export const jaLangDashboard = {
  headerSearch: {
    placeholder: '商品を検索',
    cancel: 'キャンセル',
    empty: '商品が見つかりません',
    noShop: '検索できる商品がまだありません',
  },
  adminUi: {
    podcastEnterShowTitle: '番組タイトルを入力',
    podcastMaximum: '最大',
    podcastCharacters: '文字',
    podcastShowTitleExists: 'このタイトルの番組はすでに存在します',
    podcastEditShow: '番組を編集',
    podcastNewShow: '新しい番組',
    podcastCover: 'カバー',
    podcastTitle: 'タイトル',
    podcastShowTitlePlaceholder: '番組タイトル',
    podcastCategory: 'カテゴリ',
    podcastCategoryPlaceholder: '例：True Crime',
    podcastDescription: '説明',
    podcastDescriptionPlaceholder: 'この番組の内容は…',
    podcastSubscribeButtons: '「登録」ボタン',
    podcastAddPlatform: 'プラットフォームを追加',
    podcastSave: '保存',
    podcastCreate: '作成',
    episodeOne: 'エピソード',
    episodeFew: 'エピソード',
    episodeMany: 'エピソード',
    edit: '編集',
    delete: '削除',
    addShow: '番組を追加',
    importFromRss: 'RSSからインポート',
    importFromRssFeed: 'RSSフィードからインポート',
    importFromRssHint: 'ポッドキャストのRSSリンクを貼り付けると、エピソードが自動的に新しい番組に取り込まれます。',
    import: 'インポート',
    trackWordOne: 'トラック',
    trackWordFew: 'トラック',
    trackWordMany: 'トラック',
    albumLabel: 'アルバム',
    pause: '一時停止',
    play: '再生',
    emptyTracks: 'このアルバムにはまだトラックがありません',
    untitled: '無題',
    show: '番組',
    audioFileNotAttached: '音声ファイルが添付されていません',
    paypalConnectionTitle: 'PayPalの接続方法を選択',
    paypalConnectionSubtitle: '最も便利な接続方法を選んでください',
    paypalRecommendedBadge: 'おすすめ',
    paypalPartnerTitle: 'PayPal Partner経由',
    paypalPartnerFeatureQuickConnect: '1クリックで簡単接続',
    paypalPartnerFeatureAutoTokens: 'トークンの自動更新',
    paypalPartnerFeatureMostSecure: '最も安全な方法',
    paypalPartnerFeatureNoApiKeys: 'APIキーのコピー不要',
    paypalPartnerButton: 'Partner経由で接続',
    paypalDirectTitle: '直接接続（API認証情報）',
    paypalDirectFeatureClientIdSecret: 'Client IDとSecretが必要',
    paypalDirectFeatureManualSetup: '手動設定',
    paypalDirectFeatureFullControl: 'APIを完全に制御',
    paypalDirectFeatureAdvancedUsers: '上級者向け',
    paypalDirectButton: '直接接続',
    clientIdRequired: 'Client IDは必須項目です',
    clientSecretRequired: 'Client Secretは必須項目です',
    invalidPaypalCredentials: 'PayPalの認証情報が無効です',
    connectPaypalDirectly: 'PayPalを直接接続',
    paypalConnectedSuccessfully: 'PayPalの接続が完了しました！',
    yourPaypalClientId: 'DashboardのPayPal Client ID',
    yourPaypalClientSecret: 'DashboardのPayPal Client Secret',
    chooseOperatingMode: '動作モードを選択',
    sandboxTest: 'Sandbox（テスト）',
    liveProduction: 'Live（本番）',
    whereToFindCredentials: '💡 認証情報はどこにありますか？',
    goTo: '移動先',
    createOrSelectApp: '新しいAppを作成するか、既存のものを選択',
    copyClientIdAndSecret: 'Client IDとSecretをコピー',
    cancel: 'キャンセル',
    connected: '接続済み！',
    connect: '接続',
    monobankTokenTooltip: 'Monobank Business Acquiringのトークン',
    monobankTokenPlaceholder: 'Monobankトークンを入力',
    whereToGetToken: 'トークンの取得方法は？',
    statusChangedTo: 'ステータスを変更しました',
    all: 'すべて',
    loading: '読み込み中...',
    noBookingsYet: '予約はまだありません',
    noBookingsWithStatus: 'このステータスの予約はありません',
    nightsAbbr: '泊',
    uah: 'UAH',
    oneNightDeposit: '1泊分のデポジット',
    fullPrepayment: '全額前払い',
    online: 'オンライン',
    confirm: '確認',
    complete: '完了',
    restore: '復元',
    bookingCalendarBooked: '予約済み',
    bookingCalendarBlockedManually: '手動でブロック',
    bookingCalendarAvailable: '空きあり',
    bookingCalendarNoSettings: '設定なし',
    bookingCalendarSaveItemFirst: '先にアイテムを保存してください',
    bookingCalendarLoading: '読み込み中...',
    bookingCalendarBlocked: 'ブロック済み',
    bookingCalendarSelected: '選択済み',
    bookingCalendarSelectedDates: '選択した日付',
    bookingCalendarPricePerDay: '1日あたりの価格',
    bookingCalendarOpen: '開放',
    bookingCalendarBlock: 'ブロック',
    bookingCalendarCancel: 'キャンセル',
    responseDeleted: '回答を削除しました',
    deleteAllConfirm: 'すべての回答を削除しますか？この操作は取り消せません。',
    allResponsesDeleted: 'すべての回答を削除しました',
    responseOne: '件の回答',
    responseFew: '件の回答',
    responseMany: '件の回答',
    deleteAll: 'すべて削除',
    allForms: 'すべてのフォーム',
    noResponsesYet: '回答はまだありません',
    fieldName: '名前',
    fieldPhone: '電話番号',
    fieldAddress: '住所',
    fieldComment: 'コメント',
    customFields: '追加フィールド',
    more: 'もっと見る',
    view: '表示',
    track: '追跡',
    showing: '表示中',
    of: '／',
    ordersLower: '件の注文',
    ordersEmpty: '記録はまだありません',
    ordersCountLabel: '件',
    ordersName: '名前',
    ordersPhone: '電話番号',
    ordersLoading: '読み込み中...',
    ordersComment: 'コメント',
    ordersPayment: '支払い',
    ordersPrev: '前へ',
    ordersNext: '次へ',
    revokeAccessConfirm: 'アクセスを取り消しますか？',
    accessRevoked: 'アクセスを取り消しました',
    activeGrants: '件の有効な付与',
    noActiveGrants: '有効な付与はありません',
    type: 'タイプ',
    grantedBy: '付与者',
    started: '開始',
    until: '期限',
    revoke: '取り消し',
    deleted: '削除済み',
    subscribers: '人の購読者',
    noSubscribersYet: '購読者はまだいません',
    phone: '電話番号',
    name: '名前',
    step: 'ステップ',
    done: '完了',
    stepFailedSingular: 'ステップが失敗しました',
    stepFailedPlural: 'ステップが失敗しました',
    done2: '完了しました。',
    actionFailed: '操作を実行できませんでした。',
    starterCoffeeSite: 'コーヒーショップのウェブサイトを作る',
    starterFaq: '5つの質問のFAQブロックを追加',
    starterTranslate: 'サイト全体を英語に翻訳',
    starterBrandColors: '自分のブランドに合う色を選ぶ',
    stopped: '停止しました。',
    scopeSite: 'サイト',
    scopePage: 'ページ',
    followUpAddPhoto: '写真をもう1枚追加',
    followUpAddQuestion: '質問をもう1つ追加',
    followUpAddPlan: '料金プランをもう1つ追加',
    followUpAddService: 'サービスをもう1つ追加',
    followUpAddBlock: 'ブロックをもう1つ追加',
    followUpMakeBetter: 'さらに良くする',
    followUpTweakColors: '自分のブランドに合わせて色を調整',
    followUpChangeColors: '色を変更',
    followUpTranslateEnglish: '英語に翻訳',
    undoneDeletedPrefix: '取り消しました — 削除',
    undoneOf: '／',
    undoneCreatedBlocks: '作成したブロック',
    planAnalyzing: 'リクエストを分析中',
    planCheckingSite: 'サイトの状態を確認中',
    planChoosingBlocks: 'ブロックを選択中',
    planPreparing: 'プランを準備中',
    hideDetails: '詳細を隠す',
    details: '詳細',
    emptyStateTitle: 'どんなお手伝いをしましょうか？',
    emptyStateSubtitle: 'やりたいことを入力するか、下の例を選んでください',
    undoing: '取り消し中…',
    undo: '元に戻す',
    blockSingular: 'ブロック',
    blockPlural: 'ブロック',
    usageCostTitle: 'このリクエストのコスト',
    tokens: 'トークン',
    stop: '停止',
    scopeSiteTitle: 'サイト全体への変更',
    scopePageTitle: '現在のページのみへの変更',
    customDesign: 'カスタムデザイン',
    appointmentEmbedTitle: '埋め込みURL',
    appointmentEmbedSubtitle: 'Calendlyをインラインiframeとして埋め込み',
    appointmentEmbedCaption: 'Calendly URL',
    appointmentEmbedTooltip: 'CalendlyのイベントURLを貼り付けてください（例：https://calendly.com/you/30min）',
    appointmentEmbedInvalid: '有効なCalendly URLを入力してください（例：https://calendly.com/you/30min）',
  },
  ama: {
    questions: '件の質問',
    all: 'すべて',
    unanswered: '未回答',
    answered: '回答済み',
    loading: '読み込み中...',
    noQuestions: '質問はまだありません',
    anonymous: '匿名',
    noName: '名前なし',
    yourAnswer: 'あなたの回答',
    edit: '編集',
    delete: '削除',
    cancel: 'キャンセル',
    enterAnswer: '回答を入力...',
    saveAnswer: '回答を保存',
    confirmDelete: 'この質問を削除しますか？',
    answerSaved: '回答を保存しました',
    deleted: '削除済み',
  },
  adsManager: {
    estimatedAudience: '推定オーディエンス規模',
    audienceTooLarge: 'オーディエンスが非常に広範です — 絞り込むことを検討してください。',
    audienceTooNarrow: 'オーディエンスが非常に小さいです — 広げることを検討してください。',
    audience: 'オーディエンス',
    suggestedAudience: 'おすすめのオーディエンスを使用',
    suggestedAudienceHint: '広範なターゲティング、リーチに最適',
    buildYourOwn: '自分で設定',
    buildYourOwnHint: '年齢、性別、国を設定',
    expectedViewers: '予想される広告視聴者',
    totalBudget: 'キャンペーンの総予算',
    duration: '期間',
    days: '日',
    advancedSchedule: '詳細スケジュール',
    hideAdvanced: '詳細スケジュールを隠す',
    adPreview: '広告プレビュー',
    sponsored: '広告',
    seeMore: 'もっと見る',
    learnMore: '詳細',
    yourPage: 'あなたのページ',
  },
  pinnedDock: {
    title: 'ピン留めブロック',
    label: 'ピン留め',
    expand: 'ピン留めブロックを展開',
    collapse: 'ピン留めブロックを折りたたむ',
  },
  reviewButton: {
    title: 'レビュー投稿ボタン',
    desc: 'レビューの下に、レビューを投稿できる場所へ訪問者を誘導するボタンを表示します。',
    buttonText: 'ボタンのテキスト',
    link: 'リンク',
    leaveReview: 'レビューを書く',
    googleHint: '空欄のままにするとGoogleレビューページが使用されます。',
    design: 'ボタンのデザイン',
    background: '背景',
    textColor: 'テキスト',
  },
  common: {
    you: 'あなた',
    post: '投稿',
    article: '記事',
    create: '作成',
    message: 'メッセージ',
    popular: '人気',
    emptyIntegrations: 'まず連携を追加する必要があります',
    categories: 'カテゴリ',
    edit: '編集',
    share: '共有',
    plan: 'プラン',
    sort: '並べ替え',
    addArticle: '記事を追加',
    articles: '記事',
    users: 'ユーザー',
    scans: 'スキャン',
    clicks: 'クリック',
    copy: 'コピー',
    customize: 'カスタマイズ',
    link: 'リンク',
    save: '保存',
    uploadFile: 'ファイルをアップロード',
    customImage: 'カスタム画像',
    customImageTooltip: 'カスタム画像をアップロード',
    size: 'サイズ',
    sizeTooltip: 'スライダーをドラッグしてサイズを設定',
    auto: '自動',
    rectangle: '長方形',
    custom: 'カスタム',
    clean: 'クリア',
    cleaning: 'クリア中',
    download: 'ダウンロード',
    downloading: 'ダウンロード中',
    preview: 'プレビュー',
    cover: 'カバー',
    coverTooltip: 'カバー写真をアップロード',
    title: 'タイトル',
    new: '新規',
    pro: 'Pro',
    free: '無料',
    limit: '上限',
    websites: 'ウェブサイト',
    site: 'サイト',
    apiKey: 'API Key',
    name: '名前',
    passwordChange: 'パスワード変更',
    draft: '下書き',
    page: 'ページ',
    areYouSure: 'よろしいですか？',
    drop: 'ドロップ',
    video: '動画',
    image: '画像',
    chooseFile: 'ファイルを選択',
    nothingFound: '見つかりませんでした',
    enterCorrectLink: '正しいリンクを入力してください',
    off: 'オフ',
    disconnect: '接続解除',
    connect: '接続',
    copied: 'コピーしました',
    saved: '保存しました',
    lostConnection: '接続が切れました',
    addedCategory: 'カテゴリを追加しました',
    none: 'なし',
    left: '左',
    right: '右',
    thin: '細',
    solid: '実線',
    double: '二重線',
    welcome: 'ようこそ',
    category: 'カテゴリ',
    product: '商品',
    website: 'ウェブサイト',
    items: 'アイテム',
    square: '四角',
    round: '丸',
    border: '枠線',
    shadow: '影',
    subtle: '控えめ',
    soft: 'ソフト',
    hard: 'ハード',
    block: 'ブロック',
    primary: 'メイン',
    additional: '追加',
    normal: '標準',
    bold: '太字',
    uploadVideo: '動画をアップロード',
    compact: 'コンパクト',
    card: 'カード',
    top: '上',
    center: '中央',
    bottom: '下',
    button: 'ボタン',
    addNewItem: '新しいアイテムを追加',
    blockEmptyTitle: 'まだ何もありません',
    blockEmptyText: 'このブロックにはまだアイテムがありません。追加するとページに表示されます。',
    noItemsTitle: 'アイテムがまだありません',
    noItemsText: '最初のアイテムを追加してこのブロックを埋めましょう。',
    price: '価格',
    priceCaption: '商品の価格を追加',
    oldPrice: '旧価格',
    oldPriceCaption: '旧価格には取り消し線が付きます',
    areYouSureDeleteItem: 'このアイテムを削除してもよろしいですか？',
    add: '追加',
    active: '有効',
    isActive: 'は有効です',
    isDisabled: 'は無効です',
    uploadImage: '画像をアップロード',
    design: 'デザイン',
    addAccount: 'アカウントを追加',
    hey: 'こんにちは',
    activeBackground: 'アクティブ時の背景',
    activeText: 'アクティブ時のテキスト',
    connectDomain: 'ドメインを接続',
    shortLink: '短縮リンク',
    appearanceSaved: '外観を保存しました！',
    blockAdded: 'ブロックを追加しました！',
    comingSoon: '近日公開',
    easyMoney: '簡単に収益化',
    content: 'コンテンツ',
    audience: 'オーディエンス',
    view: '表示',
    delete: '削除',
    file: 'ファイル',
    type: 'タイプ',
    from: '開始',
    to: '終了',
    fullName: '氏名',
    lastTimeUsed: '最終使用日',
    noMediaFiles: 'メディアファイルはまだありません...',
    withdraw: '引き出す',
    congrats: 'おめでとうございます！',
    makeMoneyOnline: 'オンラインで収益を得よう！',
  },
  sort: {
    title: '並べ替え',
    search: '検索',
    default: 'デフォルトの並び順',
    dateNew: '日付：新しい順',
    dateOld: '日付：古い順',
    priceLow: '価格：安い順',
    priceHigh: '価格：高い順',
    nameA: '名前：A→Z',
    nameZ: '名前：Z→A',
    popular: '人気順',
  },
  emailMenu: {
    broadcasts: '配信',
    automations: '自動化',
    templates: 'テンプレート',
    log: 'ログ',
    settings: '設定',
    noEmails: 'メールはまだありません',
    newBroadcast: '新規配信',
  },
  aiContent: {
    title: '最初のコンテンツAIを作成！',
    text: 'コンテンツを計画し、すべてのSNSに一度に公開！',
    create: 'コンテンツAIを作成',
  },
  pageDesign: {
    page: 'ページデザイン',
    image: '画像',
  },
  toolsMenu: {
    title: 'ツール',
    account: 'アカウント',
    instantPages: 'インスタントページ',
    instantPagesText: '高速読み込みの単独ページ',
    agents: 'エージェント',
    agentsText: 'プロフィールを管理するAIアシスタント',
    socialPlanner: 'ソーシャルプランナー',
    socialPlannerText: 'コンテンツのスケジュールとインスピレーション',
    emailMarketing: 'メールマーケティング',
    emailMarketingText: '連絡先リストを増やす',
    smartReply: 'Instagram Reply',
    smartReplyText: 'コメントやメッセージを自動送信',
    linkShortener: '短縮リンク',
    linkShortenerText: '長いURLを短くする',
    posts: '投稿',
    postsText: '投稿を作成・管理',
    blog: 'ブログ',
    blogText: 'ブログ記事を作成・管理',
  },
  insideMenu: {
    planner: 'プランナー',
    aiContent: 'AIコンテンツ',
    aiPosts: 'AI投稿',
    postIdeas: '投稿アイデア',
    contentPlanner: 'コンテンツプランナー',
    aiImages: 'AI画像',
    adBuilder: '広告ビルダー',
    brandProjects: 'Brand Identity',
    aiVideo: 'AI動画',
    integrations: '連携',
    products: '商品',
    orders: '注文',
    payments: '支払い',
    links: 'リンク',
    qrCodes: 'QRコード',
  },
  orders: {
    title: '注文',
    empty: '注文はまだありません',
    all: 'すべての注文',
    shop: 'ショップ',
    digital: 'デジタル商品',
    appointments: '予約',
    services: 'サービス',
    donations: '寄付',
  },
  discounts: {
    title: '割引',
    newDiscount: '+ 新しい割引',
    code: 'コード',
    titleCol: 'タイトル',
    type: 'タイプ',
    value: '値',
    status: 'ステータス',
    used: '使用回数',
    actions: '操作',
    statusAll: 'すべてのステータス',
    statusActive: '有効',
    statusExpired: '期限切れ',
    statusScheduled: '予約済み',
    statusInactive: '無効',
    searchPlaceholder: 'コードまたはタイトルで検索...',
    clearFilters: 'フィルターをクリア',
    emptyTitle: '割引はまだありません',
    emptySubtitle: '最初のプロモコードを作成して商品に割引を提供しましょう',
    createDiscount: '割引を作成',
    createTitle: '割引を作成',
    editTitle: '割引を編集',
    fieldTitle: 'タイトル',
    fieldTitlePlaceholder: '例：春のセール',
    fieldCode: 'コード',
    fieldCodePlaceholder: '例：SAVE20',
    generate: '生成',
    sectionDiscount: '割引',
    fieldTrigger: '適用方法',
    triggerCode: '割引コード',
    triggerAutomatic: '自動（コード不要）',
    triggerAutomaticHint: '条件を満たすと決済時に自動的に適用されます — コードは不要です。注文金額割引には、下に最低注文金額を設定してください。',
    automaticBadge: '自動',
    fieldType: 'タイプ',
    typePercentage: 'パーセンテージ',
    typeFixed: '固定金額',
    typeFreeShipping: '送料無料',
    fieldValue: '値',
    sectionConditions: '条件（任意）',
    appliesTo: '適用対象',
    appliesToAll: 'すべての商品',
    appliesToShop: 'ショップ',
    appliesToDigital: 'デジタル',
    appliesToCourses: 'コース',
    appliesToServices: 'サービス',
    appliesToEvents: 'イベント',
    minOrderAmount: '最低注文金額（$）',
    maxDiscountAmount: '最大割引額（$） — 0 = 上限なし',
    minItemCount: '注文の最低アイテム数 — 0 = 条件なし',
    specificProducts: '特定の商品 — 空欄 = すべて対象',
    specificProductsPlaceholder: '商品を検索...',
    noProductsFound: '商品が見つかりません',
    sectionLimits: '上限',
    usageLimit: '総使用回数の上限 — 0 = 無制限',
    usageLimitPerUser: '顧客ごとの上限 — 0 = 無制限',
    sectionSchedule: 'スケジュール',
    startDate: '開始日 — 空欄 = 今すぐ開始',
    endDate: '終了日 — 空欄 = 無期限',
    active: '有効',
    cancel: 'キャンセル',
    save: '割引を保存',
    createdSuccess: '割引を作成しました',
    updatedSuccess: '割引を更新しました',
    deletedSuccess: '割引を削除しました',
    loadError: '割引の読み込みに失敗しました',
    saveError: '割引の保存に失敗しました',
    deleteError: '割引の削除に失敗しました',
  },
  donation: {
    chooseSmiles: '絵文字を選択',
    item: 'アイテム',
    itemTitle: '寄付アイテムのタイトル',
    price: '価格',
    thanksMessagePlaceholder: '本当にありがとうございます',
    thanksMessage: 'お礼メッセージ',
    thanksMessageCaption: 'お礼メッセージは寄付後にファンに表示されます',
    addDonation: '寄付を追加',
    addAmount: '+ 金額を追加',
    buttonTitle: 'ボタンのタイトル',
    buttonTitleCaption: '寄付ボタンのタイトル',
    acceptDonations: '寄付を受け付ける',
    donationsType: '寄付',
    tips: 'チップ',
    type: 'タイプ',
    addAnotherAmount: '+ 別の金額を追加',
  },
  blog: {
    empty: 'ブログはまだありません',
  },
  apps: {
    empty: 'アプリはまだありません',
  },
  payments: {
    title: '支払い',
    text: '取引はまだありません',
    single: '単発の支払い',
    subscriptions: 'サブスクリプション',
    wallet: 'ウォレット',
    connectPromo: 'StripeまたはPayPalアカウントをUniLinkページに接続して、すべての支払いをウォレットで受け取りましょう。',
    connectSystem: '決済システムを接続',
    manageCards: 'カードを管理',
    addNewCard: '新しいカードを追加',
    editCard: 'カード情報を編集',
    addCard: 'カード情報を追加',
    cardHolder: 'カード名義人',
    cardHolderNecessary: '必須項目です',
    withdrawalSuccess: '引き出しの申請が完了しました！',
    withdrawalError: '問題が発生しました。後でもう一度お試しください。',
    change: '変更',
  },
  store: {
    emptyTitle: '商品がまだありません',
    emptyText: '最初の商品を追加して始めましょう',
    emptyButton: '商品を追加',
    createFirstProduct: '最初の商品を作成',
    startAdding: 'お気に入りの商品、デジタル商品、またはサービスを追加して始めましょう。あなたが提供するすべてを販売・宣伝できるスペースです。',
    activate: 'ストアを有効化',
    empty: '商品がまだありません',
    products: '商品',
    addProducts: '商品を追加',
    whatDoYouWant: '何を販売しますか？',
    externalProduct: '外部商品URL',
    createOwnProduct: '自分の商品を作成',
    shop: 'ショップ',
    shopText: '物理商品とデジタル商品を販売',
    digital: 'デジタル商品',
    digitalText: 'デジタルダウンロードを販売',
    course: 'コースまたはチュートリアル',
    courseText: 'コースやチュートリアルをウェブサイトに追加',
    service: 'サービス',
    serviceText: '顧客向けのサービスを追加',
    appointment: '予約',
    appointmentText: '訪問者がカレンダーで時間を予約できるようにする',
    event: 'イベントまたはチケット',
    eventText: 'イベントを作成してオーディエンスを招待',
    tips: 'チップ',
    tipsText: 'お気に入りのクリエイターにチップを贈る',
    donation: '寄付',
    donationText: '寄付する',
    membership: 'メンバーシップ',
    membershipText: 'メンバーシップをウェブサイトに追加',
    links: '外部リンク',
    linksText: '任意のウェブサイトへの外部リンクを追加',
    coupon: 'クーポン',
    couponText: 'ウェブサイト用のクーポンを追加',
    singleProduct: '単一商品',
    singleProductText: 'シンプルな決済で単一商品を販売',
    booking: '予約',
    bookingText: '訪問者がスペースや物件を予約できるようにする',
    rental: 'レンタル',
    rentalText: '空き状況と価格を設定してレンタルアイテムを掲載',
    add: '追加',
    manageStore: 'ストアを管理',
    displayLast: '最新の商品を表示',
  },
  products: {
    info: '情報',
    uploadCover: 'カバー写真をアップロードし、タイトルと説明を入力してください',
    thumbnail: 'サムネイル',
    thumbnailTab: {
      intro: '商品を開く前に、ショップで表示されるカードです。独自の価格や在庫は持ちません — それらは Details にあり、ここではカードに何を表示するかだけを選びます。',
      cardImage: 'カード画像',
      crop: 'トリミング',
      cropSquare: '正方形',
      cropPortrait: '縦長',
      cropWide: '横長',
      imageHint: '空欄にすると Details の最初の画像が使われます。1200×1200 以上がきれいに表示されます。',
      cardCopy: 'カードの文言',
      cardTitle: 'カードのタイトル',
      sameAsTitle: '商品タイトルと同じ',
      shortDescription: '短い説明',
      shortDescriptionHint: '思わずタップしたくなる一行。長い説明は Details にあります。',
      buttonLabel: 'ボタンのラベル',
      showOnCard: 'カードに表示',
      showOnCardNote: '値は Details のもの — ここでは表示の有無だけ',
      editInDetails: 'Details で編集 ↗',
      rowPrice: '価格',
      rowOldPrice: '元の価格と割引',
      rowAvailability: '在庫状況',
      rowLabel: 'ラベル',
      inStock: '在庫あり',
      notShown: '非表示',
    },
    thumbnailError: 'サムネイルを追加してください',
    title: 'タイトル',
    titleTooltip: '商品名を入力',
    shortDescription: '短い説明',
    shortDescriptionTooltip: '商品の短い説明を入力',
    description: '説明',
    descriptionTooltip: '商品の説明を入力',
    descriptionTooltipExtra: '商品の特徴、種類、色、サイズなどの任意の説明',
    price: '価格',
    priceTooltip: '商品の価格を入力',
    oldPrice: '旧価格',
    oldPriceTooltip: '旧価格には取り消し線が付きます',
    category: 'カテゴリ',
    categoryTooltip: '商品のカテゴリを選択',
    image: '画像',
    imageTooltip: '商品の画像をアップロード',
    groups: 'グループ',
    rate: '料金',
    rateTooltip: '商品の料金を入力',
    buttonTitle: 'ボタンのタイトル',
    buttonTitleTooltip: '商品ボタンのタイトルを入力',
    features: '特徴',
    featuresTooltip: 'ショーケースカードレイアウトに表示されるメリットのチェックリスト',
    featurePlaceholder: 'メリット',
    addFeature: '特徴を追加',
    limitQuantity: '数量を制限',
    itemsLeft: '残り在庫',
    itemsLeftTooltip: '商品の在庫数',
    trackStock: '在庫を追跡',
    stockQuantity: '在庫数',
    stockQuantityTooltip: '現在の在庫数。支払い済みの注文ごとに自動的に減少し、0になると商品を購入できなくなります。',
    lowStockThreshold: '在庫僅少アラート',
    lowStockThresholdTooltip: '在庫がこの数以下になったら通知を受け取ります。',
    maxOrderQuantity: '最大注文数量',
    maxOrderQuantityTooltip: '顧客が1回の注文で購入できる最大数量。制限なしの場合は空欄にしてください。',
    minOrderQuantity: '最小注文数量',
    minOrderQuantityTooltip: '顧客が1回の注文で購入しなければならない最小数量。制限なしの場合は空欄にしてください。',
    pendingReviews: {
      title: '保留中のレビュー',
      subtitle: '公開前に購入者のレビューを承認または非表示にします',
      empty: '承認待ちのレビューはありません。',
      approve: '承認',
      hide: '非表示',
    },
    attachments: '添付ファイル',
    addAttachments: '商品に添付ファイルを追加',
    addNewAttachment: '新しいアイテムを追加',
    file: 'ファイル',
    uploadFile: 'ファイルをアップロード',
    uploadCoverTitle: 'カバーをアップロード',
    optionalDescription: '商品の特徴、種類、色、サイズなどの任意の説明',
    customReviews: 'カスタムレビュー',
    addCustomReviews: '商品にレビューを追加',
    name: '名前',
    nameTooltip: '顧客の名前を入力',
    comment: 'コメント',
    commentTooltip: '顧客のコメントを入力',
    rateTooltipCustomer: '顧客の評価',
    imageTooltipCustomer: '顧客の画像をアップロード',
    displayPriceOnPreview: 'プレビューに価格を表示',
    displayDetailsOnPreview: 'プレビューに詳細を表示',
    postOnSocials: 'SNSに投稿',
    sendAnEmail: 'メールを送信',
    highlights: 'ハイライト',
    listProductSetup: '商品を掲載してストアブロックを設定',
    whereToSell: 'この商品をどこで販売しますか？',
    youHaveProducts: '{count}件の商品があります',
    shareThisProduct: 'この商品を共有',
    shareAProduct: '商品を共有',
    monetizeWays: 'Unilinkで収益化するさまざまな方法',
    addProductToProfile: 'プロフィールに{title}を追加',
    productPage: '商品ページ',
    setUpPayments: '支払いを設定',
    connectPaymentMethods: '支払い方法を接続して、Unilinkで収益を得始めましょう',
    addPaymentMethod: '{type}の支払い方法を追加して、フォロワーからの支払いを受け取りましょう',
    withdrawAttempt: 'これは債権回収のための試みであり、いかなる情報もその目的で使用されます。',
    withdrawSuccess: '引き出しの申請が完了しました！',
    yourVisitorsPay: '訪問者はまず支払いを行い、その後{method}に誘導されます',
    emailAddress: 'メールアドレス',
    calendlyLink: 'Calendlyリンク',
  },
  posts: {
    posts: '投稿',
    title: '最初の投稿を作成',
    description: '投稿では、簡単で視覚的な形式でチャット自動化を作成できます。目標に基づいておすすめの自動化を試してみましょう',
    activate: '投稿を有効化',
    managePosts: '投稿を管理',
    postsTab: '投稿タブ',
    displayLast: '最新の投稿を表示',
    tabNavigation: 'タブナビゲーション設定',
    createFirstPost: '最初のソーシャル投稿を作成！',
    autoPostsText: 'コンテンツを計画し、すべてのSNSに一度に公開！',
    createPost: '投稿を作成',
  },
  messages: {
    title: 'メッセージ',
    empty: 'メッセージはありません',
    addText: 'ヘッダーブロックにメッセージボタンを追加すると、ユーザーが簡単にメッセージを送れるようになります。',
    addButton: 'メッセージボタンを追加',
  },
  smartReply: {
    title: 'Instagram Reply',
    clicks: 'クリック',
    createTitle: '最初のInstagram Replyを作成！',
    text: 'Instagram自動DMを使って、オーディエンスに自動でリンクを共有しましょう！',
    createButton: '自動DMを作成',
    subtitleComment: 'コメントへの返信としてリンク付き自動DMを送信',
    subtitleDm: 'メッセージやStoryへの返信として自動DMを送信',
    ready: '準備完了',
    edit: '編集',
    stepContentTitle: 'IGコンテンツ',
    stepContentSub: '投稿またはReelを選択',
    storiesAndDmsSub: 'Storyへの返信や受信メッセージがあったときに自動DM',
    stepTriggerTitle: 'トリガー',
    stepTriggerSub: 'コメント内のキーワード',
    stepTriggerSubDm: 'メッセージ内のキーワード',
    stepDmTitle: 'DM',
    stepDmSub: '自動送信されるメッセージ',
    dmSummary: 'メッセージ設定済み',
    activatesNow: '自動返信はすぐに有効になります',
    saveAutomation: '自動返信を保存',
    savedToast: '自動返信を作成しました',
    linkLabel: 'リンク先を選択',
    selectDestination: 'リンク、商品、記事を選択',
    change: '変更',
    choose: '選択',
    remove: '削除',
    optional: '任意',
    buttonText: 'ボタンのテキスト',
    addLink: 'リンクを追加',
    attachLink: 'リンクを添付',
    noLinks: 'リンクはまだありません — まずLink in Bioにリンクを追加してください。',
    tabLinks: 'リンク',
    tabProducts: '商品',
    noProducts: '商品はまだありません — まずショップに商品を作成してください。',
    tabArticles: '記事',
    noArticles: '記事はまだありません — まず記事を作成してください。',
    choosePost: '投稿またはReelを選択',
    searchPosts: '投稿を検索',
    loadingPosts: '投稿を読み込み中…',
    done: '完了',
    oneSelected: '1件の投稿を選択',
    postSelected: '投稿を選択済み',
    noPosts: '投稿はまだありません — Instagramに投稿またはReelを公開してください。',
    postsError: '投稿を読み込めませんでした。もう一度お試しください。',
    reauthTitle: '一部のDMが配信されない可能性があります。',
    reauthText: 'Instagramでアカウントの再認証が必要です。',
    reconnect: '再接続',
    statActive: '有効な自動化',
    statDmSent: '送信したDM · 30日間',
    statClicks: 'リンククリック数',
    activeReplies: '有効な自動返信',
    filterAll: 'すべて',
    filterActive: '有効',
    filterOff: 'オフ',
  },
  virtualBackgrounds: {
    title: 'バーチャル背景',
    canvasSize: 'キャンバスサイズ',
    fmtCall: 'Zoom · Teams · Meet',
    fmtStories: 'Stories · Reels',
    fmtSquare: '正方形',
    fmtClassic: 'クラシック',
    background: '背景',
    bg_color: '色',
    bg_gradient: 'グラデーション',
    bg_photo: '写真',
    bg_pattern: 'パターン',
    from: '開始',
    to: '終了',
    angle: '角度',
    ink: 'インク',
    paper: '用紙',
    blur: 'ぼかし',
    darken: '暗くする',
    presets: 'プリセット',
    uploadImage: '画像をアップロード',
    removeImage: '画像を削除',
    replace: '置き換え',
    remove: '削除',
    photoPlaceholder: 'パネルから画像をアップロード',
    overlay: 'オーバーレイ',
    showName: '名前を表示',
    namePlaceholder: 'あなたの名前',
    subtitlePlaceholder: 'サブタイトル / ハンドル',
    typeface: '書体',
    textColour: 'テキストの色',
    nameSizeLabel: '名前のサイズ',
    position: '位置',
    showQr: 'QRコードを表示',
    qrPlaceholder: 'https://link',
    style: 'スタイル',
    qrCard: 'カード',
    qrBrand: 'ブランド',
    qrLight: 'ライト',
    qrSolid: 'ソリッド',
    qrSizeLabel: 'QRサイズ',
    logo: 'ロゴ / アバター',
    uploadLogo: 'ロゴをアップロード（PNG）',
    logoSizeLabel: 'ロゴのサイズ',
    finishing: '仕上げ',
    vignette: 'ビネット',
    vignetteHint: '奥行きを出すための柔らかい暗い縁',
    shuffle: 'シャッフル',
    reset: 'リセット',
    dragHint: '名前、QR、ロゴをキャンバス上でドラッグして位置を調整',
    preparing: '準備中…',
    download: 'ダウンロード',
    sizeHint: '1920 × 1080のJPGとして保存されます',
  },
  emailSignatures: {
    signatures: '署名',
    signature: '署名',
    signatureName: 'ラベル',
    signatureNamePlaceholder: '仕事用、プライベート…',
    newSignature: '新しい署名',
    createSignature: '署名を作成',
    emptyText: '署名を作成すると、送信するすべてのメールがあなたのページへリンクします。',
    default: '既定',
    isDefault: '既定の署名',
    makeDefault: '既定にする',
    duplicate: '複製',
    delete: '削除',
    save: '保存',
    saving: '保存中…',
    saved: '署名を保存しました',
    fillFromCard: '名刺から入力',
    noCard: '名刺がまだありません。項目を手動で入力してください',
    extras: '追加要素',
    socialLinks: 'SNSリンク',
    logo: '会社ロゴ',
    upload: 'アップロード',
    uploading: 'アップロード中…',
    uploadFailed: 'アップロードに失敗しました',
    imageTooLarge: '画像は{size}MB未満にしてください',
    remove: '削除',
    ctaText: 'ボタンのテキスト',
    ctaTextPlaceholder: '通話を予約',
    ctaUrl: 'ボタンのリンク',
    banner: 'バナー',
    disclaimer: '免責事項',
    disclaimerPlaceholder: '守秘義務の注記、会社情報…',
    tracking: 'トラッキング',
    copyLink: 'リンクをコピー',
    linkCopied: 'リンクをコピーしました',
    renewLink: 'リンクを更新',
    renewing: '更新中…',
    linkRenewed: 'リンクを更新しました',
    renewHint: '更新すると新しいリンクが発行されます。すでに送信済みの署名は機能しなくなりますが、下のカウンターは維持されます。',
    statClicks: 'リンクのクリック',
    statQrScans: 'QRスキャン',
    statCtaClicks: 'ボタンのクリック',
    title: 'メール署名',
    details: '詳細',
    name: '名前',
    jobTitle: '役職',
    company: '会社',
    email: 'メール',
    phone: '電話番号',
    website: 'ウェブサイト',
    style: 'スタイル',
    styleModern: 'モダン',
    styleClassic: 'クラシック',
    styleMinimal: 'ミニマル',
    styleBold: 'ボールド',
    styleCard: 'カード',
    accent: 'アクセントカラー',
    showAvatar: '写真を表示',
    showQr: 'QRコードを表示',
    preview: 'プレビュー',
    copySignature: '署名をコピー',
    copyHtml: 'HTMLをコピー',
    copied: '署名をコピーしました',
    copiedHtml: 'HTMLをコピーしました',
    instructions: {
      gmail: 'Gmail：設定 → すべての設定を表示 → 全般 → 署名 → 新規作成し、貼り付け（Ctrl/Cmd+V）して変更を保存します。',
      outlook: 'Outlook：ファイル → オプション → メール → 署名 → 新規作成し、貼り付けます。新しいOutlook / Web版：設定 → メール → 作成と返信 → 署名ボックスに貼り付けます。',
      apple: 'Apple Mail：メール → 設定 → 署名 → 署名を追加して貼り付けます。「常に規定のメッセージフォントに合わせる」のチェックを外してください。',
    },
  },
  businessCards: {
    title: '名刺',
    emptyTitle: 'デジタル名刺を作成',
    emptySubtitle: '連絡先情報を追加すれば、誰でもワンタップでスマホに保存できます。QRコードや.vcfファイルで共有しましょう。',
    createButton: '名刺を作成',
    sectionButton: '連絡先保存ボタン',
    sectionButtonSubtitle: '「連絡先を保存」ボタンの見た目と、プロフィール上での表示位置。',
    showButton: 'プロフィールに表示',
    showButtonSubtitle: '公開ページに「連絡先を保存」ボタンを表示します。',
    placement: 'ボタンの配置',
    placementSubtitle: 'ボタンを表示する場所を選択します。',
    showInHeader: 'ヘッダーに表示',
    placementHeader: 'プロフィールヘッダー',
    placementHeaderHint: '名前とアバターのすぐ下に表示されます。',
    placementContact: '連絡先セクション',
    placementContactHint: '連絡先ポップアップ内に表示されます。',
    placementBottom: 'フローティングボタン',
    placementBottomHint: '訪問者がスクロールしてもページ下部に固定されます。',
    none: 'なし',
    buttonLabel: 'ボタンのラベル',
    buttonLabelSubtitle: 'ボタンに表示するテキスト。',
    saveContact: '連絡先を保存',
    sectionDetails: '連絡先情報',
    sectionDetailsSubtitle: 'これらの情報は連絡先カードに保存されます。',
    leadCapture: '連絡先を収集',
    leadCaptureSubtitle: '名刺を受け取った人が連絡先を返せるようにします — そのままオーディエンスに追加されます。',
    leadCaptureToggle: '「連絡先を共有」を有効化',
    leadCaptureToggleHint: '公開カードに連絡先フォームを表示します。',
    leadTag: '新しいリードにタグ付け',
    leadTagSubtitle: '収集した連絡先はすべてこのタグ（例：イベントやキャンペーン名）が付けられます。',
    leadTagPlaceholder: '例：Conference 2026',
    delete: '名刺を削除',
    previewHint: '訪問者から見た名刺の表示です。',
    share: '共有 & QR',
    shareSubtitle: 'コードをスキャンするか、リンクを共有してプロフィールを開きます。',
    download: '.vcfをダウンロード',
    copyLink: 'リンクをコピー',
    copied: 'リンクをコピーしました！',
    renewLink: 'リンクを更新',
    renewing: '更新中…',
    renewConfirm: 'カードのリンクを更新しますか？現在のQRコードと共有リンクは使えなくなります。',
    linkRenewed: 'カードのリンクを更新しました',
    scans: '{count}回のスキャン',
    digitalCard: 'デジタルカード',
    physicalCard: '実物のカード',
    cardStyle: 'カードのスタイル',
    cardStyleSubtitle: '表示名を設定し、背景色を選んで、カードをウォレットに追加します。',
    displayName: '表示名',
    backgroundColour: '背景色',
    addAppleWallet: 'Apple Walletに追加',
    addGoogleWallet: 'Google Walletに追加',
    nameLabel: '名前',
    urlLabel: 'URL',
    walletScanTitle: 'QRコードをスキャンしてウォレットに保存',
    walletScanSubtitle: 'スマホのデジタルウォレットに保存されます。',
    walletUseLink: 'またはこのリンクをご利用ください',
    walletComingSoonTitle: 'もうすぐです',
    walletComingSoon: 'ウォレットパスは近日公開予定です。',
    done: '完了',
    physicalTitle: '実物のカードを注文',
    physicalSubtitle: 'NFC名刺は近日公開予定です。',
  },
  shortLinks: {
    title: '短縮リンク',
    addLink: 'リンクを追加',
    name: '名前',
    slug: 'スラッグ',
    slugTooltip: '編集ボタンをクリックするとスラッグを変更できます',
    destinationUrl: 'リンク先URL',
    metadata: 'メタデータ',
    utmTags: 'UTMタグ',
    customizeMetadata: 'リンクのメタデータをカスタマイズ',
    metaTitle: 'タイトル',
    metaDescription: '説明',
    favicon: 'ファビコン',
    imagePreview: '画像プレビュー',
    addUtm: 'リンクにUTMタグを追加（任意）',
    utmCampaign: 'UTM Campaign',
    utmMedium: 'UTM Medium',
    utmSource: 'UTM Source',
    utmTerm: 'UTM Term',
    utmContent: 'UTM Content',
    utmId: 'UTM Id',
    utmPlacement: 'UTM Placement',
    utmCreative: 'UTM Creative',
    pasteLink: '長いリンクをここに貼り付け',
    shorten: 'リンクを短縮',
    edit: 'アイテムの詳細を編集',
  },
  audience: {
    title: 'オーディエンス',
    total: '合計',
    totalMembers: 'オーディエンスの総数',
    totalContacts: '連絡先の合計',
    forms: 'フォーム',
    subscribers: '購読者',
    customers: '顧客',
    noAudienceMembers: '連絡先はありません',
    emptyAudienceMembers: 'ボタンをクリックして新しい連絡先を追加',
    addAudienceMember: '連絡先を追加',
    noSubscribers: '購読者はいません',
    emptySubscribers: 'Link in Bioにブロックを追加して新しい購読者を集めましょう',
    addDataCollect: 'データ収集ブロックを追加',
    noResponses: '回答はありません',
    emptyResponses: 'Link in Bioにブロックを追加して新しい回答を集めましょう',
    addFormBlock: 'フォームブロックを追加',
    noCustomers: '顧客はいません',
    emptyCustomers: 'Link in Bioに商品を追加して新しい顧客を集めましょう',
    addProduct: '商品を追加',
    addContactModal: {
      title: '新しい連絡先を追加',
      name: '名前',
      nameTooltip: '連絡先の名前を入力',
      email: 'メール',
      emailTooltip: '連絡先のメールアドレスを入力',
      phone: '電話番号',
      phoneTooltip: '連絡先の電話番号を入力',
      telegram: 'Telegram',
      telegramTooltip: '連絡先のTelegramユーザー名またはURLを入力',
      whatsapp: 'WhatsApp',
      whatsappTooltip: '連絡先のWhatsApp番号を入力',
      instagram: 'Instagram',
      instagramTooltip: '連絡先のInstagramユーザー名またはURLを入力',
      messenger: 'Messenger',
      messengerTooltip: '連絡先のMessengerユーザー名またはURLを入力',
      viber: 'Viber',
      viberTooltip: '連絡先のViber番号を入力',
      address: '住所',
      addressTooltip: '連絡先の住所を入力',
      add: '追加',
    },
    search: {
      search: '検索',
      error: '検索フィールドに無効な文字が入力されました',
      notFound: '結果が見つかりません',
    },
  },
  auth: {
    logIn: 'ログイン',
    logInWith: '次でログイン',
    signIn: 'サインイン',
    signInWith: '次で登録',
    email: 'メール',
    password: 'パスワード',
    notHaveAccount: 'アカウントをお持ちでないですか？',
    createAccount: '新しいアカウントを作成',
    createYourAccount: 'アカウントを作成',
    signUp: '登録',
    haveAccount: 'すでにアカウントをお持ちの場合',
    or: 'または',
    reset: 'リセット',
    resetPassword: 'パスワードをリセット',
    resetTitle: '復旧リンクをメールに送信しました',
    goToHome: 'ホームページへ移動',
    byClicking: 'クリックすることで',
    youAreAgree: 'UniLinkの以下に同意したことになります',
    terms: '利用規約',
    andConfirm: 'および当社の',
    usagePolicy: '利用ポリシー',
    signInGoogle: 'Googleでサインイン',
    forgotPassword: 'パスワードをお忘れですか？',
  },
  menu: {
    moreApps: 'その他のアプリ',
    account: 'アカウント',
    more: 'その他',
    storyWidget: 'ストーリーを埋め込む',
    integrations: '連携',
    socialAccounts: 'SNSアカウント',
    aiContent: 'AIコンテンツ',
    aiPosts: 'AI投稿',
    postIdeas: '投稿アイデア',
    contentPlanner: 'コンテンツプランナー',
    aiImages: 'AI画像',
    adBuilder: '広告ビルダー',
    aiVideo: 'AI動画',
    planner: 'プランナー',
    customers: '顧客',
    subscribers: '購読者',
    forms: 'フォーム',
    allAudience: 'すべてのオーディエンス',
    payments: '支払い',
    orders: '注文',
    products: '商品',
    events: 'イベント',
    appointments: '予約',
    discounts: '割引',
    affiliates: 'アフィリエイト',
    instantPages: 'インスタントページ',
    openInNewTab: '新しいタブで開く',
    linkInBio: 'Link in Bio',
    linkInBioApps: 'Link in Bio',
    website: 'ウェブサイト',
    store: 'ストア',
    audience: 'オーディエンス',
    emailMarketing: 'メールマーケティング',
    postPlaner: '投稿プランナー',
    posts: '投稿',
    agents: 'エージェント',
    community: 'コミュニティ',
    profileHealth: 'プロフィールの健全性',
    socialPlanner: 'ソーシャルプランナー',
    shortLinks: '短縮リンク',
    businessCards: '名刺',
    emailSignatures: 'メール署名',
    virtualBackgrounds: 'バーチャル背景',
    adsCampaigns: '広告マネージャー',
    views: '表示回数',
    clicks: 'クリック数',
    allWebsites: 'すべてのウェブサイト',
    createNewAccount: '新しいアカウントを作成',
    createNewWebsite: '新しいプロフィールを作成',
    tools: 'ツール',
    borderGenerator: '枠線ジェネレーター',
    yourPlan: '現在のプラン：',
    upgrade: 'アップグレード',
    accountSettings: 'アカウント設定',
    manageWebsites: 'プロフィールを管理',
    updates: 'アップデート',
    autoUpdate: '自動更新',
    logOut: 'ログアウト',
    myPages: 'マイページ',
    design: 'デザイン',
    heading: '見出し',
    analytics: 'アナリティクス',
    settings: '設定',
    open: '開く',
    language: '言語',
    siteLanguage: '公開サイトの言語',
    dashboardLanguage: 'ダッシュボードの言語',
    movePage: 'ページを移動',
    editBlock: 'ブロックを編集',
    renameBlock: 'ブロック名を変更',
    rename: '名前を変更',
    deleteBlock: 'ブロックを削除',
    archiveBlock: 'ブロックをアーカイブ',
    archive: 'アーカイブ',
    scheduleBlock: 'ブロックをスケジュール',
    copyBlock: 'ブロックをコピー',
    dublicateBlock: 'ブロックを複製',
    content: 'コンテンツ',
    preview: 'プレビュー',
    thumbnail: 'サムネイル',
    copy: 'コピー',
    moveBlock: 'ブロックを移動',
    move: '移動',
    edit: '編集',
    delete: '削除',
    schedule: 'スケジュール',
    dublicate: '複製',
    smartReply: 'Instagram Reply',
    marketing: 'マーケティング',
    selectBlocks: 'ブロックを選択',
    selectAll: 'すべて選択',
    cancelSelection: 'キャンセル',
    blocksSelected: '件を選択中',
    moveToPage: 'ページへ移動',
    newPage: '新しいページ',
    openPage: 'ページを開く',
    pageSettings: 'ページ設定',
    deletePage: 'ページを削除',
    appInBio: 'App in Bio',
    blog: 'ブログ',
    buildFromReference: '参考から作成',
    publish: '公開',
    creatorHub: 'クリエイターハブ',
    qrCodes: 'QRコード',
    apps: 'アプリ',
    automations: '自動化',
    messages: '受信トレイ',
    form: 'フォームを埋め込む',
    embedTools: '埋め込みツール',
  },
  modal: {
    addInstagram: 'Instagramを追加',
    addYourInstagram: 'Instagramアカウントを追加',
    cropYourAvatar: 'アバターを切り抜く',
    removeSite: 'サイトを削除してもよろしいですか？',
    areYouSure: '本当に次を実行しますか：',
    areYouSureDelete: 'このセクションを削除してもよろしいですか？',
    areYouSureArchive: 'このブロックをアーカイブしてもよろしいですか？',
    areYouSurePermanentDelete: 'このブロックを完全に削除してもよろしいですか？この操作は取り消せません。',
    remove: '削除',
    site: 'サイト',
    removeAccountText: 'アカウントを削除',
    moveBlock: 'ブロックを別のページに移動',
    moveBlockText: 'ブロックが別のページの最下部に移動します。移動後、新しいページでブロックを並べ替えられます',
    profileTitle: 'プロフィール画像を変更',
    profileText: 'デバイスから画像やGIFを選択してください。',
    profileAvatar: 'プロフィールアバター',
    addProfilePicture: 'プロフィール画像を追加',
    storiesTitle: 'ストーリー',
    storiesText: '日常の瞬間をシェアしましょう。',
    thoughtsTitle: 'つぶやき',
    thoughtsText: 'あなたの考えをシェアしましょう。',
    accountPageDescription: 'こちらはアカウントページです。ページの見た目をカスタマイズしたり、さまざまな機能ブロックを追加したりできます。',
  },
  modalSubscribe: {
    plan: 'プラン',
    usdMonth: 'USD/月',
    sites: 'サイト',
    sitesMuch: 'サイト',
    notification: '通知',
    noNotification: '通知はまだありません',
    inCategory: '次のカテゴリにはアイテムがありません：',
    categoryYet: 'カテゴリはまだありません。',
    externalPixels: '外部ピクセル',
    parameters: 'パラメータ',
    analyticsReports: 'アナリティクスとレポート',
    noUniLinkLogo: 'UniLinkロゴなし',
    inProfile: 'プロフィール内',
    verifiedBadge: '認証バッジ',
    your: 'あなたの',
    customDomain: 'カスタムドメイン',
    emailMarketing: 'メールマーケティング',
    liveSupport: 'ライブサポート',
    dataSecured: 'データはPCI DSS基準に準拠して保護されています',
    thankYou: 'ご関心をお寄せいただきありがとうございます。近日中にご連絡いたします。',
    socialMediaScheduler: 'SNSスケジューラー',
    featureRequest: '機能リクエスト',
    markAllRead: 'すべて既読にする',
    currentPlan: '現在のプラン',
    features: '機能',
  },
  buttons: {
    upgrade: 'プランをアップグレード',
    buyProPlan: 'Proプランを購入',
    continue: '続ける',
    skip: 'スキップ',
    cancel: 'キャンセル',
    confirm: '確認',
    back: '戻る',
    save: '保存',
    add: '追加',
    added: '追加済み',
    done: '完了',
    ok: 'OK',
    edit: '編集',
    delete: '削除',
    remove: '削除',
    setAsDefault: 'デフォルトに設定',
    subscribeNow: '今すぐ登録',
    yes: 'はい',
    preview: 'プレビュー',
    generate: '生成',
    changePassword: 'パスワードを変更',
    deleteAccount: 'アカウントを削除',
    removeAccount: 'アカウントを削除',
    deleteProfile: 'プロフィールを削除',
    addBlock: 'ブロックを追加',
    copyLink: 'リンクをコピー',
    active: '有効',
    update: '更新',
    updatePro: 'プランをアップグレード',
    prev: '前へ',
    next: '次へ',
    uploadImage: '画像をアップロード',
    uploadVideo: '動画をアップロード',
    loadMore: 'もっと読み込む',
    uploadProductImage: '商品画像をアップロード',
    claim: '受け取る',
    removeSite: 'サイトを削除',
    move: '移動',
    addButton: 'ボタンを追加',
    actionButton: 'アクションボタン',
    directMessage: 'ダイレクトメッセージ',
    subscribe: '登録',
    button: 'ボタン',
    generateWithAI: 'AIで生成',
    cta: 'CTA',
    cart: 'カート',
    direct: 'ダイレクト',
    follow: 'フォロー',
    addNewItem: '新しいアイテムを追加',
  },
  support: {
    liveSupport: 'ライブサポート',
    response: '営業時間内（午前8時〜午後10時 GMT+3）は通常1分以内に返信します',
    founder: 'Denys Bilozor',
    ceo: 'UniLink創業者兼CEO',
  },
  wizard: {
    createNewProfile: '新しいプロフィールを作成',
    createProfile: 'プロフィールを作成',
    continue: '続ける',
    tellUs: 'あなたについて教えてください',
    addSocialLinks: 'すべてのSNSを追加すると、データベースに表示されます',
    addMoreLinks: 'さらにリンクを追加',
    addLink: 'リンクを追加',
    selectCategory: 'あなたを最もよく表すカテゴリを1つ選択してください：',
    chooseTemplate: 'テンプレートを選択',
    skip: 'スキップ',
    step: 'ステップ',
    of: '／',
    yourName: 'あなたの名前',
    search: '検索',
    blog: 'ブログ',
    creator: 'クリエイター',
    music: '音楽',
    events: 'イベント',
    esoteric: 'エソテリック',
    fashion: 'ファッション',
    influencer: 'インフルエンサー',
    food: 'フード',
    smallBusiness: 'スモールビジネス',
    marketing: 'マーケティング',
    education: '教育',
    socialMedia: 'ソーシャルメディア',
    coaching: 'コーチング',
    ecommerce: 'Eコマース',
    healthAndFitness: '健康とフィットネス',
    beautyWellness: '美容とウェルネス',
  },
  billing: {
    back: '戻る',
    findPlan: 'あなたに合ったプランを見つけましょう',
    changeAnytime: 'いつでも変更できます。',
    subtitle: 'いつでもアップグレード、ダウングレード、キャンセルできます。',
    currentPlan: '現在のプラン',
    mostPopular: '最も人気',
    upgradeTo: '{plan}にアップグレード',
    includes: '含まれるもの：',
    everythingIn: '{plan}のすべてに加えて：',
    secure: '支払いはPCI DSS基準に準拠して保護されています。',
  },
  field: {
    fullName: '氏名',
    username: 'ユーザー名',
    addValue: '値を追加',
    newValue: '新しい値',
    placeholderDefault: 'テキスト、数字、記号など',
    addInstagramUsername: 'Instagramのユーザー名を追加',
    nameDefault: 'Jhon',
    enterYourLink: 'リンクを入力',
    searchImage: '画像を検索',
    pasteLink: 'リンクを貼り付け',
    pasteLinkTip: '任意のWebページへのリンクを追加',
    searchGIFs: 'GIFを検索',
    searchIcons: 'アイコンを検索',
    searchVideo: '動画を検索',
    search: '検索',
    insertURL: 'URLを挿入',
    writeYourDescription: '説明を入力してください',
    headerCTAbutton: 'ヘッダー、CTAボタン',
    enterTitle: 'タイトルを入力',
    enterDescription: '説明を入力',
    enterURL: '正規URLを入力',
  },
  tooltip: {
    addImage: '画像を追加',
    labelModalTitle: 'ラベル設定',
    addLabel: '+ ラベルを追加',
    label: 'ラベル',
    labelCaption: 'ラベルを入力',
    labelText: 'ラベルのテキスト',
    labelTextCaption: 'ラベルのテキストを入力',
    labelTextPlaceholder: 'ラベル',
    labelUrl: 'ラベルのURL',
    labelUrlCaption: 'ラベルのURLを入力',
    labelUrlPlaceholder: 'https://example.com',
    noLabel: 'ラベルなし',
    colorFrom: '開始色',
    colorTo: '終了色',
    highlight: 'ハイライト',
    firstName: '名',
    firstNameCaption: '名を入力',
    lastName: '姓',
    lastNameCaption: '姓を入力',
    jobTitle: '役職',
    jobTitleCaption: '役職を入力',
    organization: '組織',
    organizationCaption: '組織を入力',
    email: 'メール',
    emailCaption: 'メールを入力',
    workPhone: '勤務先電話番号',
    workPhoneCaption: '勤務先電話番号を入力',
    mobilePhone: '携帯電話番号',
    mobilePhoneCaption: '携帯電話番号を入力',
    website: 'ウェブサイト',
    websiteCaption: 'ウェブサイトを入力',
    information: '情報',
    informationCaption: '情報を入力',
    streetAddress: '番地',
    streetAddressCaption: '番地を入力',
    city: '市区町村',
    cityCaption: '市区町村を入力',
    state: '都道府県',
    stateCaption: '都道府県を入力',
    postalCode: '郵便番号',
    postalCodeCaption: '郵便番号を入力',
    country: '国',
    countryCaption: '国を入力',
    titleColor: 'タイトルの色',
    titleColorCaption: 'タイトルの色を変更できます',
    fontFamily: 'フォントファミリー',
    fontFamilyCaption: 'フォントファミリーを変更できます',
    fontSize: 'フォントサイズ',
    fontSizeLabel: 'ラベルのフォントサイズ',
    fontSizeCaption: 'フォントサイズを変更できます',
    fontSelect: 'フォント',
    fontSelectCaption: 'フォントを選択',
    imageMargin: '画像の余白',
    profilePicture: 'プロフィール画像',
    profilePictureCaption: 'プロフィール画像を変更',
    pictureSize: '画像サイズ',
    pictureSizeCaption: '画像サイズを変更できます',
    title: 'タイトル',
    titleCaption: 'タイトルを入力',
    blockCaption: 'ブロックのタイトルを入力',
    titlePageCaption: 'ページのタイトルを入力',
    templates: 'テンプレート',
    templatesCaption: 'ページのテンプレートを選択',
    myTemplates: 'マイテンプレート',
    myTemplatesEmpty: 'テンプレートはまだありません。現在のページデザインを保存すると後で再利用できます。',
    saveAsTemplate: 'テンプレートとして保存',
    saveCurrentAsTemplate: '現在のページをテンプレートとして保存',
    templateSaved: 'テンプレートを保存しました',
    templateApplied: 'テンプレートを適用しました',
    buildFromReference: '参考から生成',
    templateAppliedCount: 'テンプレートを適用しました — {n}個のブロックを追加',
    searchTemplates: 'テンプレートを検索…',
    favorites: 'お気に入り',
    previewLive: 'ライブプレビュー',
    previewingTemplate: 'プレビュー中',
    exitPreview: '終了',
    templateKind: '含める内容',
    publish: '公開',
    unpublish: '非公開にする',
    templatePublished: 'テンプレートを公開しました',
    templateUnpublished: 'テンプレートを非公開にしました',
    discoverTemplates: 'コミュニティを探す',
    discoverSubtitle: 'UniLinkの他のクリエイターが公開した無料テンプレート。',
    discoverEmpty: '公開テンプレートはまだありません — 最初に公開してみましょう。',
    pricing: '料金',
    background: '背景',
    backgroundColor: '背景色',
    textBackground: 'テキストの背景',
    textBackgroundCaption: 'テキストの背景色を選択',
    textColor: 'テキストの色',
    textColorCaption: 'テキストの色を選択',
    gradientBackground: 'グラデーション背景',
    gradientColor: 'グラデーションの色',
    BackgroundType: 'タイプ',
    backgroundSource: '背景ソース',
    backgroundSourceCaption: '背景ソースを選択',
    backgroundStyle: '背景スタイル',
    backgroundStyleCaption: '背景スタイルを選択',
    backgroundStylesNormal: '標準',
    backgroundStylesGlass: 'ガラス',
    backgroundStylesOutline: 'アウトライン',
    backgroundTypeCaption: '背景のタイプを選択',
    color: '色',
    colorTooltip: '色を変更できます',
    backgroundOpacityTooltip: 'スライダーをドラッグして背景の不透明度を設定',
    backgroundBlur: '背景のぼかし',
    backgroundBlurCaption: 'スライダーをドラッグして背景をぼかす',
    backgroundBrightness: '背景の明るさ',
    backgroundBrightnessCaption: 'スライダーをドラッグして背景の明るさを変更',
    backgroundContrast: '背景のコントラスト',
    backgroundContrastCaption: 'スライダーをドラッグして背景のコントラストを変更',
    color1: '色 1',
    color2: '色 2',
    colorCaption: 'ページの色を入力',
    gradient: 'グラデーション',
    image: '画像',
    photo: '写真',
    gif: 'GIF',
    animation: 'アニメーション',
    video: '動画',
    hexColor: '16進カラー',
    direction: '方向',
    gradientDirection: 'グラデーションの方向',
    directionCaption: 'スライダーをドラッグしてグラデーションの方向を設定',
    offset: 'オフセット',
    gradientOffset: 'グラデーションのオフセット',
    offsetCaption: 'スライダーをドラッグしてグラデーションのオフセットを設定',
    backgroundDarkness: '背景の暗さ',
    backgroundDarknessCaption: 'スライダーをドラッグして背景画像を暗くする',
    uploadVideo: '動画をアップロード',
    uploadFile: 'ファイルをアップロード',
    uploadVideoCaption: 'ページ背景の動画',
    linkToVideo: '動画へのリンク',
    linkToVideoCaption: '動画へのリンクを追加',
    videoWithSound: '音声付き動画',
    videoWithSoundCaption: '音声付きで動画を再生',
    fonts: 'フォント',
    fontRoles: {
      heading: '見出し',
      subtitle: 'サブタイトル',
      body: '全体',
    },
    fontWeight: 'フォントの太さ',
    fontWeightCaption: 'クリックして選択してください',
    preloader: 'プリローダー',
    preview: 'プレビュー',
    hideLogo: 'UniLinkロゴを非表示',
    cover: 'カバー',
    coverCaption: 'カバーを変更',
    coverCaptionHeader: 'ヘッダーのカバーに画像または動画を追加',
    pageNavigation: 'ページナビゲーション',
    websiteNavigation: 'タブナビゲーション',
    backgroundOpacity: '背景の不透明度',
    backgroundOpacityCaption: 'スライダーをドラッグしてボタン背景の不透明度を設定',
    borderRadius: '角の丸み',
    borderRadiusCaption: 'スライダーをドラッグして角の丸みを設定',
    heightTabs: 'タブの高さ',
    heightTabsCaption: 'スライダーをドラッグしてタブの高さを設定',
    backgroundShadow: '背景の影',
    backgroundShape: '背景の形状',
    backgroundBorder: '背景の枠線',
    opacity: '不透明度',
    opacityCaption: 'スライダーをドラッグして不透明度を設定',
    shape: '形状',
    shapeCaption: '形状を設定',
    text: 'テキスト',
    textCaption: 'テキストを入力',
    textSize: 'テキストサイズ',
    textSizeCaption: 'スライダーをドラッグしてテキストサイズを設定',
    additionalText: '追加テキスト',
    username: 'ユーザー名',
    currency: '通貨',
    language: '言語',
    timeZone: 'タイムゾーン',
    websiteNiche: 'ウェブサイトのニッチ',
    websiteNicheCaption: 'ウェブサイトのニッチを入力',
    renameCaption: 'ブロックのタイトルを変更',
    description: '説明',
    descriptionCaption: '説明を入力',
    actionButton: 'アクションボタン',
    actionButtonCaption: '行動を促すボタンは、訪問者にアクションを促します',
    animationDirection: 'アニメーションの方向',
    animationDirectionCaption: 'アニメーションの方向を選択',
    buttonTitle: 'ボタンのタイトル',
    buttonTitleCaption: 'ボタンのタイトルを入力',
    buttonUrl: 'ボタンのURL',
    buttonUrlCaption: 'URLは新しいウィンドウで開きます',
    imageSize: '画像サイズ',
    imageSizeCaption: 'スライダーをドラッグして画像サイズを設定',
    view: '表示',
    viewCaption: '表示を選択',
    margin: 'マージン',
    marginCaption: 'スライダーをドラッグしてアイテムの上下にマージンを追加',
    separateTopBottom: '上 / 下',
    padding: 'パディング',
    paddingCaption: 'スライダーをドラッグしてアイテムの上下にパディングを追加',
    fullWidth: '全幅',
    lineHeight: '行の高さ',
    lineHeightCaption: '行の高さを変更できます',
    button: 'ボタン',
    titleSize: 'タイトルサイズ',
    titleSizeCaption: 'タイトルサイズを変更できます',
    titleLineHeight: 'タイトルの行の高さ',
    titleLineHeightCaption: 'タイトルの行の高さをカスタマイズして、テキストにより多くのデザインの選択肢を加えましょう',
    layout: 'レイアウト',
    layoutCaption: '希望のヘッダーレイアウトを作成',
    layoutAlign: 'レイアウトの配置',
    alignText: 'テキストを配置',
    align: '配置',
    alignCaption: '配置を選択',
    position: '位置',
    positionCaption: '位置を選択',
    width: '幅',
    widthCaption: 'バナーの幅を選択',
    nameHeader: '名前',
    nameCaption: 'アカウントの名前を入力',
    shortBio: '短い自己紹介',
    shortBioCaption: 'アカウントの短い自己紹介を入力',
    externalLink: '外部リンク',
    externalLinkCaption: 'アカウントへの外部リンクを入力',
    location: '所在地',
    locationCaption: '所在地を入力',
    locationMap: '所在地マップ',
    locationMapCaption: '所在地のURLを入力',
    rightIcon: '右アイコン',
    rightIconCaption: 'このアイコンはボタンの右側に表示されます',
    buttons: 'ボタン',
    buttonsCaption: 'アクションボタンを追加',
    nameLogo: '名前のロゴ',
    nameLogoCaption: '名前用のロゴをアップロード',
    buttonText: 'ボタンのテキスト',
    buttonTextCaption: 'ボタンの名前を入力',
    buttonColor: 'ボタンの色',
    buttonColorCaption: 'ボタンの色を選択',
    buttonColorCTACaption: 'CTAボタンの背景色を選択',
    cartColor: 'カートの色',
    cartColorCaption: 'カートの背景色を選択',
    ctaButton: 'CTAボタン',
    ctaButtonCaption: 'このアイコンはボタンの右側に表示されます',
    style: 'スタイル',
    socialIconsStyleCaption: 'SNSアイコンのスタイルを選択できます',
    socialIconsShape: 'SNSアイコンの形状',
    socialIconsShapeCaption: 'SNSアイコンの形状を選択できます',
    headerTextColorCaption: 'ヘッダーのテキストの色を選択できます',
    pictureShape: '画像の形状',
    pictureShapeCaption: 'プロフィール画像の形状を選択できます',
    socialLinks: 'SNSリンク',
    socialLinksCaption: 'SNSリンクボタンを追加して、あなたと顧客がワンクリックで素早くつながれるようにしましょう',
    URL: 'URL',
    URLCaption: 'URLアドレスを入力',
    heading: '見出し',
    headingTitle: '見出しのタイトル',
    headingTitleCaption: '見出しのタイトルを入力',
    headingDescription: '見出しの説明',
    headingDescriptionCaption: '見出しの説明を入力',
    headingImage: '見出しの画像',
    headingImageCaption: '見出し用の画像をアップロード',
    headingPosition: '見出しの位置',
    headingInsideBlock: 'ブロック内',
    headingOutsideBlock: 'ブロック外',
    headingDivider: '見出しの区切り線',
    canonicalURL: '正規URL',
    seo: 'SEO',
    seoCaption: 'メタSEOタグで商品をカスタマイズ',
    themes: 'テーマ',
    brandColors: 'Brand Kit',
    applyBrandColors: 'プロフィールに適用',
    syncBlocks: 'すべてのブロックを同期',
    brandColorsApplied: 'ブランドカラーを適用しました',
    generatedPalette: '生成されたパレット',
    applying: '適用中...',
    syncing: '同期中...',
    backgroundType: '背景タイプ',
    palettes: 'パレット',
    previewTitle: 'タイトル',
    previewTitleCaption: 'プレビューのタイトルを入力',
    previewDescription: '説明',
    previewDescriptionCaption: 'プレビューの説明を入力',
    previewButton: 'ボタンのテキスト',
    previewButtonCaption: 'プレビューのボタンテキストを入力',
    previewLabel: 'ラベルのテキスト',
    previewLabelCaption: 'プレビューのラベルテキストを入力',
    previewThumbnail: 'サムネイル',
    previewThumbnailCaption: 'プレビューのサムネイルをアップロード',
  },
  table: {
    clicks: 'クリック数',
    signups: 'サインアップ',
    views: 'インプレッション',
    orderNumber: '注文番号',
    amount: '金額',
    credits: 'クレジット',
    invoice: '請求書',
    email: 'メール',
    card: 'カード',
    currency: '通貨',
    name: '名前',
    contact: '連絡先',
    optIn: 'オプトイン',
    notes: 'メモ',
    address: '住所',
    date: '日付',
    action: '操作',
    custom: 'カスタム',
    status: 'ステータス',
    tags: 'タグ',
    view: '表示',
    remove: '削除',
    sendEmail: 'メールを送信',
    details: '詳細',
    purchases: '購入',
    order: '注文',
    money: '金額',
    type: 'タイプ',
    orderCode: '注文コード',
  },
  settings: {
    title: '設定',
    settings: '設定',
    accountSettings: 'アカウント設定',
    email: 'メール',
    subscription: 'サブスクリプション',
    billingHistory: '請求履歴',
    dueTo: '期限',
    subscriptionDueTo: 'サブスクリプションの期限',
    accountLabel: 'アカウント',
    profileLabel: 'プロフィール',
    switchProfile: 'プロフィールを切り替え',
    createNewProfile: '新しいプロフィールを作成',
    active: '有効',
    currentPlan: '現在のプラン',
    freePlanHint: 'アップグレードしてPro機能を解放し、制限を解除しましょう。',
    to: '〜',
    renews: '更新日',
    passwordChangeDesc: 'アカウントのパスワードを変更',
    apiKeyDesc: 'このキーを使ってAPIリクエストを認証します',
    apiDocumentation: 'APIドキュメント',
    dashboardLanguageDesc: 'アカウントのインターフェース言語',
    cancelSubscription: 'サブスクリプションをキャンセル',
    cancelSubscriptionConfirm: 'サブスクリプションをキャンセルしてもよろしいですか？',
    subscriptionCancelled: 'サブスクリプションはキャンセルされました。プランは請求期間の終わりまで有効です。',
    subscriptionCancelError: 'サブスクリプションのキャンセルに失敗しました。サポートにお問い合わせください。',
    deleteFirst: '次を完全に削除します：',
    deleteSecond: 'とそのすべてのデータ。この操作は取り消せません。',
    account: {
      title: 'アカウント',
      usernameNotAvailable: 'このユーザー名は利用できません',
      setupCustomDomain: 'カスタムドメインを設定',
      subtitle: 'アカウントのメール、請求、パスワード、APIキー',
    },
    profile: {
      title: 'プロフィール',
      usernameNotAvailable: 'このユーザー名は利用できません',
      setupCustomDomain: 'カスタムドメインを設定',
      subtitle: 'ユーザー名、言語、通貨、タイムゾーンを管理',
      category: 'カテゴリ',
      categoryCaption: 'プロフィールのカテゴリを入力',
      usernameDesc: '公開ハンドル',
      currencyDesc: '収益と支払いに使用',
      languageDesc: '訪問者に表示される言語',
      timeZoneDesc: 'スケジュールとアナリティクス用',
      categoryDesc: 'プロフィールを最もよく表すもの',
      privateProfile: '非公開プロフィール',
      privateProfileDesc: '承認されたフォロワーのみがプロフィールを閲覧できます',
    },
    aiassistant: {
      title: 'AIアシスタント',
      subtitle: 'AIアシスタントをカスタマイズして、よりパーソナライズされた優れた応答を得ましょう',
      titleText: 'より関連性の高い応答のために、あなたが誰であるかをAIに理解させましょう',
      customAiTitle: 'カスタム指示',
      customAiPlaceholder: 'AIへの特定の指示を追加...',
      customAiDescription: 'これらの指示はAIとのすべての会話に適用されます',
      nicknameTitle: 'AIはあなたを何と呼べばよいですか？',
      nicknamePlaceholder: 'ニックネーム',
      titleBio: '自己紹介 / 説明',
      bioPlaceholder: 'あなたについて少し教えてください...',
      occupation: 'お仕事は何ですか？',
      occupationPlaceholder: '例：ウォータールー大学の工学部生',
      aboutYouTitle: 'あなたについて',
      aboutYouTooltip: 'AIアシスタントにあなたについて少し教えてください',
      locationTitle: '所在地',
      locationPlaceholder: '例：ウクライナ、キーウ',
      categoryTitle: 'カテゴリ',
    },
    notifications: {
      title: '通知',
      subtitle: '新しい訪問者のメールや注文に関する通知を設定',
      text: 'メッセンジャーを接続して、新しい顧客のメールや注文に関する通知を受け取りましょう',
      setUpWebhooks: 'Webhooksセクションでwebhookを設定',
      save: '保存',
      connect: '接続',
      disconnect: '接続解除',
      webhook: 'Webhook',
      emailSubmit: 'データ収集の送信',
      formSubmit: 'フォームの送信',
      showSubmit: 'ショップの送信',
      digitalSubmit: 'デジタル商品の送信',
      appointmentSubmit: '予約の送信',
      requestSubmit: 'サービスの送信',
      donationSubmit: '寄付の送信',
      email: 'メール',
      settings: '設定',
      cartSubmit: 'カートの送信',
      linkClick: 'リンククリック',
      contactClick: '連絡先クリック',
      all: 'すべて',
      updates: 'アップデート',
      messages: 'メッセージ',
      opportunities: 'チャンス',
      insights: 'インサイト',
      activity: 'アクティビティ',
      system: 'システム',
      news: 'ニュース',
      more: 'もっと見る',
      less: '表示を減らす',
      connectedAccounts: '連携済みアカウント',
      addEmailAccount: 'メールアカウントを追加',
    },
    paymentSystem: {
      title: '決済システム',
      subtitle: 'StripeまたはPayPalで支払いを設定',
      text: '処理手数料を表示',
      connected: '接続済み',
      active: 'ウェブサイトで支払いを受け付ける',
      pending: '保留中',
      disconnect: '接続解除',
      connect: '接続',
      add: '追加',
      ofYourAccount: 'アカウントの',
      save: '保存',
    },
    manualPayments: {
      title: '手動 / オフライン支払い',
      hint: '顧客はオフライン（銀行振込、現金、QR）で支払います。注文は手動で確認します。',
      save: '保存',
      iban: 'IBAN',
      accountHolder: '口座名義人',
      bankName: '銀行名',
      phone: '電話番号',
      payeeName: '受取人名',
      instruction: '指示',
      instructionHint: '**太字** ~取り消し線~ _斜体_ で装飾できます',
      requireProof: '支払い証明を必須にする',
      requireProofHint: '決済を完了するには、顧客がスクリーンショット（領収書、振込確認、その他の支払い証明）をアップロードする必要があります。',
      markPaidOnConfirm: '顧客の確認時に支払い済みとする',
      markPaidOnConfirmHint: '顧客が支払いを確認すると、支払いステータスが自動的に「支払い済み」に更新されます。',
      contactBeforePay: '支払い前の販売者への問い合わせを有効化',
      contactBeforePayHint: '顧客が支払いをスキップして販売者にメッセージを送れるようになり、問い合わせが増えると同時に信頼が高まり、キャンセルが減ります。',
    },
    shop: {
      title: 'ショップ',
      subtitle: 'カテゴリとプロパティを設定',
      label: {
        title: 'ラベル',
        subtitle: '商品カードにラベルを追加',
        addValue: '値を追加',
        save: '保存',
        value: '値',
        enterTitle: 'タイトルを入力',
        maximum: '値は最大5つまでです',
        add: '追加',
        edit: '編集',
        labels: 'ラベル',
      },
      category: {
        title: 'カテゴリ',
        subtitle: '商品にカテゴリを追加',
        addCategory: 'カテゴリを追加',
        save: '保存',
        maximum: '最大数は次のとおりです',
        editTitle: 'カテゴリ',
        name: '名前',
        namePlaceholder: 'カテゴリを入力',
        visibility: '表示設定',
        visible: '表示',
        hidden: '非表示',
        description: '説明',
        descriptionHint: '説明は100文字未満にしてください',
        descriptionPlaceholder: '短い説明を追加',
        cover: 'カバー',
        view: '表示',
        share: '共有',
        linkCopied: 'リンクをコピーしました',
        saveFirst: '先にカテゴリを保存してください',
        moveOut: '移動する',
      },
      property: {
        title: 'プロパティ',
        subtitle: '商品にプロパティを追加',
        addProperties: 'プロパティを追加',
        properties: 'プロパティ',
        type: 'タイプ',
        typeTooltip: 'プロパティのタイプ',
        titleModal: 'タイトル',
        titleModalTooltip: 'プロパティの名前',
        enterTitle: 'タイトルを入力',
        value: '値',
        addValue: '値を追加',
        maximum: '値の最大数は次のとおりです',
        save: '保存',
        cancel: 'キャンセル',
        remove: '削除',
        addPropertyToItem: 'アイテムにプロパティを追加',
        add: '追加',
        edit: '編集',
        propertiesSmall: 'プロパティ',
        required: '必須',
        requiredTooltip: '購入に必須のプロパティを設定',
        selectAll: 'すべて選択',
      },
      actionButtons: {
        contentTab: 'コンテンツ',
        designTab: 'デザイン',
        buttonTitle: 'ボタンのタイトル',
        buttonColor: 'ボタンの色',
        cancel: 'キャンセル',
        save: '保存',
        maxChars: '最大 {count} 文字',
        minChars: '最小 {count} 文字',
        enterTitle: 'ボタンのタイトルを入力してください',
        contactTooltip: 'お客様からの連絡手段をひとつ選びます：メール、メッセージ、フォーム',
        contactNotConfigured: '連絡手段を設定してください',
        methodEmail: 'メールを送る',
        methodMessenger: 'メッセンジャー',
        methodForm: '申込みフォーム',
        enterAddress: 'アドレスを入力してください',
        invalidAddress: '無効なアドレスです',
        enterContact: '番号またはユーザー名を入力してください',
        summaryFields: '{count} 項目',
        dragToReorder: 'ドラッグして並べ替え',
        fieldName: '項目名',
        fieldRequired: '必須',
        deleteField: '項目を削除',
        enterFieldName: '項目名を入力してください',
        addAtLeastOneField: '項目を1つ以上追加してください',
        maxFields: '最大 {count} 項目',
        typeText: 'テキスト',
        typeEmail: 'メール',
        typePhone: '電話',
        preorderTooltip: 'この商品の予約フォーム',
        preorderRowHint: '購入者が入力する項目 — 開いて編集',
        saveFailed: '保存できませんでした。もう一度お試しください。',
        preorderNotConfigured: '予約フォームを設定してください',
        enableAtLeastOneField: '項目を1つ以上有効にしてください',
        enterSubmitTitle: '送信ボタンのタイトルを入力してください',
        invalidUrl: '無効なリンクです',
        redirectHelper: '空欄の場合、お客様はページに留まり下のテキストを見ます。',
        discardTitle: '保存せずに閉じますか？',
        discardText: 'ボタン設定の変更は失われます。',
        discardContinue: '編集を続ける',
        discardClose: '閉じる',
        contactModalTitle: 'Contact ボタン',
        preorderModalTitle: '予約注文ボタン',
        contactModalSubtitle: 'ボタン1つに動作1つ。結果の届く先は次の画面で設定します',
        actionTab: '動作',
        methodFormDesc: '購入者が項目を入力します',
        methodChat: 'ライブチャット',
        methodChatDesc: 'このページでリアルタイムにやり取り',
        methodMessengerDesc: 'WhatsApp、Telegram、Viber…',
        methodEmailDesc: '購入者のメールアプリが開きます',
        inboxDefaultNote: '初期設定ではすべて Unilink Inbox に保存されます。後から変更できます。',
        readyToSave: '保存できます',
        apply: '適用',
        back: '戻る',
        pickAction: 'ボタンの動作を選んでください',
        buttonText: 'ボタンの文字',
        buttonBackground: 'ボタンの背景',
        buttonTextColor: '文字の色',
        lowContrastWarning: '文字が背景に溶けています。購入者はラベルを読めません。',
        colorsSharedNote: '色は商品ページのボタンに適用されます。',
        chatNoSetup: '設定は不要です。チャットはページ上で開き、やり取りは Inbox に届きます。',
        yourEmail: 'あなたのメールアドレス',
        yourEmailHelper: '購入者のメールアプリが、このアドレス宛の下書きで開きます。',
        channelAndContact: 'チャネルと連絡先',
        singleChannelNote: 'ボタンは選んだアプリのチャットをすぐに開きます。',
        addContact: '連絡先を追加',
        deleteContact: '連絡先を削除',
        contactsCount: '連絡先 {count} 件',
        maxContacts: '連絡先は最大 {count} 件です',
        duplicateContact: 'このアプリはすでに一覧にあります',
        multiChannelNote: 'ボタンを押すと一覧が開き、お客様がアプリを選びます。',
        recapMessengers: 'お客様が選びます: {apps}',
        whatToAsk: '何を尋ねるか',
        fieldsOfMax: '{max} 項目のうち {count}',
        fieldOptional: '任意',
        typeLongText: '長文',
        duplicateField: '同じ名前の項目が上にあります',
        addReplyableField: 'メールか電話を追加してください。ないと返信できません',
        presetName: '名前',
        presetEmail: 'メール',
        presetPhone: '電話',
        presetComment: 'コメント',
        presetOwnField: '自由項目',
        thanksText: '送信後に表示する文',
        thanksPlaceholder: 'ありがとうございます。当日中にご返信します。',
        recapForm: '申込みは {targets} 届きます',
        recapChat: 'やり取りは Unilink Inbox に届きます',
        recapMessenger: '購入者は {app} に移動します',
        recapEmail: '購入者のメールが {address} 宛の下書きで開きます',
        recapEmailFallback: 'あなたのアドレス',
        recapTargetInbox: 'Unilink Inbox に',
        actionsLabel: '連絡手段',
        actionsOfMax: '{count}/{max}',
        actionsCount: '{count} 件の動作',
        addAction: '動作を追加',
        addFirstAction: 'お客さまの最初の連絡手段を追加してください',
        deleteAction: '動作を削除',
        actionNeedsAttention: '設定が未完了です',
        severalActionsNote: '各動作は商品ページ上の個別のボタンになります（この順序で）。',
        methodAlreadyAdded: 'すでに追加済みです',
        duplicateChannel: 'この連絡先のチャネルはすでに追加されています',
        duplicateTitle: '同じ文字のボタンがすでにあります',
        defaultTitleForm: 'お問い合わせ',
        defaultTitleChat: 'チャットで相談',
        defaultTitleEmail: 'メールで問い合わせ',
        buyModalTitle: 'Buy ボタン',
        buyModalSubtitle: '購入者をそのまま決済に進めます',
        buyTooltip: 'ボタンは購入者をそのまま決済に進めます',
        buyNoPrice: 'テキストのみ、価格なし',
        priceOnButton: 'ボタンに出す価格',
        priceOnButtonHelper: '空欄ならボタンにはテキストだけが出ます',
        invalidPrice: '価格は数字のみです（例: 990）',
        redirectModalTitle: 'Redirect ボタン',
        redirectModalSubtitle: 'リンクで任意のページへ移動させます',
        redirectTooltip: 'ボタンはリンクで任意のページを開きます',
        linkLabel: 'リンク',
        linkPlaceholder: 'https://example.com/page',
        opensHost: '開くページ: {host}',
        openInNewTab: '新しいタブで開く',
        enterLink: 'このボタンが開くリンクを入力してください',
        noLinkSet: 'リンク未設定',
        preorderModalSubtitle: '販売開始前の予約を集めます — 支払いなし',
        shipEta: '発送の時期',
        shipEtaPlaceholder: '例: 9月15日まで',
        shipEtaHelper: 'フォームに表示します — 購入者が待ち時間を先に把握でき、問い合わせが減ります',
        fieldsInForm: 'フォームの項目数: {count}',
        enableFieldFirst: 'まず項目をオンにしてください',
        submitInForm: 'フォームのボタン文言',
        afterSubmit: '送信後',
        afterSubmitText: 'テキストを表示',
        afterSubmitUrl: 'ページへ移動',
        afterSubmitTextHelper: '購入者はページに留まり、このテキストを読みます',
        preorderThanksPlaceholder: 'ありがとうございます！商品が準備できたらご連絡します。',
        enterRedirectUrl: 'ページの URL を入力するか、テキスト表示に戻してください',
      },
      preorderForm: {
        title: '予約注文フォーム',
        subtitle: '予約注文フォームのフィールドを設定',
        fields: 'フィールド',
        fieldsTooltip: 'フォームにフィールドを追加',
        required: '必須',
        submitButton: '送信ボタンのタイトル',
        redirectUrl: 'リダイレクトURL（任意）',
        resultText: '結果テキスト',
        save: '保存',
        name: '名前',
        emailAddress: 'メールアドレス',
        phone: '電話番号',
        address: '住所',
        comment: 'コメント',
      },
      shipping: {
        title: '決済フォーム',
        subtitle: '購入者が注文時に入力する項目',
        fields: 'フィールド',
        fieldsTooltip: '決済フォームにフィールドを追加',
        required: '必須',
        save: '保存',
        name: '名前',
        emailAddress: 'メールアドレス',
        phone: '電話番号',
        address: '住所',
        comment: 'コメント',
        askDetails: '購入者の情報を聞く',
        askDetailsHint: 'オフ — フォームなしで注文を受け付けます',
        askDetailsPaymentWarning:
          '決済はオンラインで行われます。メールがないと領収書の送り先がありません。少なくともメールはオンのままにするか、決済を「支払なしで注文を受ける」に切り替えてください。',
        askDetailsRedirectNote: '決済は別のサイトで行われるため、これらの項目は購入者に表示されません。',
        askDetailsNoContactNote: '注文は連絡先なしで届きます。折り返し連絡するなら電話番号はオンのままにしてください。',
        promoCode: 'プロモコード',
        addCustomField: 'カスタムフィールドを追加',
        addFormInfo: 'フォーム情報を追加',
        editFormInfo: 'フォーム情報を編集',
        type: 'タイプ',
        typeTooltip: 'カスタムフィールドのタイプ',
        fieldName: 'フィールド名',
        fieldNameTooltip: 'カスタムフィールドの名前',
        placeholder: 'プレースホルダー',
        placeholderTooltip: 'カスタムフィールドのプレースホルダー',
        delete: '削除',
        update: '更新',
        add: '追加',
      },
      delivery: {
        title: '配送方法',
        subtitle: '配送・宅配・店頭受取',
        loading: '読み込み中…',
        inactive: '無効',
        confirmDelete: 'この配送方法を削除しますか？',
        category: {
          shipping: '配送',
          localDelivery: '地域配達',
          selfPickup: '店頭受け取り',
        },
        rateType: {
          free: '無料',
          conditionalFree: '条件付き無料',
          flatRate: '定額',
          customRates: 'カスタム料金',
          carrierApi: '配送業者API',
        },
        carrier: {
          custom: 'カスタム配送業者',
        },
        add: {
          shipping: '配送を追加',
          localDelivery: '地域配達を追加',
          selfPickup: '店頭受け取りを追加',
        },
        actions: {
          edit: '編集',
          delete: '削除',
          save: '保存',
          cancel: 'キャンセル',
        },
        fields: {
          name: '名前',
          namePh: '例：通常配送',
          description: '説明',
          isActive: '有効',
          estimatedDays: '予想日数',
          currency: '通貨',
          countryCodes: '国コード（CSV）',
          carrier: '配送業者',
          rateType: '料金タイプ',
          flatPrice: '定額料金',
          freeThreshold: '無料になる金額（小計）',
          fallbackPrice: 'フォールバック料金',
          customRates: 'カスタム料金の行',
          senderCity: '発送元の都市名',
          senderCityRef: '発送元の都市ref',
          pickupInstructions: '受け取りの手順',
          pickupCharge: '受け取り料金',
          askPickupDateTime: '決済時に受け取り日時を尋ねる',
        },
        rateRow: {
          subtotal: '小計別',
          weight: '重量別（g）',
          min: '最小',
          max: '最大',
          price: '料金',
          add: '行を追加',
        },
      },
      legal: {
        title: '法的文書',
        subtitle: '利用規約・プライバシー・返品',
        loading: '読み込み中…',
        empty: '法的文書はまだありません。',
        inactive: '無効',
        required: '必須',
        confirmDelete: 'この文書を削除しますか？',
        addNew: '+ 文書を追加',
        types: {
          terms: '利用規約',
          privacy: 'プライバシーポリシー',
          returns: '返品 / 返金ポリシー',
          shipping: '配送ポリシー',
          cookies: 'Cookieポリシー',
          custom: 'カスタム',
        },
        fields: {
          title: 'タイトル',
          titlePh: '例：利用規約',
          type: '文書の種類',
          content: '内容',
          contentPh: 'ここに法的文書を記入してください…',
          isActive: '有効',
          requireAcceptance: '決済時に同意を必須にする',
        },
        actions: {
          edit: '編集',
          delete: '削除',
          save: '保存',
          cancel: 'キャンセル',
        },
      },
      checkoutGroup: '決済',
      serviceCharge: {
        title: 'サービス料',
        subtitle: 'すべての注文にサービス料またはチップを追加します。',
        label: '説明',
        labelPh: '例：サービス料5%と配達チップ$3',
        rate: '料率',
        rateHint: '注文小計に対する割合。',
        amount: '金額',
        amountHint: '上乗せする固定金額。',
      },
      tip: {
        title: 'チップ',
        subtitle: '顧客が決済時に注文にチップを追加できるようにします。',
        enable: 'チップを有効化',
        presets: 'チッププリセット（%）',
        noPresets: 'プリセットはまだありません — 下に追加してください。',
        presetPh: '例：10',
        addPreset: '+ プリセットを追加',
        presetsHint: '決済時にクイック選択ボタンとして表示されます。最大6つ。',
        remove: '削除',
        allowCustom: 'カスタム金額を許可',
        label: '案内ラベル',
        labelPh: '例：素晴らしいサービスにチップを追加',
        save: '保存',
        saving: '保存中…',
      },
      orderNumber: {
        title: '注文番号',
        subtitle: '注文番号の表示形式をカスタマイズします。',
        next: '次の注文番号',
        prefix: '接頭辞',
        suffix: '接尾辞',
        showInMessage: '請求書と注文メッセージに表示',
        reset: '注文番号をリセット',
      },
      orderMessage: {
        title: '注文メッセージ',
        subtitle: '顧客に送信される注文確認をカスタマイズします。',
        footer: 'メッセージのフッター',
        footerPh: '例：ご注文ありがとうございます！@yourbrandをフォローしてください',
        footerHint: 'すべての注文確認メッセージに追加されます。',
        plain: 'プレーンメッセージ',
        plainHint: '注文メッセージからすべての書式を削除します。',
      },
      invoice: {
        title: '請求書',
        subtitle: '支払い済みの注文に添付されるブランド付き請求書。',
        upgrade: 'アップグレード',
        showLogo: 'ロゴを表示',
        header: 'ヘッダー',
        footer: 'フッター',
        companyName: '会社名',
        companyEmail: '会社のメール',
        companyPhone: '会社の電話番号',
        companyAddress: '会社の住所',
        companyAddressPh: '住所を入力',
      },
    },
    seo: {
      title: 'SEO',
      subtitle: 'メタSEOタグでページをカスタマイズ',
      titleText: 'タイトル',
      titlePlaceholder: 'ページタイトルを入力',
      description: '説明',
      descriptionPlaceholder: 'ページの説明を入力',
      favicon: 'ファビコン',
      uploadFavicon: 'ファビコンをアップロード',
      imagePreview: '画像プレビュー',
      useCustom: 'カスタム画像を使用',
      save: '保存',
      visualise: 'Googleでウェブサイトのプレビューがどう表示されるかを視覚化',
      inMessengers: 'メッセンジャーでの表示',
      inSocial: 'SNSでの表示',
      searchEngine: '検索エンジン',
      googleIndexable: 'Googleインデックス可能',
      sitemap: {
        title: 'サイトマップ',
        entryHint: '検索エンジンがインデックスできるページや商品を管理します。',
        setupLink: 'カスタマイズ',
        mainEntry: 'ウェブサイトをインデックス',
        subtitle: '検索エンジンがインデックスするページを選択します。無効にしたページにはnoindexタグが付与され、サイトマップから削除されます。',
        mainPage: 'メインプロフィールページ',
        pagesSection: 'ページ',
        pagesHint: 'サイトの各追加ページのインデックスを切り替えます。',
        noPages: '追加ページはまだありません。',
        productsSection: '商品',
        productsHint: '個々の商品ページのインデックスを切り替えます。',
        noProducts: '商品はまだありません。',
        postsSection: '投稿',
        postsHint: '個々の投稿のインデックスを切り替えます。',
        noPosts: '投稿はまだありません。',
        blogSection: 'ブログ記事',
        blogHint: '個々のブログ記事のインデックスを切り替えます。',
        noArticles: 'ブログ記事はまだありません。',
        loadMore: 'もっと読み込む',
        loading: '読み込み中…',
      },
    },
    analytics: {
      title: 'アナリティクス',
      subtitle: 'Facebook Pixel、Google Analytics、UTMパラメータを連携',
      facebookTooltip: 'Facebookを接続してアナリティクスを表示',
      googleAnalyticsTooltip: 'Google Analyticsを使うと、広告のROIを測定し、すべてのリンクを追跡できます。',
      googleTagManagerTooltip: 'Googleタグマネージャーを使うと、ウェブサイトのタグを設定して即座に配信できます',
      tikTokPixelTooltip: 'TikTok Pixelは、TikTok広告がウェブサイトに与える影響を追跡する強力な測定ツールです',
      pinterestTag: 'Pinterestタグ',
      pinterestTagTooltip: 'Pinterestタグはウェブサイトに追加するコードで、Pinterestがサイトへの訪問者や、Pinterest広告を見た後にサイトで取った行動を追跡できるようにします。',
      tag: 'タグ',
      headerTagTooltip: 'ウェブサイトのheadに表示されるタグを貼り付け',
      bodyTagTooltip: 'ウェブサイトのbodyに表示されるタグを貼り付け',
      utmParameters: 'UTMパラメータ',
      utmParametersTooltip: 'カスタムURLでキャンペーンデータを収集します。URLにパラメータを追加して、トラフィックを誘導するキャンペーンを識別しましょう。',
      makeAnalytics: 'Google AnalyticsでUniLinkのトラフィックをSocialとして表示',
      the: '',
      campaign: 'campaign',
      parameter: 'パラメータは各投稿またはリンクのタイトルから動的に設定されます',
      save: '保存',
    },
    customDomain: {
      title: 'カスタムドメイン',
      subtitle: 'カスタムドメインでページをカスタマイズ',
      titleTooltip: 'カスタムドメインを追加',
      save: '保存',
      connect: '接続',
      connecting: '接続中',
      instructions: '手順',
      submit: '送信',
      submitting: '送信中...',
      enterDomain: 'ドメインを入力',
      domainPlaceholder: 'your-domain.com',
      steps: {
        submitting: 'リクエストを送信中',
        validation: 'ドメインの検証',
        certificate: '証明書のプロビジョニング',
        complete: '完了',
      },
      txtRecord: {
        title: 'TXTレコード',
        description: '以下のTXTレコードをDNS設定に追加してください：',
        verifyButton: 'TXTレコードを確認',
        verifying: '確認中...',
        verified: 'TXTレコードを確認しました',
      },
      cnameRecord: {
        title: 'CNAMEレコード',
        description: '以下のCNAMEレコードをDNS設定に追加してください：',
        verifyButton: 'CNAMEレコードを確認',
        verifying: '確認中...',
        verified: 'CNAMEレコードを確認しました',
      },
      dnsTable: {
        type: 'タイプ',
        host: 'ホスト',
        value: '値',
        ttl: 'TTL',
        copy: 'コピー',
        copied: 'コピーしました！',
      },
      provisioning: {
        title: 'SSL証明書をプロビジョニング中...',
        description: '数分かかる場合があります。お待ちください。',
        timeout: '証明書のプロビジョニングに予想より時間がかかっています。後ほどご確認ください。',
      },
      complete: {
        title: 'ドメインでHTTPSが正常に有効になりました。',
        connected: '接続済み',
      },
      failed: {
        title: 'ドメインの接続に失敗しました',
        tryAgain: '再試行',
      },
      rootDomainWarning: 'ルートドメインには、CNAMEフラット化に対応するDNSプロバイダー（例：Cloudflare、Route53）が必要です。',
      deleteConfirm: {
        title: 'ドメインを接続解除',
        message: 'このドメインを接続解除してもよろしいですか？このドメインからウェブサイトにアクセスできなくなります。',
        confirm: '接続解除',
        cancel: 'キャンセル',
      },
    },
    developerApi: {
      title: '開発者API',
      subtitle: 'APIキーを作成して、/api/v2エンドポイント経由で注文、商品、顧客にアクセスします。',
      keyName: 'キー名',
      keyNamePh: '例：倉庫の同期',
      scopes: '権限',
      scopeLabels: {
        'orders:read': '注文の読み取り',
        'products:read': '商品の読み取り',
        'products:write': '商品在庫の更新',
        'customers:read': '顧客の読み取り',
      },
      create: 'キーを作成',
      creating: '作成中…',
      created: 'APIキーを作成しました',
      copyWarning: 'このキーを今すぐコピーしてください — 再度表示されることはありません。',
      done: '完了',
      revoke: '取り消し',
      revoked: '取り消し済み',
      confirmRevoke: 'このAPIキーを取り消しますか？これを使用しているアプリは動作しなくなります。',
      empty: 'APIキーはまだありません。',
    },
    whatsapp: {
      title: 'WhatsApp Business',
      subtitle: 'WhatsApp Businessの番号を接続して、顧客のメッセージを受信・返信します。',
      phoneNumberId: '電話番号ID',
      accessToken: 'アクセストークン',
      displayPhone: '表示用電話番号（任意）',
      connect: '接続',
      connecting: '接続中…',
      connected: '接続済み',
      disconnect: '接続解除',
      confirmDisconnect: 'WhatsAppを接続解除しますか？',
      webhookHelp: 'このコールバックURLと確認トークンをMeta App → WhatsApp → 設定に入力してください：',
      webhookUrl: 'コールバックURL',
      verifyToken: '確認トークン',
      inbox: '受信トレイ',
      noMessages: 'メッセージはまだありません。',
      selectThread: '会話を選択してください。',
      replyPlaceholder: 'メッセージを入力…',
      send: '送信',
      broadcast: {
        title: '一斉送信',
        audienceInbox: '受信トレイの連絡先',
        audienceCrm: 'CRMオーディエンス（テンプレート）',
        message: 'メッセージ',
        inboxHint: '自由形式のテキスト — 24時間のカスタマーサービスウィンドウ内の連絡先にのみ配信されます。',
        templateName: 'テンプレート名',
        templateLang: 'テンプレートの言語',
        crmHint: '承認済みのWhatsAppテンプレートを使用してください — 24時間ウィンドウ外の連絡先に届けるには必須です。',
        send: '一斉送信を送る',
        sending: '送信中…',
        empty: '一斉送信はまだありません。',
        sent: '送信済み',
        failed: '失敗',
      },
      autoReply: {
        title: '自動返信',
        type: 'タイプ',
        typeKeyword: 'キーワード',
        typeGreeting: '挨拶（最初のメッセージ）',
        typeAway: '不在（営業時間外）',
        keyword: 'キーワード',
        from: '開始時刻',
        to: '終了時刻',
        reply: '返信テキスト',
        add: 'ルールを追加',
        empty: '自動返信ルールはまだありません。',
        delete: '削除',
      },
    },
    webhooks: {
      title: 'Webhooks',
      subtitle: '外部サービスにリアルタイムのイベント通知を送信',
      webhook: 'Webhook',
      webhookTooltip: 'webhookを追加',
      send: 'サードパーティのウェブサイトにイベントを送信',
      webhookUrl: 'Webhook URL（POSTリクエスト）',
      error: '正しいリンクを入力してください',
      save: '変更を保存',
      enableWebhooks: 'Webhooksを有効化',
      enableDescription: '選択したイベントでPOSTリクエストを送信',
      endpointUrl: 'エンドポイントURL',
      endpointTooltip: '選択したイベントが発生したときにPOSTリクエストを受け取るURL',
      endpointPlaceholder: 'https://example.com/api/webhook',
      events: 'イベント',
      selectAll: 'すべて選択',
      deselectAll: 'すべて選択解除',
      filterPlaceholder: 'イベントを絞り込む...',
      all: 'すべて',
      none: 'なし',
      active: '有効',
      inactive: '無効',
      categories: {
        submissions: '送信',
        engagement: 'エンゲージメント',
      },
      eventLabels: {
        SubmitHeaderSubscribe: 'ヘッダー登録',
        SubmitHeaderMessage: 'ヘッダーメッセージ',
        SubmitDataCollect: 'データ収集',
        SubmitForm: 'フォーム送信',
        SubmitShop: 'ショップ注文',
        SubmitShopPreorder: 'ショップ予約注文',
        SubmitDigital: 'デジタル商品',
        SubmitAppointment: '予約',
        SubmitService: 'サービス注文',
        SubmitEvent: 'イベント登録',
        SubmitCourse: 'コース申し込み',
        SubmitDonation: '寄付',
        SubmitMembership: 'メンバーシップ',
        SubmitBlog: 'ブログ購入',
        SubmitCoupon: 'クーポン使用',
        SubmitTip: 'チップ',
        SubmitLink: 'リンク購入',
        SubmitProductMessage: '商品への質問',
        SubmitPodcast: 'ポッドキャスト購入',
        SubmitBooking: '予約',
        SubmitRental: 'レンタル',
        SubmitSingleProduct: '単一商品',
        SubmitDiscount: '割引注文',
        SubmitListing: '掲載リクエスト',
        SubmitUnlock: 'コンテンツのロック解除',
        SubmitChatAi: 'AIチャットメッセージ',
        ClickLink: 'リンククリック',
        ClickContact: '連絡先クリック',
        AddToCart: 'カートに追加',
        AddToCartSingleProduct: '単一商品をカートに追加',
        AddToWishlist: 'ウィッシュリストに追加',
        InitiateCheckout: '決済開始',
        DownloadFile: 'ファイルダウンロード',
        DownloadMusic: '音楽ダウンロード',
        CopyCoupon: 'クーポンをコピー',
        CopyDiscount: '割引をコピー',
        QR_ScanQrCode: 'QRコードスキャン',
        VisitPage: 'ページ訪問',
      },
    },
    sensitive: {
      title: 'センシティブな内容',
      subtitle: 'ウェブサイトを表示する前にセンシティブな内容の警告を表示します',
    },
    socialIntegration: {
      title: 'SNS連携',
      subtitle: 'Instagram、TikTokの連携を管理',
      connectInstagram: 'Instagramを接続',
    },
    emailIntegration: {
      title: 'オーディエンス連携',
      subtitle: '訪問者のメールアドレスをMailChimp、Replyに渡します',
      emailCaption: '連携を追加して、フォロワーのメールアドレスをMailChimpに渡しましょう',
      mailChimp: 'MailChimp連携',
      selzy: 'Selzy連携',
      selzyCaption: 'APIキーを追加して、フォロワーのメールアドレスをSelzyに渡しましょう',
      sendPulse: 'SendPulse連携',
      sendPulseCaption: 'APIキーを追加して、フォロワーのメールアドレスをSendPulseに渡しましょう',
      reply: 'Reply連携',
      replyCaption: 'APIキーを追加して、フォロワーのメールアドレスを次に渡します：',
      integrations: '連携',
    },
    calendarIntegration: {
      title: 'カレンダー連携',
      subtitle: 'カレンダーサービスを接続',
      calendly: 'Calendly',
      calendlyDescription: 'Calendlyを接続して、イベントタイプと空き状況を同期します',
      googleCalendar: 'Google Calendar',
      googleCalendarDescription: 'Google Calendarを接続して、イベントを同期しGoogle Meetリンクを作成します',
      zoom: 'Zoom',
      zoomDescription: 'Zoomを接続して、会議リンクを自動的に作成します',
      googleMeet: 'Google Meet',
      googleMeetDescription: 'Google Meetリンクを自動的に作成します（Google Calendarが必要）',
    },
    storage: {
      title: 'ストレージ',
      subtitle: '訪問者の注文をGoogle Spreadsheetに保存',
      storageCaption: '連携を追加して、すべての顧客の注文をGoogle Spreadsheetに保存しましょう',
      emailSignup: 'メール登録',
      emailSignupsCaption: 'メール登録を保存するテーブルを選択',
      formSignups: 'フォーム登録',
      forSignupsCaption: 'フォーム登録を保存するテーブルを選択',
      shopOrders: 'ショップ注文',
      shopOrderCaption: 'ショップ注文を保存するテーブルを選択',
      disconnect: 'スプレッドシートを接続解除',
      storageUsage: 'ストレージ使用量',
      of: '／',
      uses: 'このアプリは次を使用しています：',
      space: 'の空きディスク容量',
      view: '詳細を表示',
      noItems: 'アイテムはありません',
      files: 'ファイル',
      images: '画像',
      videos: '動画',
      audio: '音声',
      settings: '設定',
      free: '空き',
      needMoreSpace: 'もっと容量が必要ですか？',
      unlockStorage: '無制限ストレージと4K動画を解放',
      upgradePlan: 'プランをアップグレード',
      addFile: 'ファイルを追加',
      uploading: 'アップロード中...',
      dragDrop: 'またはここにドラッグ＆ドロップ',
      noFilesYet: 'ファイルはまだありません',
      noImagesYet: '画像はまだありません',
      noVideosYet: '動画はまだありません',
      noAudioYet: '音声はまだありません',
      filesHint: 'PDF、ドキュメント、その他のダウンロードをアップロードして、バイオページのリンクに添付しましょう。',
      imagesHint: '画像をアップロードして、バイオページ全体で使用しましょう。',
      videosHint: '動画をアップロードして、バイオページに埋め込みましょう。',
      audioHint: '音声トラックをアップロードして、バイオページで共有しましょう。',
    },
  },
  productStore: {
    title: 'Link in Bioにストアタブを表示',
    subtitle: '現在ストアは非表示になっています。',
  },
  sections: {
    splashScreen: {
      title: 'スプラッシュ画面',
      subtitle: 'ページの読み込み中に表示されます',
    },
    promo: {
      title: 'プロモバー',
      subtitle: 'プロモーションを表示できるハイライト',
      masterPromoMessage: '現在マスタープロモバーが有効になっています。このページ用にカスタムプロモバーを作成する場合は、まずマスタープロモバーを無効にする必要があります。',
      titlePlaceholder: '私のウェブサイトへようこそ！',
      switcherIsMasterPromobar: 'すべてのページに表示',
    },
    contact: {
      title: '連絡先',
      subtitle: 'あなたと連絡を取る手段を提供',
      caption: 'メッセンジャーボタンを追加して、あなたと顧客がワンクリックで素早くつながれるようにしましょう',
      tooltip: '連絡先を使うと、ユーザーがあなたと直接連絡を取れます。電話、メール、メッセンジャー、所在地を追加しましょう',
      addNewContact: '新しい連絡先を追加',
      addContact: '連絡先を追加',
      chooseContact: '連絡先を選択',
      enterLink: '連絡先のリンクを入力',
      showDetails: '詳細を表示',
      enterAnyContact: 'いずれかの連絡先を入力してください',
      enterAnyContactCaption: '（WhatsApp、Telegram、Viber、Messenger）',
    },
    membership: {
      title: 'メンバーシップ',
      subtitle: 'コンテンツへの無料または有料のサブスクリプションを作成',
      addNewTier: '新しいティアを追加',
      editTier: 'ティアを編集',
      name: '名前',
      nameCaption: 'ティアの名前を入力',
      price: '月額料金',
      priceCaption: 'ティアの料金を入力',
      month: '月',
      image: '画像',
      imageCaption: 'ティア用の画像をアップロード',
    },
    pricing: {
      title: '料金',
      subtitle: '価格付きのメニューを作成',
      add: '新しいアイテムを追加',
      edit: 'アイテムを編集',
      name: '名前',
      nameCaption: 'アイテムの名前を入力',
      duration: '属性',
      durationCaption: 'アイテムの時間、数量、または期間を入力',
      category: 'カテゴリ',
      categoryCaption: 'アイテムのカテゴリを入力',
      price: '価格',
      priceCaption: 'アイテムの価格を入力',
      month: '月',
      image: '画像',
      imageCaption: 'アイテム用の画像をアップロード',
    },
    subscribe: {
      dataCollectTitle: 'データ収集',
      title: '登録',
      subtitle: '訪問者からメールや電話番号を収集',
      instructionsMessage: 'ページにメール登録フィールドを追加して、訪問者が簡単に登録できるようにしましょう！',
      instructionsLink: 'メールをMailChimpに渡してマーケティングキャンペーンを実施しましょう。',
      sectionHeaderCaption: 'ニュースレターを購読',
      collecting: '収集',
      collectingCaption: '入力のタイプを選択',
      addDataToCollect: '収集するデータを追加',
      email: 'メール',
      enterEmail: 'メールを入力',
      thanksForEmail: 'メールをありがとうございます',
      phone: '電話番号',
      telegram: 'Telegram',
      facebook: 'Facebook',
      instagram: 'Instagram',
      twitter: 'X (Twitter)',
      youtube: 'Youtube',
      whatsapp: 'Whatsapp',
      viber: 'Viber',
      messenger: 'Messenger',
      modalTitle: '更新されたリンクを追加',
      placeholder: 'プレースホルダー',
      placeholderCaption: 'プレースホルダーのテキストを入力',
      button: 'ボタン',
      buttonCaption: '訪問者にメール入力を促すテキスト（10%オフ割引、今すぐ登録、ファイルをダウンロードなど）',
      submitButton: '送信ボタン',
      enterButton: 'ボタンを入力',
      thanksMessage: 'お礼メッセージ',
      thanksMessageCaption: '購読者へのお礼メッセージ',
      resultAction: 'アクション（送信後）',
      resultActionCaption: 'フォーム記入後のアクション',
      sendAnEmail: 'メールを送信',
      downloadFile: 'ファイルをダウンロード',
      redirect: 'リダイレクト',
      messageBody: 'メッセージ本文',
      messageBodyCaption: 'このデータは、メールの特典（クーポン、ファイルダウンロードリンクなど）としてユーザーのメールに送信されます',
      integration: '連携',
      integrationCaption: '訪問者のメールアドレスをMailChimp、Replyに渡します',
      storage: 'ストレージ',
      storageCaption: '訪問者の注文をGoogle Spreadsheetに保存',
      maxSize: 'チャンネルは最大3つまで追加できます',
    },
    text: {
      title: 'テキスト',
      subtitle: '自分や会社について自由に記入',
      trimBio: 'テキストを省略',
    },
    header: {
      title: 'ヘッダー',
      subtitle: 'ページ上の拡大された注目画像または動画',
      verifiedBadge: '認証バッジ',
      showProfilePic: 'プロフィール画像を表示',
      profilePicRatio: '比率',
      profilePicRatioSquare: '正方形',
      profilePicRatioLandscape: '横長',
      profilePicRatioPortrait: '縦長',
      verticalCropStep: '縦長写真',
      squareCropStep: '正方形アバター',
      namePlaceholder: 'あなたの名前',
      shortBioPlaceholder: '私の短い紹介',
      externalLinkPlaceholder: 'URL',
      locationPlaceholder: '都市',
      addSocial: '+ SNSを追加',
      addCover: '+ カバーを追加',
      addButton: '+ ボタンを追加',
      topButtons: '上部ボタン',
      bottomButtons: '下部ボタン',
      buttonSubtitleLanguage: '言語切り替え',
      buttonSubtitleContact: '電話 / メッセージ',
      buttonSubtitleCart: 'ショッピングカート',
      buttonSubtitleCta: '行動喚起',
      buttonSubtitleMessage: 'メッセージ',
      buttonSubtitleSubscribe: '登録',
      buttonSubtitleQrcode: 'QRコード',
      buttonSubtitleSearch: '商品検索',
      buttonDisabledHint: '非表示 · 無効',
      addText: '+ テキストを追加',
      addLabel: '+ ラベルを追加',
      subtitleName: '名前の表示をカスタマイズ',
      subtitleShortBio: '短い自己紹介の表示をカスタマイズ',
      shortBioSize: '短い自己紹介のサイズ',
      subtitleShortBioSize: '短い自己紹介のサイズを変更できます',
      subtitleLocation: '市区町村/国を設定して、訪問者を特定の場所へ案内しましょう',
      headerCoverWarningMessage: 'お使いのブラウザは動画タグに対応していません。',
      headerCoverTitle: 'ヘッダーの上にカバーを設定',
      coverHeight: 'カバーの高さ',
      subtitleCoverHeight: 'カバーの高さを変更できます',
      coverDarkness: 'カバーの暗さ',
      subtitleCoverDarkness: 'スライダーをドラッグしてカバー画像を暗くする',
      nameSize: '名前のサイズ',
      subtitleNameSize: '名前のサイズを変更できます',
      positionText: '名前の位置',
      subtitlePositionName: 'スライダーをドラッグして名前の位置を設定',
      positionContent: 'コンテンツの位置',
      subtitlePositionContent: '自己紹介、リンク、所在地の位置を設定',
      coverText: 'カバー上のテキスト',
      subtitleCoverText: 'カバーにテキストを追加',
      position: '位置',
      subtitlePosition: 'スライダーをドラッグしてボタンの位置を設定',
      buttonCover: 'カバー上のボタン',
      subtitleButtonCover: 'アクションを選んでカバーにボタンを追加',
      subtitleFollow: 'フォローボタンでユーザーがあなたのニュースをフォローできます',
      buttonOpacity: 'スライダーをドラッグしてボタンの不透明度を変更',
      subtitleCart: 'ショッピング体験を提供するカートアイコン',
      subtitleDirect: '訪問者をメッセンジャーへ案内するクイックボタン',
      subtitleCTAButton: 'ユーザーのクリックを促す（行動喚起）ボタン',
      subtitleSocialLinks: 'SNSを見た目よく整えましょう',
      chooseSocialLink: 'SNSリンクを選択',
      alignSocialLink: 'SNSリンクの配置',
      enterYourSocialLink: 'SNSリンクを入力',
      blockShadow: 'ブロックの影',
      activeButtonPosition: 'アクティブボタンの位置',
      gradientColor: 'グラデーションの色',
      bottomGradient: '下部グラデーション',
      autoGradient: '自動',
      customGradient: 'カスタム',
      transparentGradient: '透明',
      gradientPositionLabel: '影の位置',
      gradientPositionPhoto: '写真の下',
      gradientPositionHeader: 'ヘッダー内の下部',
      uploadLogo: 'ロゴをアップロード',
      customBackground: 'カスタム背景',
      headingLabel: '見出しラベル',
      customizeLabel: '見出しラベルの表示をカスタマイズ',
      labelText: 'ラベルのテキスト',
      enterLabelText: '見出しラベルのテキストを入力',
      bottomBadge: '下部の色合い',
      addTint: '色合いを追加',
      bottomBadgeText: 'テキスト（任意）',
      bottomBadgePreset: 'プリセット',
      bottomBadgeShape: '形状',
      bottomBadgeSize: '高さ',
      bottomBadgeAction: 'アクション',
      bottomBadgeBgColor: '背景色',
      bottomBadgeTextColor: 'テキストの色',
      bottomBadgeGradientFrom: 'グラデーション開始色',
      bottomBadgeGradientTo: 'グラデーション終了色',
      bottomBadgeGradientAngle: 'グラデーションの角度',
    },
  },
  billingHistory: {
    title: '請求履歴',
    invoices: '請求書',
    messageText: '支払い履歴はまだありません。',
  },
  migrate: {
    title: 'LinkTreeやTaplinkをお使いですか？',
    text: 'リンクを貼り付けて、ワンクリックでUniLinkに移行しましょう！',
    button: '移行',
  },
  pages: {
    title: 'ページ',
    addPage: 'ページを追加',
    addNewPage: '新しいページを追加',
    deleteTitle: 'このページを削除してもよろしいですか？',
    managePage: 'タブを管理',
    empty: 'このページにはまだブロックがありません。',
    dragAndDrop: '他のタブをドラッグ＆ドロップして並べ替えましょう',
    pageNavigation: 'ページナビゲーション設定',
    goToDesign: 'デザイン設定へ移動',
    viewArchive: 'アーカイブを表示',
    archivedBlocks: 'アーカイブされたブロック',
    noArchivedBlocks: '現在使っていないブロックをアーカイブして、ページをすっきりと保ちましょう。',
    archiveAllUnpublished: '未公開のブロックをすべてアーカイブ',
    restore: '復元',
    permanentDelete: '完全に削除',
  },
  analytics: {
    lifeTimeAnalytics: '累計アナリティクス',
    impressions: 'インプレッション',
    impressionsText: '選択した期間のインプレッション統計のパフォーマンス',
    clicks: 'クリック',
    clicksText: '選択した期間の「クリック」イベントのパフォーマンス',
    signUps: 'サインアップ',
    signUpsText: '選択した期間の「クローズ」イベントのパフォーマンス',
    totalInteractions: '総インタラクション',
    totalInteractionsText: '選択した期間のクリックとフォーム登録の合計',
    engagementRate: 'エンゲージメント率',
    engagementRateText: 'インタラクションにつながったプロフィール表示の割合',
    visitor: '訪問者のソース',
    country: '国',
    countries: '国',
    linkClicks: 'リンククリック',
    content: 'コンテンツ',
    views: '表示回数',
    links: 'リンク',
    products: '商品',
    blocks: 'ブロック',
    pages: 'ページ',
    clicksLower: 'クリック',
    of: '／',
    noContentData: '選択した期間のデータはまだありません',
  },
  aiInsights: {
    title: 'AIインサイト',
    generate: 'プロフィールを分析',
    description: 'AIによる推奨事項を取得して、プロフィールのパフォーマンスを改善しましょう。',
    analyzing: 'プロフィールを分析中...',
    refresh: '更新',
    action: 'アクション',
  },
  post: {
    subscriptionTypePlaceholder: '「type」以上のサブスクリプションで利用可能',
    postButtonText: '投稿',
    newPostPlaceholder: '何を考えていますか',
    free: '無料',
    pro: 'Pro',
    premium: 'Premium',
    noPost: '投稿はまだありません',
    editPost: '投稿を編集',
  },
  preview: {
    buy: '購入',
    connect: '接続',
  },
  activeButton: {
    initialText: 'ウェブサイト',
    inputPlaceholder: 'アクションを検索...',
    existing: '既存',
    redirect: 'リダイレクト',
    scroll: 'スクロール',
    title: 'アクティブボタン',
    modalTitle: 'アクティブボタンのアクション',
    subtitle: 'ユーザーのアクションを促すボタン',
    next: '次へ',
    save: '保存',
    opensALinkFromLinksBlock: 'リンクブロックからリンクを開く',
    url: 'URL',
    opensAWebsite: 'ウェブサイトを開く',
    openInApp: 'アプリで開く',
    addAction: 'アクションを追加',
    actionTitle: 'アクション',
    actionCaption: 'アクションタイプを編集',
    chooseOption: 'オプションを選択',
    tellPeople: 'アクションボタンの使い方を伝えましょう',
    urlRedirect: 'URLリダイレクト',
    customUrl: 'カスタムURL',
    customUrlText: 'ウェブサイトを開く',
    links: 'リンク',
    linksText: 'リンクブロックからリンクを開く',
    downloadDocument: 'ドキュメントをダウンロード',
    sendEmail: 'メールを送信',
    opensEmailClient: 'メールクライアントを開く',
    phoneCall: '電話をかける',
    initiatesPhoneCall: '電話発信を開始',
    navigation: 'ナビゲーション',
    openPage: 'ページを開く',
    opensInternalPage: '内部ページを開く',
    openPageText: '内部ページを開く',
    openProduct: '商品を開く',
    openProductText: 'ストアから商品ページを開く',
    openBlog: 'ブログを開く',
    opensBlogPageFromStore: 'ストアからブログページを開く',
    openBlock: 'ブロックを開く',
    opensContentBlock: 'コンテンツブロックを開く',
    openItem: 'アイテムを開く',
    opensItemPageFromStore: 'ストアからアイテムページを開く',
    showNewModal: '新しいモーダルを表示',
    displayContentInModalWindow: 'モーダルウィンドウにコンテンツを表示',
    showProduct: '商品を表示',
    displayProductInModalWindow: 'モーダルウィンドウに商品を表示',
    showBlog: 'ブログを表示',
    scrollToBlock: 'ブロックへスクロール',
    scrollToBlockText: '指定したページブロックへスクロール',
    scrollToItem: 'アイテムへスクロール',
    action: 'アクション',
    showBlock: 'ブロックを表示',
    showBlockText: 'ストアのコンテンツブロック',
    showItem: 'アイテムを表示',
    showItemText: 'ストアからアイテムページを開く',
    linksCaption: 'リンク',
    linksTooltip: 'リンクブロックからリンクを選択',
    pagesCaption: 'ページ',
    pagesTooltip: 'ページから選択',
    productsCaption: '商品',
    productsTooltip: 'リストから商品を選択',
    blocksCaption: 'ブロック',
    blocksTooltip: 'リストからブロックを選択',
    itemsCaption: 'アイテム',
    itemsTooltip: 'リストからアイテムを選択',
    showProductText: 'ページ上のモーダルウィンドウに商品を表示',
    more: 'もっと見る',
    less: '表示を減らす',
    showNewModalTitle: '新しいモーダルのデータ',
    uploadDocumentTitle: 'クリックしてアップロードするか、ドラッグ＆ドロップ',
    uploadProgressTitle: 'アップロード中...',
    haveNoModal: 'モーダルがありません',
    haveModal: 'モーダルを選択しました',
    openNewModalHandler: '新しいモーダルを作成',
    linkGroupSubTitle: 'ブロックを選択',
    linkItemSubTitle: 'リンクを選択',
    urlItemSubTitle: 'ウェブサイトのURL',
    openInAppItemSubTitle: 'アプリのURL',
    sendEmailItemSubTitle: 'メールアドレス',
    phoneCallItemSubTitle: '電話番号',
    openPageGroupSubTitle: 'ページを選択',
    openPageItemSubTitle: 'ページを選択',
    openProductGroupSubTitle: '商品タイプを選択',
    openProductItemSubTitle: '商品を選択',
    openBlogGroupSubTitle: 'ブログチャンネルを選択',
    openBlogItemSubTitle: 'ブログ記事を選択',
    openBlockGroupSubTitle: 'ページを選択',
    openBlockItemSubTitle: 'ブロックを選択',
    openItemGroupSubTitle: 'ブロックを選択',
    openItemItemSubTitle: 'アイテムを選択',
    showProductGroupSubTitle: '商品タイプを選択',
    showProductItemSubTitle: '商品を選択',
    showBlogGroupSubTitle: 'ブログチャンネルを選択',
    showBlogItemSubTitle: 'ブログ記事を選択',
    showBlockGroupSubTitle: 'ページを選択',
    showBlockItemSubTitle: 'ブロックを選択',
    showItemGroupSubTitle: 'ブロックを選択',
    showItemItemSubTitle: 'アイテムを選択',
    scrollToBlockGroupSubTitle: 'ページを選択',
    scrollToBlockItemSubTitle: 'ブロックを選択',
    scrollToItemGroupSubTitle: 'ブロックを選択',
    scrollToItemItemSubTitle: 'アイテムを選択',
    linkGroupPlaceholder: 'ブロックを選択...',
    linkItemPlaceholder: 'リンクを選択...',
    openPageItemPlaceholder: 'ページを選択...',
    openProductGroupPlaceholder: '商品タイプを選択...',
    openProductItemPlaceholder: '商品を選択...',
    showProductGroupPlaceholder: '商品グループを選択...',
    showProductItemPlaceholder: '商品を選択...',
    openBlogGroupPlaceholder: 'ブログチャンネルを選択...',
    openBlogItemPlaceholder: 'ブログ記事を選択...',
    openBlockGroupPlaceholder: 'ページを選択...',
    openBlockItemPlaceholder: 'ブロックを選択...',
    openItemGroupPlaceholder: 'ページとブロックを選択...',
    openItemItemPlaceholder: 'アイテムを選択...',
    showBlogGroupPlaceholder: 'ブロググループを選択...',
    showBlogItemPlaceholder: 'ブログ投稿を選択...',
    showBlockGroupPlaceholder: 'ページを選択...',
    showBlockItemPlaceholder: 'ブロックを選択...',
    showItemGroupPlaceholder: 'ページとブロックを選択...',
    showItemItemPlaceholder: 'アイテムを選択...',
    scrollToBlockGroupPlaceholder: 'ページを選択...',
    scrollToBlockItemPlaceholder: 'ブロックを選択...',
    scrollToItemGroupPlaceholder: 'ページとブロックを選択...',
    scrollToItemItemPlaceholder: 'アイテムを選択...',
    linkReadable: 'リンク',
    urlReadable: 'URL',
    openInAppReadable: 'アプリで開く',
    downloadDocumentReadable: 'ドキュメントをダウンロード',
    sendEmailReadable: 'メールを送信',
    phoneCallReadable: '電話をかける',
    openPageReadable: 'ページを開く',
    openProductReadable: '商品を開く',
    showNewModalReadable: '新しいモーダルを表示',
    showProductReadable: '商品を表示',
    openBlogReadable: 'ブログを開く',
    openBlockReadable: 'ブロックを開く',
    openItemReadable: 'アイテムを開く',
    showBlogReadable: 'ブログを表示',
    showBlockReadable: 'ブロックを表示',
    showItemReadable: 'アイテムを表示',
    scrollToBlockReadable: 'ブロックへスクロール',
    scrollToItemReadable: 'アイテムへスクロール',
  },
  design: {
    textColorHint: 'このブロックの本文の色です。見出しには独自の色があります。',
    tabs: 'タブ',
    imageView: '画像表示',
    preview: 'プレビュー',
    buttonOpacity: 'ボタンの不透明度',
    buttonBorder: 'ボタンの枠線',
    buttonShadow: 'ボタンの影',
    itemView: 'アイテム表示',
    itemViewTooltip: 'アイテム表示を選択',
    itemLayout: 'アイテムレイアウト',
    itemLayoutTooltip: 'アイテムレイアウトを選択',
    top: '上',
    center: '中央',
    bottom: '下',
    bottomLeft: '左下',
    bottomHorizontal: '下部横並び',
    under: '下',
    title: 'タイトル',
    titleButton: 'タイトルとボタン',
    displayOptions: '表示オプション',
    displayOptionsTooltip: '表示オプションを選択',
    landscape: '横長',
    square: '正方形',
    portrait: '縦長',
    desktopMode: 'デスクトップモード',
    mobile: 'コンパクト',
    desktop: 'ワイド',
    responsive: 'レスポンシブ',
    custom: 'カスタム',
    templates: 'テンプレート',
    chooseTemplates: 'テンプレートを選択',
    viewAll: 'すべて表示',
    previousTheme: '以前のテーマは完全に消去されますのでご注意ください。',
    useThisTemplate: 'このテンプレートを使用',
    notSupportedVideo: 'お使いのブラウザは動画タグに対応していません。',
    photosBy: '写真提供',
    animationBy: 'アニメーション提供',
    searchTheSame: '同じ語句を再度検索すると別の結果が表示されます。',
    addImage: '画像を追加',
    addVideo: '動画を追加',
    orSelectFrom: 'または次から選択',
    noImagesYet: '画像はまだありません',
    noVideosYet: '動画はまだありません',
    videoBy: '動画提供',
    hamburgerMenu: 'ハンバーガーメニュー',
    menuContent: 'メニューの内容',
    menuShowContacts: '連絡先を表示',
    menuShowAddress: '住所を表示',
    menuAddress: '住所',
    menuAddressCaption: '空欄の場合は連絡先ブロックから取得します',
    menuShowCta: 'ボタンを表示',
    menuCtaText: 'ボタンのテキスト',
    menuCtaCaption: '空欄の場合はヘッダーのボタンを使用します',
    menuCtaUrl: 'ボタンのリンク',
    menuShowSocials: 'SNSを表示',
    tabsOnTop: 'タブを上に',
    tabsOnBottom: 'タブを下に',
    borderType: '枠線のタイプ',
    subTitle: '形状、枠線タイプ、影などを選択',
    icon: 'アイコン',
    iconTooltip: 'ボタンに合ったアイコンを選択',
    background: '背景',
    color: '色',
    backgroundOpacity: '背景の不透明度',
    backgroundOpacityTooltip: 'スライダーをドラッグして背景の不透明度を設定',
    gradient: 'グラデーション',
    color1: '色 1',
    color2: '色 2',
    direction: '方向',
    directionTooltip: 'スライダーをドラッグしてグラデーションの方向を設定',
    offset: 'オフセット',
    offsetTooltip: 'スライダーをドラッグしてグラデーションのオフセットを設定',
    minHeight: '最小の高さ',
    minHeightTooltip: 'スライダーをドラッグしてボタンの最小の高さを変更',
    align: '配置',
    alignTooltip: 'ボタンの位置を変更',
    insert: 'URLを挿入',
    upload: '動画をアップロード',
    search: '動画を検索',
    layout: 'レイアウト',
    layoutTooltip: '希望のレイアウトを選択',
    view: '表示',
    viewTooltip: '希望の表示を選択',
    media: 'メディア',
    mediaTooltip: '希望のメディアを選択',
    none: 'なし',
    small: '小',
    medium: '中',
    large: '大',
    round: '丸',
    feed: 'フィード',
    slider: 'スライダー',
    text: 'テキスト',
    colorTooltip: '色を選択',
    button: 'ボタン',
    buttonTooltip: 'ボタンの色を選択',
    chooseEmoji: '絵文字を選択',
    changeEmoji: '絵文字を変更',
    quantum: 'クォンタム',
    emoji: '絵文字',
    warp: 'ワープ',
  },
  components: {
    quickAdd: {
      addLink: 'リンクを追加',
      addVideo: '動画を追加',
      addProduct: '商品を追加',
      addPost: '投稿を追加',
      addArticle: '記事を追加',
      addPhoto: '写真を追加',
      addMusic: '音楽を追加',
      addFiles: 'ファイルを追加',
      addStory: 'ストーリーを追加',
    },
    emoji: {
      search: '検索',
      clear: 'クリア',
      notfound: '絵文字が見つかりません',
      skintext: 'デフォルトの肌の色を選択',
      categories: {
        search: '検索結果',
        recent: 'よく使う絵文字',
        smileys: 'スマイリーと感情',
        people: '人と体',
        nature: '動物と自然',
        foods: '食べ物と飲み物',
        activity: 'アクティビティ',
        places: '旅行と場所',
        objects: '物',
        symbols: '記号',
        flags: '旗',
        custom: 'カスタム',
      },
      categorieslabel: '絵文字カテゴリ',
      skintones: {
        1: 'デフォルトの肌の色',
        2: '明るい肌の色',
        3: 'やや明るい肌の色',
        4: '中間の肌の色',
        5: 'やや濃い肌の色',
        6: '濃い肌の色',
      },
    },
    blogPreviewModal: {
      title: 'ブログプレビュー',
      notify: '購読者に通知',
    },
    standAloneModal: {
      title: 'リンクプレビュー',
      save: '保存',
      chooseLayout: 'リンクのレイアウトを選択',
      linkSettings: 'リンク設定',
      linkSettingsSubtitle: 'リダイレクト、表示',
      whenVisitorsClicks: '訪問者がこのリンクをクリックしたとき：',
      redirect: 'リダイレクト',
      redirectText: '訪問者を直接URLに送る',
      highlight: 'ハイライト',
      highlightText: '訪問者をUniLinkに送りハイライトする',
      standalone: 'スタンドアロン',
      standaloneText: 'YouTubeリンクを目立たせ、コンテンツをその場で再生',
      cover: 'カバー',
      imageTab: '画像',
      videoTab: '動画',
      uploadImage: '画像をアップロード',
      whenVisitors: '訪問者が共有リンクを選択したとき：',
      compact: 'コンパクト表示',
      fullView: 'フル表示',
      videoSound: '音声付きで動画を再生',
    },
    instagramModal: {
      title: 'Instagram DMを自動送信',
      subtitle: '誰かがあなたのIG投稿やReelにコメントしたときに、このリンクをダイレクトメッセージで送信します',
      promo: '送信元のIGを選択してください',
      connect: 'Instagramアカウントを接続',
      added: 'Instagramアカウントを追加しました',
      addNew: '新しい自動化を追加',
      igContent: 'IGコンテンツ',
      trigger: 'トリガー',
      dmContent: 'DM',
      linkDestination: 'リンク先',
      buttonTitle: 'ボタンのタイトル',
      buttonTitleTooltip: 'ボタンのタイトルを入力',
      directMessage: 'ダイレクトメッセージ',
      directMessageTooltip: 'ダイレクトメッセージを入力',
      selectPosts: '自動DMのトリガーとなる投稿またはReelを選択してください。',
      onePost: '特定の1件の投稿またはReel',
      allPosts: 'すべての投稿またはReel',
      triggerText: 'コメントにこれが含まれると、DMが送信されます。',
      addMessage: 'リンクと一緒に自動送信するメッセージを追加します。',
      clickLink: '誰かがDM内のリンクをクリックしたとき：',
      anyComment: 'すべてのコメント',
      storiesAndDms: 'ストーリーとDM',
      anyMessage: 'すべてのメッセージ',
      specificKeywords: '特定のキーワードを含むコメント',
      sendLink: '訪問者をUniLinkに送りハイライトする ',
      skipLink: 'UniLinkをスキップして直接送る',
      keywordsTitle: '特定のキーワードを含むコメント',
      keywordsText: 'コメントに特定のキーワードが含まれる、または除外される場合にDMが送信されます（大文字小文字は区別されません）：',
      keywordsPlaceholder: 'キーワードを入力',
      keywordsExclude: '除外するキーワード',
      keywordsExcludeText: 'これらのいずれかを除外する必要があります',
      replyComment: '返信コメント',
      replyCommentTooltip: '返信コメントを入力',
    },
    blockEditProduct: {
      productPreview: 'サムネイル',
      productDetails: '詳細',
      settings: '設定',
      design: 'デザイン',
    },
    editMenuItems: {
      overview: '概要',
      analytics: 'アナリティクス',
    },
    botToken: {
      bot: 'ボット',
      botTooltip: 'ボットのトークンを入力',
      connect: '接続',
      token: 'トークン',
    },
    rewards: {
      title: 'タイトル',
      titleTooltip: '応答のタイトルを入力',
      text: 'テキスト',
      textTooltip: '応答のテキストを入力',
      link: 'リンク',
      linkTooltip: '応答のリンクを入力',
      code: 'コード',
      codeTooltip: '応答のコードを入力',
      files: 'ファイル',
      filesTooltip: '応答のファイルを入力',
      removeReward: 'この応答を削除してもよろしいですか？',
    },
    addRewardModal: {
      addReward: '応答を追加',
      textTitle: 'テキスト',
      textText: 'リッチエディタで手順や任意のテキストへのアクセスを提供',
      fileTitle: 'ファイル',
      fileText: 'ファイルへのアクセスを提供し、連絡先情報を収集',
      linkTitle: 'リンク',
      linkText: '限定コンテンツへのアクセスを提供し、連絡先情報を収集',
      codeTitle: 'コード',
      codeText: '限定プロモーションへのアクセスを提供し、連絡先情報を収集',
    },
    blockEmpty: {
      isNotAdded: 'が追加されていません',
      itSeems: 'あなたの',
      itemsNot: 'アイテムがまだ追加されていないようです。今すぐ動画を追加しましょう',
      add: '追加',
    },
    blockList: {
      add: '追加',
      item: 'アイテム',
    },
    submitAction: {
      action: 'アクション（送信後）',
      actionTooltip: '送信後のアクションを選択',
      upload: '添付ファイルをアップロード',
      none: 'なし',
      page: '確認ページを表示',
      email: '確認メールを送信',
      redirect: 'URLにリダイレクト',
    },
    blockEditItem: {
      content: 'コンテンツ',
      preview: 'プレビュー',
      settings: '設定',
    },
    domainButton: {
      customizeDomain: 'ドメインをカスタマイズしましょう。',
      upgradeToLink: 'Link in Bio Proにアップグレードして、カスタムドメインを使いましょう。',
    },
    coverText: {
      text: 'テキスト',
      textTooltip: 'カバーのテキストを入力',
      description: '説明',
      descriptionTooltip: 'カバーの説明を入力',
      textColor: 'テキストの色',
    },
    itemModal: {
      edit: '編集',
      addNew: '新規追加',
      item: 'アイテム',
      update: '更新',
      add: '追加',
    },
    productSheet: {
      openFullEditor: 'フル編集画面を開く',
      copyLink: 'リンクをコピー',
      active: '有効',
      notActive: '無効',
      statistics: '統計',
      clicks: 'クリック',
      sales: '販売数',
      revenue: '売上',
      onlyName: '必須は名前だけです',
      name: '名前',
      required: '必須',
      price: '価格',
      optional: '任意',
      free: '無料',
      appearance: '外観',
      cover: 'カバー画像',
      coverNote: '正方形、600×600 以上。あとから追加できます。',
      description: '説明',
      descriptionPlaceholder: '内容を一行で',
      remove: '削除',
      photo: '写真',
      enterName: '名前を入力',
      adding: '追加中…',
    },
    viewDesign: {
      compact: 'コンパクト',
      card: 'カード',
      button: 'ボタン',
      list: 'リスト',
      hero: 'ヒーロー',
      featured: '注目',
    },
    moveItemModal: {
      title: 'アイテムを別のページに移動',
      cancel: 'キャンセル',
      move: '移動',
      page: 'ページ',
      pageTooltip: 'アイテムを移動するページを選択',
      blocks: 'ブロック',
      blocksTooltip: 'アイテムを移動するブロックを選択',
      emptyBlocks: 'このページには必要なブロックがありません。',
    },
    limitModal: {
      title: '上限に達しました',
      text1: 'サイトの上限に達しました。',
      text2: 'プランをアップグレードするにはお問い合わせください。',
      close: '閉じる',
    },
    cropPicture: {
      title: '画像を切り抜く',
      cancel: 'キャンセル',
      save: '保存',
    },
    uploadFile: {
      uploadProductImage: '商品画像をアップロード',
      coverImage: 'カバー画像',
      uploadImages: 'ここには画像のみアップロードできます',
    },
    userMediaLibrary: {
      addImage: '画像を追加',
      uploadImage: '画像をアップロード',
      orSelectFrom: 'またはアップロード',
      orSelectLink: 'またはリンクを貼り付け',
      myMedia: 'マイメディア',
      stockImages: 'ストック画像',
      gifs: 'GIF',
      icons: 'アイコン',
      noImagesYet: '画像はまだありません',
      loadMore: 'もっと読み込む',
    },
    itemMenu: {
      active: '有効',
      willBeAvailable: 'アイテムは次の日時に利用可能になります：',
      save: '保存',
      copied: 'コピーしました',
      copyLink: 'リンクをコピー',
      delete: '削除',
    },
    itemDesign: {
      linkColor: 'リンクの色',
      gradient: 'グラデーション',
      background: '背景',
      backgroundOpacity: '背景の不透明度',
      backgroundOpacityTooltip: 'スライダーをドラッグして背景の不透明度を設定',
      backgroundDarkness: '背景の暗さ',
      backgroundDarknessTooltip: 'スライダーをドラッグして背景の暗さを設定',
      text: 'テキスト',
      color1: '色 1',
      color2: '色 2',
      direction: '方向',
      directionTooltip: 'スライダーをドラッグしてグラデーションの方向を設定',
      offset: 'オフセット',
      offsetTooltip: 'スライダーをドラッグしてグラデーションのオフセットを設定',
      linkHeight: 'リンクの高さ',
      linkHeightTooltip: 'スライダーをドラッグしてボタンの高さを変更',
      icon: 'アイコン',
      iconTooltip: 'ボタンのアイコンを選択',
      imageShape: '画像の形状',
      imageShapeTooltip: 'リンクの画像の形状を選択',
    },
    menu: {
      linkInBio: 'Link in Bio',
      linkInBioApps: 'Link in Bio',
      posts: '投稿',
      audience: 'オーディエンス',
      orders: '注文',
      marketing: 'マーケティング',
      emailMarketing: 'メールマーケティング',
      socialPlanner: 'ソーシャルプランナー',
      shortLinks: '短縮リンク',
      businessCards: '名刺',
      emailSignatures: 'メール署名',
      virtualBackgrounds: 'バーチャル背景',
      recentProfiles: '最近のプロフィール',
      standalonePage: 'スタンドアロンページ',
      soloApps: 'App in Bio',
      bots: 'ボット',
      smartReply: 'Instagram Reply',
      analytics: 'アナリティクス',
      settings: '設定',
      shop: '収益化',
      publish: '公開',
      studio: 'スタジオ',
      blog: 'ブログ',
      qrCodes: 'QRコード',
      singlePages: 'アプリ',
      forms: 'フォーム',
      form: 'フォーム',
      automations: '自動化',
      community: 'コミュニティ',
      messages: '受信トレイ',
      agents: 'エージェント',
      apps: 'アプリ',
    },
    notificationsBlockSetting: {
      title: '通知',
      setUp: '設定',
      notifications: '通知',
      connect: '接続',
      telegramText: '誰かが次を行ったときにTelegram通知を受け取る：',
      change: '変更',
      email: 'メール',
      emailText: '誰かが次を行ったときにメールを受け取る：',
      webhook: 'Webhook',
      webhookTooltip: 'webhookを追加',
      activate: '有効化',
      webhookText: '誰かが次を行ったときにサードパーティのウェブサイトにイベントを送信：',
      webhookURL: 'Webhook URL（POSTリクエスト）',
      error: '正しいリンクを入力してください',
      save: '保存',
    },
    navigation: {
      content: 'コンテンツ',
      pages: 'ページ',
      posts: '投稿',
      shop: 'ストア',
      blog: 'ブログ',
      design: 'デザイン',
      analytics: 'アナリティクス',
      settings: '設定',
      apps: 'アプリ',
      store: 'ストア',
    },
    headerSettings: {
      design: 'デザイン',
      analytics: 'アナリティクス',
      settings: '設定',
      editTabs: 'タブを編集',
    },
    unlockModal: {
      title: 'Pro機能を解放',
      text: 'Link in Bioをもっと活用しましょう。月額わずか$5でProのすべての機能を解放：',
      checkBoxTitle1: 'ブロックが増える：',
      checkBoxText1: 'フォーム、ストア、カウントダウン、メディアプレーヤーを追加',
      checkBoxTitle2: '高度なアナリティクス：',
      checkBoxText2: 'クリック、表示、オーディエンスのインサイトを追跡',
      checkBoxTitle3: 'カスタムドメイン：',
      checkBoxText3: '自分のドメインを使ってプロフェッショナルな見た目に',
      checkBoxTitle4: '組み込みストア：',
      checkBoxText4: '商品を簡単に販売し注文を管理',
      checkBoxTitle5: 'SEOツール：',
      checkBoxText5: 'メタタグ、UTM、カスタムスラッグで上位表示',
      checkBoxTitle6: '連携：',
      checkBoxText6: 'Mailchimp、Zapier、その他のツールと同期',
      checkBoxTitle7: 'メールマーケティング：',
      checkBoxText7: 'リードを収集し自動キャンペーンを送信',
      checkBoxTitle8: '優先サポート：',
      checkBoxText8: '必要なときにより迅速なサポートを受けられる',
      upgradeToPro: 'Proにアップグレード',
      viewAllPlans: 'すべてのプランを表示',
    },
    profileSwitcher: {
      title: 'すべてのプロフィール',
      button: '新しいプロフィールを追加',
    },
    account: {
      signOut: 'サインアウト',
      createNew: '新しいLink in Bioを作成',
      tryPro: '今すぐProを試す！',
      tryProText: '高度なカスタマイズと詳細なオーディエンスインサイトで、より多くの訪問者を獲得しましょう！',
    },
    accountSettings: {
      title: 'アカウント設定',
    },
    billingHistory: {
      title: '請求履歴',
    },
    pages: {
      home: 'ホーム',
      newPage: '新しいページ',
      managePages: 'ページを管理',
    },
    blockItem: {
      actionRequired: '要対応',
      hidden: '非表示 · 誰にも見えません',
    },
    blockContent: {
      untitled: '無題',
      clickToRename: 'クリックしてサブタイトルの名前を変更',
      saving: '保存中',
      saved: '保存済み',
      deleteTitle: 'このブロックを削除してもよろしいですか？',
      cancel: 'キャンセル',
      yes: 'はい',
    },
    addButtonModal: {
      title: 'アクションボタンを追加',
      close: '閉じる',
      added: '追加済み',
      add: '追加',
      messageTitle: 'メッセージ',
      messageText: 'メッセージボタンで、ユーザーがメッセンジャー経由であなたに連絡できます',
      subscribeTitle: '登録',
      subscribeText: '登録ボタンで、ユーザーがあなたのメールやメッセンジャーのリストに登録できます',
      ctaTitle: 'CTAボタン',
      ctaText: 'CTAは、ユーザーに特定のアクションを促すウェブサイト上の案内です',
      cartTitle: 'カート',
      cartText: 'ショッピングカートアイコンを表示して、訪問者がサイトで購入できることを示します',
      contactTitle: '連絡先',
      contactText: '訪問者があなたの連絡先情報に素早くアクセスできるようにします',
      qrcodeTitle: 'QRコード',
      qrcodeText: 'QRコードを表示して、訪問者が素早くスキャンしページを共有できるようにします',
      languageTitle: '言語',
      languageText: '訪問者がページの言語を切り替えられるようにします',
      searchTitle: '検索',
      searchText: '訪問者がヘッダーからショップの商品を検索できるようにします',
    },
    inputMask: {
      copyLink: 'リンクをコピー',
    },
    videoLibrary: {
      addVideo: '動画を追加',
      myVideos: 'マイ動画',
      stockVideos: 'ストック動画',
      pasteUrl: 'URLを貼り付け',
      uploadVideo: '動画をアップロード',
    },
    createBlockModal: {
      searchTitle: 'ページに追加するブロックを選択',
      title: 'UniLinkに追加',
      contentTitle: 'コンテンツ',
      contentText: 'ページを作成・管理',
      growTitle: 'リード',
      growText: 'リードを収集しエンゲージメントを高める',
      monetizeTitle: '収益化',
      monetizeText: '商品、コンテンツ、サービスを販売',
      monetizationTitle: '収益を得て回収する',
      monetizationText: '商品やサービスを販売し、チップを回収',
      socialTitle: 'SNSコンテンツ',
      socialText: 'UniLinkでSNSコンテンツを共有',
      toolsTitle: '成長ツール',
      toolsText: 'オーディエンスを成長させ、管理し、つながる',
      search: '検索',
      all: 'すべて',
      allCategories: 'すべてのカテゴリ',
      content: 'コンテンツ',
      monetization: '収益化',
      social: 'ソーシャル',
      tools: 'ツール',
      header: 'ヘッダー',
      headerText: 'プロフィール画像と自己紹介を追加',
      link: 'リンク',
      linkText: 'リンクのレイアウトを選択',
      text: 'テキスト',
      textText: 'テキストのレイアウトを選択',
      videos: '動画',
      videosText: '動画のタイプを選択',
      image: '画像',
      imageText: '画像ブロックを追加',
      music: '音楽',
      musicText: '音楽のタイプを選択',
      socialFeeds: 'ソーシャルフィード',
      socialFeedsText: 'ソーシャルフィードのタイプを選択',
      moreContent: 'その他',
      moreContentText: 'コンテンツブロックをさらに追加',
      dataCollect: 'データ収集',
      dataCollectText: 'データ収集のタイプを選択',
      form: 'フォーム',
      formText: 'フォームのタイプを選択',
      conversionTools: 'エンゲージメントツール',
      conversionToolsText: 'コンバージョンブロックを追加',
      products: '商品',
      productsText: '商品ブロックを追加',
      donation: 'チップと寄付',
      tipsAndDonations: 'チップと寄付',
      tipsDonationsText: 'チップと寄付のブロック',
      event: 'イベント',
      eventText: 'イベントのタイプを選択',
      quickAdd: 'すべてのブロック',
      quickAddText: '任意のブロックを追加',
    },
    addBlockModal: {
      title: 'UniLinkに追加',
      dragToAdd: 'ドラッグして追加',
      contentTitle: '基本コンテンツを共有',
      contentText: 'UniLinkでコンテンツを直接共有',
      monetizationTitle: '収益を得て回収する',
      monetizationText: '商品やサービスを販売し、チップを回収',
      socialTitle: 'SNSコンテンツ',
      socialText: 'UniLinkでSNSコンテンツを共有',
      toolsTitle: '成長ツール',
      toolsText: 'オーディエンスを成長させ、管理し、つながる',
      search: '検索',
      searchPlaceholder: 'コンテンツを検索...',
      all: 'すべて',
      allCategories: 'すべてのカテゴリ',
      content: 'コンテンツ',
      monetization: '収益化',
      social: 'ソーシャル',
      tools: 'ツール',
      suggestTitle: 'ブロックを提案',
      suggestText: '欲しいブロックがありませんか？見たいものを教えてください',
      suggestModalTitle: 'ブロックを提案',
      suggestModalSubtitle: 'UniLinkにあったらいいと思うブロックを教えてください。すべてのアイデアを読んでいます。',
      suggestPlaceholder: '例：Google Calendar連携付きの予約ブロック...',
      suggestSubmit: '提案を送信',
      suggestSending: '送信中...',
      suggestSuccessTitle: '提案を送信しました！',
      suggestSuccess: 'ありがとうございます！すべてのアイデアを読み、ロードマップに反映します。',
      suggestError: '送信できませんでした。もう一度お試しください。',
    },
    tabNavigation: {
      tabView: 'タブ表示',
      tabViewTooltip: 'ナビゲーションのタブ表示を選択',
      colors: '色',
      colorsTooltip: '投稿とボタンの色を選択',
      tabs: 'タブ',
      tabsTooltip: 'ウェブサイトのナビゲーションに表示するタブを選択',
      content: 'コンテンツ',
      posts: '投稿',
      store: 'ストア',
      shop: 'ストア',
      tabsSettings: 'タブナビゲーション設定',
    },
    hideLogo: {
      text: 'ページのフッターにUniLinkロゴを表示します。',
      text2: 'ページのフッターにUniLinkロゴを表示します。',
    },
    palettePreview: {
      custom: 'カスタム背景色',
      hexColor: '16進カラー',
      hexColorTooltip: 'プレビューの16進カラーを入力',
    },
    backgroundVideo: {
      insert: 'URLを挿入',
      upload: '動画をアップロード',
      search: '動画を検索',
    },
    periodDropdown: {
      today: '今日',
      yesterday: '昨日',
      last7days: '過去7日間',
      last30days: '過去30日間',
      allTime: '全期間',
      custom: 'カスタム',
    },
    subsections: {
      content: 'コンテンツ',
      design: 'デザイン',
      settings: '設定',
    },
    wrapperSettings: {
      lock: 'PROプランにアップグレード',
    },
    shareModal: {
      addSocials: 'SNSに追加',
      shareTo: '共有先',
      qrCode: 'QRコード',
      customizeUrl: 'URLをカスタマイズ',
      goToMy: '移動先：',
      print: 'あなた専用のQRコードを次に印刷できます：',
      cards: '名刺やチラシ',
      download: 'ダウンロード',
      copy: 'コピー',
      previewMobile: 'モバイルでプレビュー',
      scanMobilePreview: 'モバイル端末でQRコードをスキャンして、ウェブサイトをプレビュー',
      types: {
        socials: 'SNS',
        shareTo: '共有',
        qrCode: 'QR',
        title: 'UniLinkを共有',
        titleSocials: 'UniLinkをSNSに追加',
        titleShareTo: '共有先...',
        titleQRCode: 'QRコード',
        titlePreviewMobile: 'モバイルでプレビュー',
      },
      socialList: {
        instagramText: 'UniLinkをInstagramプロフィールに追加しましょう。UniLink URLをコピーし、プロフィールを編集を開いて、ウェブサイトのフィールドに貼り付けるだけです。',
        facebookText:
          'UniLinkをFacebookプロフィールに追加しましょう。UniLink URLをコピーし、プロフィールの基本データページを開き、連絡先と基本情報をクリックし、+ ウェブサイトを追加をクリックして、ウェブサイトのアドレスフィールドにUniLink URLを貼り付け、保存をクリックします。',
        tikTokText:
          'UniLinkをFacebookプロフィールに追加しましょう。UniLink URLをコピーし、プロフィールの基本データページを開き、連絡先と基本情報をクリックし、+ ウェブサイトを追加をクリックして、ウェブサイトのアドレスフィールドにUniLink URLを貼り付け、保存をクリックします。',
        twitchText:
          'UniLinkをTwitchチャンネルに追加しましょう。UniLink URLをコピーし、Twitchチャンネルを開いて、概要をクリックし、概要とリンクの設定を編集をクリックして、ソーシャルリンクまでスクロールし、最初のテキストフィールドにUniLinkを追加し、2番目のテキストフィールドにUniLink URLを貼り付けて、追加をクリックします。',
        youTubeText:
          'UniLinkをYouTubeチャンネルに追加しましょう。UniLink URLをコピーし、YouTubeチャンネルを開いて、チャンネルをカスタマイズをクリックし、基本情報をクリックして、リンクの下でリンクのタイトルを追加しURLフィールドにUniLink URLを貼り付けて、公開をクリックします。',
        linkedInText:
          'UniLinkをLinkedInプロフィールに追加しましょう。UniLink URLをコピーし、LinkedInプロフィールを開いて、鉛筆アイコンをクリックし、連絡先情報までスクロールして、ウェブサイトURLのフィールドにUniLink URLを貼り付けて、適用をクリックします。',
        pinterestText:
          'UniLinkをPinterestプロフィールに追加しましょう。UniLink URLをコピーし、Pinterestの設定を開いて、ウェブサイトURLのフィールドにUniLink URLを貼り付けて、保存をクリックします。',
        twitterText:
          'UniLinkをTwitterプロフィールに追加しましょう。UniLink URLをコピーし、プロフィールを開いて、プロフィールを編集をクリックし、ウェブサイトのフィールドにUniLink URLを貼り付けます。',
      },
      share: {
        shareFacebook: 'Facebookでシェア',
        shareLinkedIn: 'LinkedInでシェア',
        shareTwitter: 'Twitterでシェア',
        shareWhatsApp: 'WhatsAppで共有',
        shareMessenger: 'Messengerで共有',
        shareEmail: 'メールで共有',
      },
    },
  },
  popupMenu: {
    edit: 'ページを編集',
    openInNewTab: '新しいタブで開く',
    copyLink: 'URLをコピー',
    delete: '削除',
    showThumbnail: 'ダッシュボードにページのサムネイルを表示',
    manageTabs: 'タブを管理',
  },
  tabsDashboard: {
    labelAddNewTab: '新しいタブ',
  },
  blocks: {
    header: {
      blockTitle: 'ヘッダー',
      blockText: 'プロフィール画像をカスタマイズし、短い自己紹介を追加して、SNSアイコンを更新',
      blockShortText: 'プロフィールをカスタマイズ',
      layout: 'レイアウト',
      layoutTooltip: '希望のヘッダーレイアウトを作成',
      layoutAlign: 'レイアウトの配置',
      layoutAlignTooltip: 'テキストを配置',
      bottomButtonsSettings: '下部ボタン',
      bottomButtonsLayout: 'レイアウト',
      bottomButtonsRow: '横並び',
      bottomButtonsColumn: '縦積み',
      profilePicture: 'プロフィール画像',
      profilePictureTooltip: 'プロフィール画像を変更',
      cropMismatch: 'この写真は別のレイアウト用に切り抜かれています。',
      adjustCrop: '切り抜きを調整',
      photoShapeLabel: '写真の形状',
      photoShapeTooltip: 'このレイアウトで正方形の写真を表示するか、縦長に切り抜くかを選択します。',
      photoShapeSquare: '正方形',
      photoShapeVertical: '縦長',
      coverShape: 'カバーの形',
      coverShapeTooltip: 'カバーの下端を選びます：直線、下向きの弧、上向きの弧。',
      coverShapeStraight: '直線',
      coverShapeArcDown: '下向きの弧',
      coverShapeArcUp: '上向きの弧',
      avatarOffsetLabel: 'アイコンの位置',
      avatarOffsetTooltip: 'カバーの端に対してアイコンを上下に調整します。',
      photoStyleProTitle: '高度な写真スタイルを解放',
      photoStyleProDesc: '背景なしとテキスト背面はPRO機能です。',
      photoShapeCustom: 'カスタム',
      sliderStyleLabel: 'スライダースタイル',
      sliderStyleTooltip: 'スワイプは一度に1枚ずつ写真を表示します。ギャラリーはサムネイル列を表示し、サムネイルをタップするとメイン写真が切り替わります。',
      sliderStyleSwipe: 'スワイプ',
      sliderStyleGallery: 'ギャラリー',
      photoPositionLabel: '写真の位置',
      photoPositionHint: '縦方向のフレーミング',
      verticalCropHint: 'このレイアウトは元の写真を表示します。表示したい縦方向の範囲を選択してください。',
      verticalCropReady: 'このレイアウトで表示される縦方向の範囲を微調整します。',
      pickVerticalArea: '縦方向の範囲を選択',
      pictureSize: '画像サイズ',
      pictureSizeTooltip: '画像サイズを変更できます',
      pictureHeight: '画像の高さ',
      pictureHeightCaption: '画像の高さを変更できます',
      photoStyle: '写真スタイル',
      photoStyleTooltip: '写真をそのまま表示するか、背景を削除するか、被写体の背面にテキストを配置します。',
      avatarModeOriginal: 'オリジナル',
      avatarModeCutout: '背景なし',
      avatarModeLayered: 'テキスト背面',
      overlayText: 'テキスト',
      overlayTextPlaceholder: 'あなたの名前（デフォルト）',
      overlayColor: 'テキストの色',
      overlaySize: 'サイズ',
      overlayY: '縦位置',
      overlayEffect: 'アニメーション',
      overlayEffectNone: 'なし',
      overlayEffectShimmer: 'シマー',
      overlayEffectGlow: 'グロー',
      overlayEffectGradient: 'グラデーション',
      overlayEffectSparkle: 'スパークル',
      overlayUsesName: 'このレイアウトではテキストがプロフィール名になり、あなたの背面に表示されます。「名前」セクションで編集してください。',
      cutoutGenerate: '切り抜きを生成',
      cutoutRegenerate: '再生成',
      cutoutUpload: 'アップロード',
      cutoutOr: 'または',
      cutoutGenerating: '生成中...',
      cutoutUploading: 'アップロード中...',
      cutoutVideoHint: '背景の削除は動画ではなく画像写真でのみ機能します。',
      cutoutTimeout: '背景の削除に時間がかかりすぎています。もう一度お試しください。',
      preview: 'プレビュー',
      badge: 'バッジ',
      badgeTooltip: 'ヘッダーに認証バッジを追加',
      profileBadges: 'バッジ',
      profileBadgesTooltip: '名前の横に表示するバッジを最大3つ選択',
      profileBadgesProLockHint: 'このバッジを使うにはPROにアップグレードしてください',
      profileBadgesAdd: 'バッジを追加',
      profileBadgesManage: 'バッジを管理',
      profileBadgesModalTitle: 'プロフィールにバッジを追加',
      profileBadgesModalSubtitle: 'あなたの実績や評価をアピールしましょう。',
      profileBadgesCustomCta: '自分のバッジをアップロード',
      profileBadgesCustomDesc: 'カスタムバッジ',
      profileBadgesCustomName: 'バッジ名',
      profileBadgesCustomChoose: '画像を選択',
      profileBadgesCustomChange: '画像を変更',
      profileBadgesCustomUploading: 'アップロード中…',
      profileBadgesCustomAdd: 'バッジを追加',
      tags: 'タグ',
      tagsTooltip: '名前の下にカテゴリタグを表示（最大5つ）',
      tagsAdd: 'タグを追加',
      addTags: '+ タグを追加',
      tagsEdit: 'タグを編集',
      tagsCustomPlaceholder: 'カスタムタグを追加',
      tagsCustomAdd: '追加',
      tagsSuggested: 'おすすめのカテゴリ',
      tagsSelected: '選択済み',
      tagsEmpty: 'タグはまだありません — 候補から選ぶか、自分で追加してください',
      tagsLimit: 'タグは最大5つ',
      visibility: '表示設定',
      visibilityTooltip: 'プロフィール画像を表示または非表示',
      cover: 'カバー',
      coverTooltip: 'ヘッダーのカバーに画像または動画を追加',
      addCover: 'カバーを追加',
      image: '画像',
      video: '動画',
      positionCover: 'テキストとボタンの位置',
      positionCoverTooltip: 'スライダーをドラッグして位置を変更',
      buttons: 'ボタン',
      block: 'ブロック',
      videoProcessing: '動画を処理中',
      vibe: 'バイブ',
      vibeTooltip: 'あなたのバイブを追加',
      stories: 'ストーリー',
      storiesTooltip: 'ストーリーを追加',
      addStory: 'ストーリーを追加',
      storiesSubtitle: 'ストーリーに画像または動画を追加',
      subscribeMethod: '登録方法',
      subscribeMethodTooltip: '登録方法を選択',
      subscribeLink: '登録リンク',
      subscribeLinkTooltip: '登録リンクをコピー',
      minWidth: '最小幅',
      addVCard: 'vCardを追加',
      vCard: 'vCard',
      vCardTooltip: '自分についての情報を追加できます',
      buttonInline: 'ヘッダーにインラインのボタン',
      buttonInsideContact: '連絡先ボタン内のボタン',
      showSaveContact: '連絡先を保存を表示',
      options: 'オプション',
      showBusinessCard: '名刺を表示',
      showBusinessCardCaption: 'ここに「連絡先を保存」ボタンを追加します。',
      editBusinessCard: '名刺を編集',
      editContactDetails: '名刺の連絡先情報を編集',
      needAddContact: '連絡先ボタンを追加する必要があります',
      socialGap: '間隔',
      socialGapCaption: '間隔を変更できます',
      socialSize: 'サイズ',
      socialSizeCaption: 'サイズを変更できます',
      icons: 'アイコン',
      iconsTooltip: 'ボタンにアイコンを追加',
      ribbonLabel: '装飾リボン',
      ribbonLabelTooltip: 'ヘッダーのヒーローの下にカラーバーを追加',
      addTint: 'リボンを追加',
      ribbonTitle: 'リボン',
      ribbonText: 'リボンのテキスト',
      ribbonTextPlaceholder: '例：月末まで20%オフ',
      ribbonColor: 'リボンの色',
      ribbonTheme: 'スタイル',
      ribbonThemes: {
        none: '装飾なし',
        birthday: '誕生日',
        newyear: '新年',
        valentine: 'バレンタイン',
        halloween: 'ハロウィン',
        summer: 'サマー',
      },
      ribbonEffect: 'エフェクト',
      ribbonEffects: {
        none: 'なし',
        gradient: 'アニメーショングラデーション',
        shimmer: 'シマー',
        lights: 'ストリングライト',
      },
      ribbonPosition: '位置',
      ribbonPositions: {
        bottom: 'ヘッダーの下',
        underPhoto: '写真の下',
      },
      ribbonRemove: 'リボンを削除',
      statusBadges: 'アクティビティ',
      statusBadgesTooltip: 'ページにリアルタイムのアクティビティを表示',
      addStatus: 'アクティビティを追加',
      statusDisabledHint: '非表示 · 無効',
      followersTitle: 'フォロワー',
      followersCounter: 'フォロワーカウンター',
      followersTooltip: '連携したSNSアカウントの合計フォロワー数を表示',
    },
    text: {
      blockTitle: 'テキスト',
      blockText: '好きなことを何でも書ける汎用テキストブロック。WYSIWYGエディタでテキストを整形できます',
      blockShortText: '汎用テキストブロック',
      title: 'タイトル',
      titleText: 'タイトルサイズをカスタマイズ',
      orderOfElements: '要素の順序',
      orderOfElementsTooltip: 'スライダーをドラッグして要素の順序を変更',
      changeOrder: '順序を変更',
      text: 'テキスト',
      content: 'コンテンツ',
      image: '画像',
      button: 'ボタン',
      addButtons: 'ボタンをさらに追加',
      displayedContent: '表示コンテンツ',
      displayedContentTooltip: 'コンテンツを表示または非表示',
      buttonLayout: 'ボタンのレイアウト',
      buttonLayoutTooltip: 'ボタンを縦または横に配置するかを選択',
    },
    timeline: {
      blockTitle: 'タイムライン',
      blockText: 'イベント付きの縦型タイムラインを表示。各イベントには日時、タイトル、説明、任意の画像を設定できます',
      blockShortText: 'イベントのタイムラインを表示',
      editItem: 'イベントを編集',
      title: 'タイトル',
      titlePlaceholder: 'イベントのタイトル',
      subtitle: 'サブタイトル',
      subtitlePlaceholder: '役割または所属（任意）',
      description: '説明',
      descriptionPlaceholder: 'イベントの説明（任意）',
      startTime: '開始時刻',
      endTime: '終了時刻',
      startDate: '開始日',
      endDate: '終了日',
      showEndDate: '終了日を表示',
      showEndDateTooltip: '進行中のイベント（例：「2023年からここで勤務」）ではオフにしてください',
      includeTime: '時刻を含める',
      includeTimeTooltip: 'オフの場合、時刻なしで日付のみが表示されます',
      image: '画像',
      imagePlaceholder: 'アバターまたはアイコンをアップロード',
      imageUploadFailed: '画像をアップロードできませんでした。マイメディアを使うかリンクを貼り付けてください。',
      untitled: '無題',
      listLayout: 'リストレイアウト',
      lineColor: '線の色',
    },
    trust: {
      blockTitle: '信頼',
      blockShortText: 'パートナーシップを共有',
      blockText: 'すべてのつながりを1か所にまとめましょう。',
      titleText: 'タイトルサイズをカスタマイズ',
      orderOfElements: '要素の順序',
      orderOfElementsTooltip: 'スライダーをドラッグして要素の順序を変更',
      changeOrder: '順序を変更',
      text: 'テキスト',
      content: 'コンテンツ',
      image: '画像',
      button: 'ボタン',
      displayedContent: '表示コンテンツ',
      displayedContentTooltip: 'コンテンツを表示または非表示',
      enterTrustLink: 'パートナーのURLを入力',
      enterTrustLinkTooltip: 'パートナーのURLを貼り付け',
      enterPartnerName: 'パートナー名を入力',
      enterPartnerUrl: 'https://www.yourPartner.com/',
      enterDescription: '説明を入力（任意）',
      partnerLogo: 'パートナーのロゴ',
      uploadPartnerLogo: 'パートナーのロゴをアップロード',
    },
    wall: {
      blockTitle: 'ウォール',
      blockShortText: '訪問者からメッセージを収集',
      blockText: '訪問者がメッセージを残しコンテンツと交流できる公開ウォールを表示',
    },
    'live-stream': {
      blockTitle: 'ライブ配信',
      blockShortText: 'ページでライブ配信',
      blockText: 'オーディエンスにライブ配信 — プラットフォームでネイティブに、またはYouTube / Twitchを埋め込み',
    },
    workout: {
      blockTitle: 'ワークアウト',
      blockShortText: 'ワークアウトを共有・販売',
      blockText: '構造化されたワークアウトを投稿 — セット、レップ、デモ動画付きのエクササイズ。販売または無料で共有',
      templates: {
        sessionCard: 'セッションカード',
        sessionCardCaption: 'カバーと名前、情報一行、その下にスタートボタン',
        exerciseList: '種目リスト',
        exerciseListCaption: '各種目のサムネイル、セット数、重量',
        setTracker: 'セット記録',
        setTrackerCaption: 'セットごとに一行——完了、進行中、これから',
        restTimer: 'レストタイマー',
        restTimerCaption: 'セット間の大きなカウントダウンと次の種目',
        weekPlan: '週間プラン',
        weekPlanCaption: '曜日の一覧。今日はすぐ開始できる状態',
        videoExercise: 'フォーム動画',
        videoExerciseCaption: '縦長のフォーム動画と、その下にポイント',
        progress: '進捗',
        progressCaption: '今月のセッションをバーで表示、合計を二つ添えて',
        circuit: 'サーキット',
        circuitCaption: 'ワークとレストのラウンド。進行中の種目を強調',
        sessionDone: 'セッション完了',
        sessionDoneCaption: '今終えた内容、連続日数、感想を残す場所',
      },
      defaults: {
        mon: '月',
        tue: '火',
        wed: '水',
        thu: '木',
        fullBody: '全身',
        legsAndCore: '脚と体幹',
        upperBody: '上半身',
        restDay: '休養',
      },
    },
    videoFeedback: {
      blockTitle: '動画フィードバック',
      blockShortText: '動画の推薦文を収集',
      blockText: 'オーディエンスから短い動画の推薦文やフィードバックを収集',
    },
    'premium-inbox': {
      blockTitle: 'プレミアム受信トレイ',
      blockShortText: 'ファンからの有料メッセージ',
      blockText: 'ファンがプレミアム受信トレイに有料メッセージやリクエストを直接送れるようにします',
    },
    'order-form': {
      blockTitle: '注文フォーム',
      blockShortText: 'ページから注文を収集',
      blockText: 'カスタマイズ可能な注文フォームでページから直接注文を収集',
    },
    link: {
      blockTitle: 'リンク',
      blockText: 'ウェブサイト、ブログ、オンラインストア、その他のウェブページへトラフィックを誘導',
      blockShortText: 'ウェブサイトへトラフィックを誘導',
      addLink: 'リンクを追加',
      addNewLink: '新しいリンクを追加',
      restrictedTitle: '{platform}リンクはPRO機能です',
      restrictedText: '{platform}リンクの追加はPROプランで利用できます。プランをアップグレードしてこのリンクをページに追加しましょう。',
      upgradeToPro: 'PROにアップグレード',
      showMore: 'もっと見る',
      showLess: '表示を減らす',
      viewArchive: 'アーカイブを表示',
      archivedLinks: 'アーカイブされたリンク',
      noArchivedLinks: '現在使っていないリンクをアーカイブして、リンク管理をすっきりと保ちましょう。',
      archiveAllUnpublished: '未公開のリンクをすべてアーカイブ',
      addFormExisting: '既存のリンクから追加',
      addYourLink: 'グループにリンクを追加',
      add: '追加',
      otherTypes: 'アクションタイプ',
      link: 'リンク',
      navigate: '移動',
      navigateTo: '移動先',
      scrollBlock: 'スクロール先',
      copyText: 'テキストをコピー',
      navigatePage: 'ページ',
      navigateProduct: '商品',
      navigateBlock: 'ブロック',
      modal: 'モーダル',
      showModal: 'モーダルを表示',
      modalBlock: 'ブロックを表示',
      modalItem: 'アイテムを表示',
      modalCustom: 'カスタム',
      document: 'ドキュメント',
      privat24: 'Privat24',
      phone: '電話をかける',
      viber: 'Viberを開く',
      skype: 'Skypeを開く',
      email: 'メールを送信',
      discount: '割引',
      smartLink: 'スマートリンク',
      mobileApp: 'ディープリンク',
      enterURL: 'URLを入力',
      enterPrivat: 'Private Bankのカードを入力',
      enterPhone: '電話番号を入力',
      enterViber: 'Viber番号を入力',
      enterSkype: 'Skypeを入力',
      enterEmail: 'メールを入力',
      enterTitle: 'タイトルを入力',
      enterCopyText: 'コピーするテキストを入力',
      enterPromoCode: 'プロモコードを入力',
      group: 'グループを作成',
      content: 'コンテンツ',
      links: 'リンク',
      heading: '見出し',
      settings: '設定',
      thumbnail: 'サムネイル',
      typeTooltip: '  クリックするとこのリンクが開きます',
      title: 'タイトル',
      titleTooltip: 'リンクの名前',
      description: '説明',
      descriptionTooltip: 'リンクの特徴、種類、色、サイズなどの任意の説明',
      label: 'ラベル',
      labelTooltip: 'ラベル名を追加',
      button: 'ボタン',
      buttonTooltip: 'ボタン名を追加',
      buttonText: 'ボタンのテキスト',
      buttonTextTooltip: 'ボタンの名前',
      buttonUrl: 'ボタンのURL',
      buttonUrlTooltip: 'ボタンのURLを入力',
      addLinkToGroup: 'グループにリンクを追加',
      removeFromGroup: 'グループから削除',
      deletePermanently: '完全に削除',
      image: '画像',
      buttonBg: 'ボタンの背景',
      postPreview: '投稿プレビュー',
      separatorType: '区切りのタイプ',
      separatorTypeTooltip: 'ボタンに区切りのタイプを追加',
      section: 'セクション',
      sectionTooltip: 'リンクのセクション',
      descriptionSeparator: '説明',
      descriptionSeparatorTooltip: 'セクションの任意の説明',
      sectionText: 'セクションのテキスト',
      linkInstant: 'リンクの即時転送',
      spotlight: 'リンクを目立たせる',
      addEffect: '特殊効果を追加',
      countdown: 'カウントダウン',
      countdownTimer: 'カウントダウンタイマー',
      countdownText: 'リンクがクリック可能になるまでのライブカウントダウンを追加',
      chooseDate: '日付を選択',
      chooseDateTooltip: 'リンクの日付を選択',
      chooseAction: 'アクションを選択',
      chooseActionTooltip: 'リンクのアクションを選択',
      addCountdown: 'リンクにカウントダウンを追加',
      scheduler: 'スケジューラー',
      schedule: 'スケジュール',
      scheduleText: 'リンクを有効化する未来の日時を選択',
      activateOn: '有効化日',
      activateOnTooltip: '日付を選択',
      deactivateOn: '無効化日',
      deactivateOnTooltip: '日付を選択',
      addSchedule: 'スケジュールを追加：',
      scheduleError: '終了日は開始日より前にできず、開始日は過去にできません。',
      scheduleErrorPast: '有効化日は過去にできません。',
      scheduleErrorPastDeactivate: '無効化日は過去にできません。',
      scheduleErrorOrder: '無効化日は有効化日より後でなければなりません。',
      activatesIn: '有効化まで',
      deactivatesIn: '無効化まで',
      lock: 'ロック',
      lockText: '訪問者は条件のいずれかを満たすことでのみこのリンクにアクセスできます。',
      lockCode: 'コード',
      lockCodeTitle: 'このリンクを解除するコード',
      lockCodeText: '訪問者はこのリンクを解除するために4桁のコードを入力する必要があります',
      lockSubscribe: '登録',
      lockSubscribeTitle: 'リンクを解除するには、訪問者があなたのUniLinkに登録する必要があります。',
      lockSubscribeText: 'ロックが正常に設定されました。',
      lockPayment: '支払い',
      lockPaymentText: 'ロックが正常に設定されました。',
      price: '価格',
      priceTooltip: '商品の価格を追加',
      lockAge: '生年月日（年齢）',
      lockAgeTitle: '最低年齢を設定',
      lockAgeText: '訪問者は生年月日でリンクを解除するために一定の年齢以上である必要があります',
      lockAgeAlert: 'ロックが正常に設定されました。',
      lockSensitive: 'センシティブな内容',
      lockSensitiveText: '訪問者は、このリンクにすべての人に適さない内容が含まれる可能性があることを了承する必要があります。',
      makeLink: 'リンクを有料にする',
      addLock: 'リンクにロックを追加',
      save: '保存',
      clear: 'クリア',
      buttonColor: 'ボタンの色',
      labelColor: 'ラベルの色',
      background: '背景',
      imageHeight: '画像の高さ',
      imageHeightTooltip: 'スライダーをドラッグして画像の高さを変更',
      buttonMinimum: '最小の高さ',
      buttonMinimumTooltip: 'スライダーをドラッグしてボタンの高さを変更',
      textPosition: 'テキストの位置',
      textPositionTooltip: 'テキストの縦位置を選択',
      preview: 'プレビュー',
      defaultDesign: 'デフォルトデザイン',
      defaultDesignTooltip: 'リンクのデフォルトデザインを設定',
      defaultDesignTitle: 'このデザインはすべてのリンクに適用されますのでご注意ください。',
      defaultDesignText: 'デフォルトのリンクデザインを変更できます',
      changeDefault: 'デフォルトを変更',
      applyDefault: 'デフォルトを適用',
      scheduled: 'スケジュール済み',
      scheduledVisible: 'スケジュールされたリンクが表示されました',
      scheduledHidden: 'スケジュールされたリンクが非表示になりました',
      linkClickable: 'リンクがクリック可能になるまで',
      linkDisable: 'リンクが無効になるまで',
      lockedBy: 'ロックの種類：',
      items: 'アイテム',
      doNotAnyLinks: 'リンクはまだありません',
      sublinks: 'サブリンク',
      layout: 'レイアウト',
      layoutTooltip: '希望のサブリンクのレイアウトを選択',
      hideGroupLink: 'グループリンクを非表示',
      rules: 'ルール',
      rulesText: 'ページを訪れている人に応じて、このリンクの表示を変更します。',
      rulesEmpty: '条件はまだありません。条件を追加して、このリンクを誰に表示するか制御しましょう。',
      rulesAddCondition: '条件を追加',
      rulesActive: '表示ルール',
      rulesIf: '条件',
      rulesThen: '結果',
      ruleTypeLocation: '所在地',
      ruleTypeDevice: 'デバイス',
      ruleTypeTime: '曜日と時刻',
      ruleOperatorIs: 'が次である',
      ruleOperatorIsNot: 'が次でない',
      ruleActionHide: 'リンクを非表示',
      ruleActionShow: 'リンクを表示',
      ruleSelectLocations: '所在地を選択',
      ruleSearchLocations: '国を検索…',
      ruleFrom: '開始',
      ruleTo: '終了',
      ruleAnyTime: 'すべて',
    },
    'data-collect': {
      blockTitle: 'データ収集',
      blockText: '訪問者からメールや電話番号を収集',
      blockShortText: 'メールを収集',
      maxSize: 'チャンネルは最大3つまで追加できます',
      customTerms: 'カスタム利用規約',
      customTermsTooltip: 'フォームにカスタム利用規約を追加',
      termsConditions: '利用規約',
      text: 'テキスト',
      subscribe: '登録',
      title: 'タイトル',
      titleTooltip: '利用規約のタイトルを入力',
      titleResultTooltip: '送信のタイトルを入力',
      url: 'URL',
      urlTooltip: 'URLを入力',
      editItem: 'アイテムを編集',
      placeholder: 'プレースホルダー',
      placeholderTooltip: 'プレースホルダーのテキストを入力',
      button: 'ボタン',
      buttonTooltip: '訪問者にメール入力を促すテキスト（10%オフ割引、今すぐ登録、ファイルをダウンロードなど）',
      successMessage: '成功メッセージ',
      successMessageTooltip: '購読者への成功メッセージ',
      botURL: 'ボットURL（任意）',
      botURLTooltip: 'ボットのURLを入力',
      botToken: 'ボットトークン',
      botTokenTooltip: 'ボットのトークンを入力',
      rewards: '応答',
      rewardsTooltip: '購読者への応答を追加',
      addReward: '応答を追加',
      thankYou: 'お礼メッセージ',
      email: {
        none: 'なし',
        display: '応答を即座に表示',
        send: '応答をメールに送信',
        redirect: 'URLにリダイレクト',
      },
      phone: {
        none: 'なし',
        display: '応答を即座に表示',
        send: '応答を電話に送信',
        redirect: 'URLにリダイレクト',
      },
      telegram: {
        none: 'なし',
        display: '応答を即座に表示',
        send: '応答をTelegramボットで送信',
        redirect: 'URLにリダイレクト',
      },
      whatsapp: {
        none: 'なし',
        display: '応答を即座に表示',
        send: '応答をWhatsAppボットで送信',
        redirect: 'URLにリダイレクト',
      },
      instagram: {
        none: 'なし',
        display: '応答を即座に表示',
        send: '応答をInstagramボットで送信',
        redirect: 'URLにリダイレクト',
      },
      messenger: {
        none: 'なし',
        display: '応答を即座に表示',
        send: '応答をMessengerボットで送信',
        redirect: 'URLにリダイレクト',
      },
      viber: {
        none: 'なし',
        display: '応答を即座に表示',
        send: '応答をViberボットで送信',
        redirect: 'URLにリダイレクト',
      },
      connect: '接続',
      toChangeReward: '応答タイプを変更するには、現在のものを削除してください',
      remove: '削除',
      viewTypes: '表示タイプ',
    },
    form: {
      blockTitle: 'フォーム',
      blockText: 'オーディエンスから情報やデータを取得できます',
      blockShortText: '情報を取得',
      fields: 'フィールド',
      fieldsTooltip: 'フォームにフィールドを追加',
      addCustomField: 'カスタムフィールドを追加',
      addItem: 'アイテムを追加',
      editItem: 'アイテムを編集',
      type: 'タイプ',
      typeTooltip: 'フィールドのタイプを選択',
      string: '短い回答',
      textarea: '長い回答',
      dropdown: 'ドロップダウン',
      radio: 'ラジオボタン',
      checkbox: 'チェックボックス',
      date: '日付',
      time: '時刻',
      country: '国',
      file: 'ファイルのアップロード',
      rating: '評価',
      submissionsClosed: '受付を停止する',
      submissionsClosedTooltip: 'フォームの代わりに短い案内を表示します。すでに届いた回答はそのまま残ります。',
      closedTitle: '停止時の見出し',
      closedText: '停止時のメッセージ',
      templates: {
        contact: 'お問い合わせフォーム',
        contactCaption: '一文、入力欄、ボタンひとつ — 誰もが想像するフォーム',
        steps: 'ステップ式',
        stepsCaption: '1画面につき2問、進捗バー付き。長いフォームが長く見えなくなります',
        upload: 'ファイルのアップロード',
        uploadCaption: 'まずアップロード欄 — 入稿データや資料に',
        schedule: '日付と時間',
        scheduleCaption: '日と時間帯を選び、名前を残すだけ',
        rating: '評価とフィードバック',
        ratingCaption: '星、タップできるいくつかの項目、コメント欄ひとつ',
        card: 'クラシック',
        cardCaption: '素のフォーム：入力欄が縦に並び、その下にボタン',
        button: 'ポップアップボタン',
        buttonCaption: 'ページにはボタンひとつ。フォームはポップアップで開きます',
      },
      fieldName: 'フィールド名',
      fieldNameTooltip: 'フィールド名を入力',
      name: '名前',
      placeholder: 'プレースホルダー',
      placeholderTooltip: 'プレースホルダーのテキストを入力',
      required: '必須',
      requiredTooltip: 'フィールドが必須かどうかをチェック',
      value: '値',
      enterTitle: 'タイトルを入力',
      addValue: '値を追加',
      delete: '削除',
      update: '更新',
      add: '追加',
      confirmationPage: '確認アクション',
      confirmationPageSubtitle: 'フォーム送信後の結果アクションを選択',
      successMessage: '成功メッセージ',
      successMessageTooltip: 'フォーム送信後の成功メッセージ',
      thankYou: 'お礼メッセージ',
      submit: '送信',
    },
    contact: {
      blockTitle: '連絡先',
      blockText: '連絡先を使うと、ユーザーがあなたと直接連絡を取れます。電話、メール、メッセンジャー、所在地を追加しましょう',
      blockShortText: 'ユーザーと連絡を取る',
      addNewContact: '新しい連絡先を追加',
      newContact: '新しい連絡先',
      friendlyName: '表示名',
    },
    faq: {
      blockTitle: 'FAQ',
      blockText: 'よくある質問 — ユーザーが尋ねそうな典型的な質問への回答リストを指します',
      blockShortText: 'よくある質問',
      addNewItem: '新しいアイテムを追加',
      editItem: 'アイテムを編集',
      title: 'タイトル',
      titleTooltip: 'タイトルを入力',
      description: '説明',
      descriptionTooltip: '説明を入力',
      update: '更新',
      add: '追加',
      howToFind: 'アクセス方法',
      view: '表示',
      viewTooltip: 'FAQアイテムの表示方法を選択',
      feed: 'フィード',
      slider: 'スライダー',
      emptyTitle: 'アイテムがまだありません',
      emptyText: '最初の質問を追加してこのブロックを埋めましょう。',
    },
    ama: {
      blockTitle: '何でも質問',
      blockShortText: 'ファンからの質問に答える',
      blockText: 'オーディエンスに質問してもらい、ページ上で回答しましょう',
    },
    feature: {
      blockTitle: '特徴',
      blockText: '画像付きのテキストセクションで、あなたのビジネスがなぜ最高なのかをユーザーに伝えます',
      blockShortText: '理由をユーザーに伝える',
      title: 'タイトル',
      titleTooltip: 'アイテムのタイトルを変更',
      description: '説明',
      descriptionTooltip: 'アイテムの説明を変更',
    },
    highlight: {
      blockTitle: 'ハイライト',
      blockText: '最も重要なリンクをサムネイル付きで強調表示（最大3つ）',
      blockShortText: '最も重要なものを強調',
      title: 'タイトル',
      titleTooltip: 'アイテムのタイトルを変更',
      url: 'URL',
      urlTooltip: 'アイテムのURLを変更',
      modeLink: 'リンク',
      modeStory: 'ストーリー',
      coverPhoto: '写真',
      coverIcon: 'アイコン',
      templates: {
        scroll: 'スクロール行',
        scrollCaption: '元のブロック。丸いカバーが折り返して並び、4つ以上で横スクロールになります',
        story: 'ストーリー',
        storyCaption: 'グラデーションのリングに大きめのカバー。タップして見るものだと一目で伝わります',
        square: '正方形カバー',
        squareCaption: 'スクロールする行に正方形のカバー。ストーリーの列ではなく棚のように見えます',
        tall: '縦長カード',
        tallCaption: '写真の上に名前を重ねた縦長カード。カバーそのものが主役のときに最適です',
        icon: 'アイコンカバー',
        iconCaption: '写真の代わりにアイコンを並べたグリッド。画像がまだないときに',
        grid: 'グリッド',
        gridCaption: '4列のグリッドにすべてを一度に表示。スクロールには多すぎる場合に',
      },
    },
    banner: {
      blockTitle: 'バナー',
      blockText: '画像、動画、最新商品を目立たせて紹介。CTAボタンを追加して、目標コンバージョンへユーザーを誘導できます',
      blockShortText: '画像・動画を紹介',
      height: '高さ',
      heightTooltip: 'バナーの高さを変更',
      badge: 'バッジ',
      badgeTooltip: 'このテンプレートでタイトルの上に表示される小さな一行',
      badgePlaceholder: '刷り上がりました',
      templates: {
        classic: 'クラシック',
        classicCaption: '元のバナー。文字が画像の中央に浮かび、大きさは縦横比の設定で決まります',
        coverTop: '肩見出し付きカバー',
        coverTopCaption: '見出しの上に小さな一行、すべて中央揃え。バナーで名乗るときに最適',
        coverTitle: 'タイトルのみ',
        coverTitleCaption: '一語を大きく字間を空けて、その下に一行。ボタンも他の要素もありません',
        coverLeft: '左揃え',
        coverLeftCaption: '文字は下の角、ボタンは二つ横並び。ランディングページの始まり方です',
        coverCenter: '中央のボタン',
        coverCenterCaption: 'すべて中央揃え、ボタンはピル型に縦積み。六つの中で最も直球',
        coverVideo: '動画カバー',
        coverVideoCaption: '動画を再生するバナー向け。状態を示すピル、音声の切り替え、ボタン一つ',
        coverBadge: 'バッジとCTA',
        coverBadgeCaption: '低めのフレーム。新着を告げる白いピル、見出し、ボタン一つ',
      },
    },
    slider: {
      blockTitle: 'スライダー',
      blockText: '画像コンテンツを紹介し、さまざまな機能を追加できる画像カルーセル',
      blockShortText: '画像カルーセル',
      image: '画像',
      imageTooltip: 'ギャラリーの画像',
      addText: 'テキストを追加',
      title: 'タイトル',
      titleTooltip: 'スライドのタイトル',
      titleSize: 'タイトルサイズ',
      titleSizeTooltip: '読みやすさのためにサイズを選択',
      description: '説明',
      descriptionTooltip: 'スライドの説明',
      textColor: 'テキストの色',
      addButton: 'ボタンを追加',
      url: 'URL',
      urlTooltip: '画像のURL',
      button: 'ボタン',
      buttonTooltip: 'ボタンのタイトル',
      buttonText: 'ボタンのテキスト',
      buttonColor: 'ボタンの色',
      height: '高さ',
      heightTooltip: 'スライドの高さを変更',
      view: '表示',
      viewTooltip: 'スライダーの表示を選択',
      auto: '自動',
      square: '正方形',
      rectangle: '長方形',
      single: 'シングル',
      multi: 'マルチ',
      templates: {
        multi: 'マルチ',
        multiCaption: '元のカードの帯。次のカードが端からのぞきます',
        single: 'シングル',
        singleCaption: '元の一枚ずつのスライダー。下にドットが並びます',
        showcase: 'ショーケース',
        showcaseCaption: '元のショーケース。大きな番号、カウンター、サムネイルの帯',
        full: '全面＋ドット',
        fullCaption: '一枚の写真を端から端まで。ドット以外に何もありません。説明のいらない写真向け',
        peek: '次のスライドがのぞく',
        peekCaption: '次のスライドが端からのぞくので、試す前にスワイプできると分かります',
        caption: 'キャプション付き',
        captionCaption: '写真をカードに収め、その下にスライド自身のタイトルと説明',
        thumbs: 'サムネイル付き',
        thumbsCaption: '写真の下に帯を置き、枚数の多い組はスワイプせず飛べるように',
        counter: 'カウンターと矢印',
        counterCaption: '数字と矢印二つ。じっくり順に見ていく価値のある組に',
        auto: '自動再生バー',
        autoCaption: 'ストーリーズのバー。スライダーが自分で進み、どこまで来たかを示します',
        compare: 'ビフォーアフター',
        compareCaption: '最初の二枚を重ね、境目の線をドラッグします。それぞれのタイトルがラベルになります',
        video: '動画スライド',
        videoCaption: '動画ファイルのスライド向け。訪問者が音を入れられ、経過時間も出ます',
        shop: '購入できるスライド',
        shopCaption: 'スライドのタイトル・説明・ボタンが、商品名・価格・操作として読まれます',
      },
    },
    gallery: {
      blockTitle: 'ギャラリー',
      blockText: '画像コンテンツを紹介できる画像カルーセル',
      blockShortText: '画像カルーセル',
      image: '画像',
      imageTooltip: 'ギャラリーアイテムの画像',
      layout: 'レイアウト',
      layoutTooltip: 'ギャラリーのレイアウトを選択',
      feed: 'フィード',
      slider: 'スライダー',
    },
    blog: {
      blockTitle: 'ブログ',
      blockText: '投稿のブログを作成',
      blockShortText: 'ブログを作成',
      writeYourStory: 'ストーリーを書く',
      shortDescription: '短い説明',
      shortDescriptionTooltip: 'ブログの任意の説明',
      description: '説明',
    },
    map: {
      blockTitle: 'マップ',
      blockText: 'Googleマップを追加して、ユーザーが実店舗へアクセスしやすくします',
      blockShortText: 'Googleマップを追加',
      buttonText: 'ボタンのテキスト',
      buttonTextTooltip: '2番目の表示を選択するとボタンが表示されます',
      text: 'テキスト',
      addAddress: '別の住所を追加',
      address: '住所',
      addressTooltip: '例えばGoogleマップから住所を貼り付けます',
      googleMap: 'Googleマップ（埋め込みコード）',
      googleMapTooltip: 'Googleマップから埋め込みコードを貼り付けます',
      howToFind: '埋め込みコードの見つけ方',
      incorrectCode: '埋め込みコードが正しくありません。',
      moreInfo: '詳細情報',
      code: 'コード',
      addressSettings: '住所設定',
      addressContent: 'URL、タイトル、ボタンテキストまたはアイコンを追加',
      title: 'タイトル',
      titleTooltip: '住所の名前',
      url: 'URL',
      urlTooltip: '例えばGoogleマップから住所のURLを貼り付けます',
      directionText: '経路案内のテキスト',
      directionTextTooltip: 'ユーザーへの行動喚起テキスト',
    },
    footer: {
      templates: {
        minimal: 'ミニマル',
        minimalCaption: 'マークとSNS行、法的表記。第二のメニューを置かずにページを締めます',
        columns: 'リンク2列',
        columnsCaption: '見出しごとにまとめたリンクを2列で。実在するセクションが数個のときに',
        accordion: 'アコーディオン',
        accordionCaption: '暗い面での折りたたみグループ。平らに並べきれない数のセクション向け',
        subscribe: '購読つきフッター',
        subscribeCaption: 'ナビチップの上にメール欄。アドレスを集めるフッター向け',
        contacts: '連絡先フッター',
        contactsCaption: '電話・メール・住所をタップできる行に。その下にメッセンジャー',
        shop: '大きなショップフッター',
        shopCaption: '配送の約束、リンク列、アプリバッジ、支払い方法',
        cta: '行動喚起',
        ctaCaption: '見出しと2つの操作を置いた塗りのパネル。ページの締めの一言',
        sticky: '操作バーつきフッター',
        stickyCaption: '通常のフッターの下に、電話・チャット・主要ボタン',
        locale: '言語と通貨',
        localeCaption: '言語・通貨・配送先の国を、ストアのヘルプリンクの上に',
      },
      defaults: {
        groups: [
          { title: 'サービス', links: ['デザイン', '開発', 'ブランディング'] },
          { title: '会社', links: ['会社概要', '事例', '採用'] },
        ],
        subscribeTitle: '月に一度のお便り',
        subscribeText: '事例、進め方、少しの舞台裏。迷惑メールは送りません。',
        subscribeButton: '購読する',
        ctaTitle: 'プロジェクトについてお聞かせください',
        ctaText: '営業日は1時間以内に返信します。',
        ctaButton: 'ご連絡ください',
        languages: [
          { code: 'ja', label: '日本語' },
          { code: 'en', label: 'Eng' },
          { code: 'uk', label: 'Ukr' },
        ],
        currency: '¥ 円',
        country: '日本',
        contacts: [
          { icon: 'phone', value: '+81 3 1234 5678' },
          { icon: 'mail', value: 'hi@studio.jp' },
          { icon: 'pin', value: 'キーウ市ホリヴァ通り22' },
        ],
      },
      blockTitle: 'フッター',
      blockText: 'ページの最下部にあるコンテンツのセクション。連絡先情報、SNSアイコン、メール登録フォームを追加できます',
      blockShortText: '最下部コンテンツのセクション',
      addBlock: 'ブロックを追加',
      blockType: 'ブロックタイプ',
      blockTypeTooltip: 'ブロックタイプを選択',
      addBlockTitle: 'ブロックのタイトル',
      addBlockTitleTooltip: 'ブロックのタイトルを選択',
      faq: 'FAQ',
      'data-collect': 'データ収集',
      contact: '連絡先',
      pages: 'ページ',
      payments: '支払い',
      social: 'ソーシャル',
      cancel: 'キャンセル',
      add: '追加',
      None: 'なし',
      text: 'テキスト',
      link: 'リンク',
      image: '画像',
      divider: '区切り線',
      linkViewLabel: 'レイアウト',
      linkViewTooltip: 'リンクの配置方法',
      linkViewSingle: '縦積み',
      linkViewRow: '横並び',
      linkItemsLabel: 'リンク',
      linkItemsTooltip: '最大5つのリンクを追加（例：プライバシーポリシー、利用規約）',
      linkLabelPlaceholder: 'ラベル',
      linkUrlPlaceholder: 'URL',
      linkAddMore: '+ リンクを追加',
      alignLabel: '配置',
      alignTooltip: '水平方向の配置',
      alignLeft: '左',
      alignCenter: '中央',
      alignRight: '右',
      imageLabel: '画像',
      imageTooltip: 'ロゴまたは画像をアップロード',
      imageLinkLabel: 'リンク（任意）',
      imageLinkTooltip: '画像をクリック可能にする',
      dividerLabel: '区切り線のタイプ',
      dividerTooltip: '線または空白スペース',
      dividerLine: '線',
      dividerSpace: 'スペース',
      picker: {
        subtitle: 'フッターに追加する要素を選択',
        configureSubtitle: '設定してフッターに追加',
        back: '戻る',
        saveButton: '保存',
        availableTitle: '追加可能',
        addedTitle: '追加済み',
        addedLabel: '追加済み',
        addButton: 'ブロックを追加',
        linkTitle: 'リンク',
        linkSub: '任意のURLへのボタン',
        socialTitle: 'ソーシャル',
        socialSub: 'SNSプロフィールのアイコン',
        textTitle: 'テキスト',
        textSub: '見出しまたは段落',
        pagesTitle: 'ページ',
        pagesSub: 'ネストされたサブページへのリンク',
        paymentsTitle: '支払い',
        paymentsSub: '対応する支払い方法',
        imageTitle: '画像',
        imageSub: 'ロゴまたは写真',
        dividerTitle: '区切り線',
        dividerSub: '線または間隔',
        faqTitle: 'FAQ',
        faqSub: 'よくある質問',
        dataCollectTitle: 'データ収集',
        dataCollectSub: 'メール登録フォーム',
        contactTitle: '連絡先',
        contactSub: '連絡先情報',
        importMode: 'ブロックからインポート',
        manualMode: '手動で追加',
        noContactsToImport: 'インポートできる連絡先がありません — 手動で追加してください。',
        noSocialsToImport: 'インポートできるSNSアイコンがありません — 手動で追加してください。',
        manualItemsLabel: 'アイテム',
        manualItemsTooltip: 'タイプを選んで値を入力してください。',
        contactValuePlaceholder: '@username / メール / 電話番号',
        socialUrlPlaceholder: 'https://...',
        addMore: '+ さらに追加',
      },
      faqText: 'よくある質問はFAQブロックで編集できます。これをクリックすると移動できます',
      socialText: 'SNSアイコンはヘッダーブロックで編集できます。これをクリックすると移動できます',
      dataCollectText: 'データ収集はデータ収集ブロックで編集できます。これをクリックすると移動できます',
      contactText: '連絡先は連絡先ブロックで編集できます。これをクリックすると移動できます',
      contactDesign: {
        editSource: '連絡先そのものは連絡先ブロックで編集できます —',
        variantLabel: 'スタイル',
        variantList: 'リスト',
        variantButton: 'ボタン',
        shapeLabel: '形状',
        shape_square: '四角',
        shape_rounded: '角丸',
        shape_pill: 'ピル',
        widthLabel: '幅',
        widthFull: '全幅',
        widthHalf: '半分',
        widthHalfStacked: '半分（縦積み）',
        borderLabel: '枠線',
        borderOn: 'オン',
        borderOff: 'オフ',
        borderColorLabel: '枠線の色',
      },
      pagesText: 'ウェブサイトで新しいページを追加できます',
      paymentsText: '支払い方法が表示されます',
      showOnAllpages: 'すべてのページに表示',
      layout: 'レイアウト',
      splitImage: 'サイド画像',
      footerText: '現在、ホームページのフッターが有効になっています。',
      editSocialIcons: 'SNSアイコンはヘッダーセクションで編集できます。これをクリックすると移動できます',
      editSubscribe: '登録は登録セクションで編集できます。これをクリックすると移動できます',
      editContacts: '連絡先は連絡先セクションで編集できます。これをクリックすると移動できます',
      editFrequently: 'よくある質問はFAQセクションで編集できます。これをクリックすると移動できます',
    },
    'chat-ai': {
      blockTitle: 'ライブチャット',
      blockShortText: 'AIとチャット',
      blockText: 'AIとチャット',
      suggestionsTitle: '候補',
      suggestionsSubtitle: 'クイックプロンプト',
    },
    custom: {
      blockTitle: 'カスタム',
      blockShortText: 'AI搭載ブロック',
      blockText: 'ミニインタラクティブアプリを説明すると、AIが生成します',
    },
    shop: {
      blockTitle: 'ショップ',
      blockText: '商品リストを追加',
      blockShortText: '商品を追加',
      view: '表示',
      cardLayout: 'カードレイアウト',
      cardLayoutTooltip: 'ショーケースは各商品を詳細な販売カードとして1行に1つ表示します',
      standardCards: '標準',
      showcaseCards: 'ショーケース',
      products: '商品',
      categories: 'カテゴリ',
      featured: '注目',
      shoppingCart: 'ショッピングカート',
      shoppingCartNote: 'カートボタンは訪問者が商品を追加すると表示されます',
      cartIconDisabledHint: 'これを使用するにはショッピングカートをオンにしてください',
    },
    digital: {
      blockTitle: 'デジタル商品',
      blockText: 'デジタルダウンロードを販売：PDF、スプレッドシート、テンプレート、限定コンテンツ',
      blockShortText: 'デジタル商品を販売',
    },
    podcast: {
      templates: {
        latest: '最新エピソード',
        latestCaption: '一番新しい回と、それを再生するボタンひとつ',
        player: 'プレーヤー',
        playerCaption: 'シークバー、15秒戻る、30秒進む、再生速度',
        list: 'エピソード一覧',
        listCaption: '再生・番号・タイトル・長さ — 素直なフィード',
        resume: '続きから',
        resumeCaption: 'この訪問者が止めた場所を、その人のブラウザに保存',
        bestOf: 'ベスト',
        bestOfCaption: '最初に聴く3本を、あなたが並べた順で',
        cover: '番組のカバー',
        coverCaption: 'アートワーク、番組の内容、配信中のアプリ',
        subscribe: 'フォロー行',
        subscribeCaption: '一行と配信先だけ — カバーもエピソードもなし',
        trailer: '予告編',
        trailerCaption: '「この番組は自分向きか」への2分の答え',
        guest: 'ゲスト回',
        guestCaption: 'ゲストで売るインタビュー、写真は全幅',
        guests: 'ゲスト一覧',
        guestsCaption: '番組に出た顔ぶれをグリッドで',
        hosts: 'ホスト紹介',
        hostsCaption: '誰が作っているか — エピソードの著者欄から',
        chapters: 'チャプターとノート',
        chaptersCaption: 'ノートのタイムスタンプ行。タップで頭出し',
        transcript: '書き起こし',
        transcriptCaption: 'エピソードを文字で。どの行からでも頭出し',
        clip: '共有クリップ',
        clipCaption: '大きく置いた一文と、その下に共有ボタン',
        video: 'ビデオポッドキャスト',
        videoCaption: '静止画と、観るか聴くかの選択',
        seasons: 'シーズン',
        seasonsCaption: '番組をチップに、その下にエピソード',
        topics: 'トピック絞り込み',
        topicsCaption: '番組のカテゴリーでエピソードを絞る',
        showCards: '番組カード',
        showCardsCaption: '番組ごとにカード、横スクロール',
        ask: 'リスナーからの質問',
        askCaption: '呼びかけ、質問例、そして回答の届け先',
        ratings: '評価',
        ratingsCaption: 'あなたの評点と、引用したいレビュー一件',
        support: '番組を支援',
        supportCaption: '支援者が得るものと、申し込み先',
        classic: 'Listen Now',
        classicCaption: '元のブロック — 番組タブ付きのフィード',
        showcase: 'ショーケース',
        showcaseCaption: '編集的なビュー：大きなカードとカバーのレール',
      },
      copy: {
        askTitle: 'リスナーからの質問',
        askHint: '呼びかけ、質問例、そして回答の届け先（フォーム、メール、音声受付）。',
        ratingTitle: '評価',
        ratingHint: 'あなたの評点と引用するレビュー。ブロックは入力した内容をそのまま表示し、Apple や Spotify からは取得しません。',
        supportTitle: '番組を支援',
        supportHint: '支援者が得るものと申し込み先。ボタンは、すでに決済している場所へ送ります。',
        title: 'タイトル',
        text: '本文',
        question: '質問の例',
        url: 'ボタンのリンク',
        buttonText: 'ボタンの文言',
        voiceUrl: '音声リンク',
        value: '評点',
        count: '出典',
        quote: 'レビュー',
        author: '誰の言葉か',
        tiers: 'プラン',
        tierName: '名称',
        tierPerk: '内容',
        tierPrice: '価格',
        addTier: '+ プランを追加',
        removeTier: 'プランを削除',
      },
      blockTitle: 'ポッドキャスト',
      blockText: 'ポッドキャストを宣伝',
      blockShortText: 'ポッドキャストを宣伝',
    },
    'page-list': {
      blockTitle: 'ページリスト',
      blockText: 'ページのリストを作成',
      description: '説明',
      blockShortText: 'ページのリストを作成',
      addNewPageItem: 'ページリンクを追加',
    },
    appointment: {
      blockTitle: '予約',
      blockText: '訪問者がカレンダーで時間を予約できるようにする',
      blockShortText: '訪問者に予約させる',
    },
    service: {
      blockTitle: 'サービス',
      blockText: 'リクエストが送信されるとメール通知を受け取ります',
      blockShortText: 'メールを受け取る',
    },
    requests: {
      blockTitle: 'サービス',
      blockText: 'リクエストが送信されるとメール通知を受け取ります',
      blockShortText: 'メールを受け取る',
    },
    tips: {
      blockTitle: 'チップ',
      blockText: 'UniLinkは応援を楽しく簡単にします。数タップで、ファンが支払いをしてメッセージを残せます',
      blockShortText: '応援を楽しく',
    },
    tip: {
      blockTitle: 'チップ',
      blockText: 'UniLinkは応援を楽しく簡単にします。数タップで、ファンが支払いをしてメッセージを残せます',
      blockShortText: '応援を楽しく',
    },
    donation: {
      blockTitle: '寄付',
      blockText: 'UniLinkは応援を楽しく簡単にします。数タップで、ファンが支払いをしてメッセージを残せます',
      blockShortText: '応援を楽しく',
    },
    course: {
      blockTitle: 'コースまたはチュートリアル',
      blockText: '訪問者がカレンダーで時間を予約できるようにする',
      blockShortText: '訪問者に予約させる',
    },
    event: {
      blockTitle: 'イベントまたはチケット',
      blockText: 'オーディエンスがあなたのイベントに参加できるようにする',
      blockShortText: 'オーディエンスを招く',
    },
    menu: {
      blockTitle: 'メニュー',
      blockText: '価格付きのユニークなメニューを作成',
      blockShortText: 'ユニークなメニューを作成',
    },
    recipe: {
      blockTitle: 'レシピ',
      blockText: '材料、手順、写真付きのレシピを共有',
      blockShortText: 'レシピを共有',
    },
    booking: {
      blockTitle: '予約',
      blockText: '訪問者がスペースを予約できるようにする',
      blockShortText: '訪問者に予約させる',
      name: '名前',
      nameCaption: 'スペースの名前を入力',
      description: '説明',
      descriptionCaption: 'このスペースの短い説明',
      rentalType: 'レンタルタイプ',
      rentalTypeCaption: '例：アパート、車、オフィス',
      duration: '期間',
      durationCaption: '例：1日ごと、1週間ごと、1か月ごと',
      price: '価格',
      priceCaption: 'このスペースの基本価格',
      oldPrice: '旧価格',
      oldPriceCaption: '任意の以前の価格',
      rating: '評価',
      ratingCaption: '平均評価（任意）',
      label: 'ラベル',
      labelCaption: 'HOTやNEWなどの短いバッジ',
      image: '画像',
      imageCaption: 'このスペースのカバー画像をアップロード',
      location: '所在地',
      locationCaption: '都市、エリア、または住所',
      capacity: '収容人数（ゲスト）',
      capacityCaption: '最大ゲスト数',
      rooms: '部屋と面積',
      roomsCaption: '寝室、バスルーム、面積',
      bedrooms: '寝室',
      bathrooms: 'バスルーム',
      areaSqM: '面積（m²）',
      minStay: '最低宿泊日数',
      minStayCaption: '予約の最低日数',
      requiresDeposit: 'デポジットが必要',
      depositAmount: 'デポジット金額',
      depositAmountCaption: '予約確定のための前払いデポジット',
      noSmoking: '禁煙',
      noPets: 'ペット不可',
      amenitiesWifi: 'Wi‑Fi',
      amenitiesParking: '駐車場',
      amenitiesKitchen: 'キッチン',
      amenitiesHeating: '暖房',
      amenitiesAC: 'エアコン',
      amenitiesPool: 'プール',
      amenitiesSauna: 'サウナ',
      amenitiesRestrooms: 'トイレ',
      validationNameRequired: '名前は必須です',
      validationPriceRequired: '価格は0以上の数値でなければなりません',
      validationDepositRequired: 'デポジットが有効な場合、デポジット金額は必須です',
      validationCapacityNumber: '収容人数は0以上の数値でなければなりません',
      validationOldPriceNumber: '旧価格は0以上の数値でなければなりません',
      brand: 'ブランド',
      brandCaption: '車のブランド、例：Tesla',
      model: 'モデル',
      modelCaption: '車のモデル、例：Model 3',
      year: '年式',
      yearCaption: '製造年',
      color: '色',
      colorCaption: '外装色、例：黒',
      fuelType: '燃料タイプ',
      fuelTypeCaption: 'ガソリン、ディーゼル、電気、ハイブリッドなど',
      transmission: 'トランスミッション',
      transmissionCaption: 'オートマチックまたはマニュアル',
      seatCount: '座席数',
      seatCountCaption: '車の座席数',
      edit: 'アイテムを編集',
      add: 'アイテムを追加',
    },
    membership: {
      blockTitle: 'メンバーシップ',
      blockText: 'コンテンツへの無料または有料のサブスクリプションを作成',
      blockShortText: 'サブスクリプションを作成',
    },
    pricing: {
      blockTitle: '料金',
      blockText: '価格付きのユニークなメニューを作成',
      blockShortText: 'ユニークなメニューを作成',
      name: '名前',
      nameTooltip: '商品名を入力',
      pricingPlanName: '料金プラン名',
      pricingPlanNameTooltip: '料金プランの名前を入力',
      description: '説明',
      descriptionTooltip: '商品の説明を入力',
      pricingPlanDescriptionTooltip: '料金プランの説明を入力',
      priceValue: '価格の値',
      priceUnit: '価格の単位',
      label: 'ラベル',
      labelTooltip: '料金プランのラベルを入力',
      orderButtonText: '注文ボタンのテキスト',
      orderButtonTextDescriptionTooltip: '料金プランの注文ボタンのテキストを入力',
      orderButtonLink: '注文ボタンのリンク',
      orderButtonLinkDescriptionTooltip: '料金プランの注文ボタンのリンクを入力',
      subtitle: 'サブタイトル',
      subtitleTooltip: '商品のサブタイトルを入力',
      price: '価格',
      priceTooltip: '商品の価格を入力',
      pricingTiers: '料金ティア',
      pricingTiersTooltip: '商品の料金ティアを入力',
      addPriceValue: '価格を追加',
      group: 'グループ',
      groupTooltip: '商品のグループを選択',
      image: '画像',
      imageTooltip: '商品の画像をアップロード',
      unit: '価格の単位',
      unitTooltip: '価格の単位を入力',
      addUnitTitle: '価格の単位',
      addPriceUnitValue: '価格の単位を追加',
      addUnitButtonText: '保存',
      button: 'ボタン',
      buttonTooltip: '商品にボタンを追加',
      buttonAddText: '+ ボタンを追加',
      buttonModalTextField: 'ボタンのテキスト',
      buttonModalTextFieldTooltip: 'ボタンのテキストを入力',
      buttonModalURLField: 'ボタンのURL',
      buttonModalURLFieldTooltip: 'ボタンのURLを入力',
      buttonModalTitle: 'ボタンを追加',
      groups: {
        title: 'グループ',
        subtitle: 'グループの追加、編集、削除',
        groups: 'グループ',
        groupsTooltip: 'グループの追加、編集、削除',
        addNewGroup: '新しいグループを追加',
        newGroup: '新しいグループ',
        titleGroup: 'タイトル',
        titleGroupTooltip: 'グループのタイトルを入力',
        descriptionGroup: '説明',
        descriptionGroupTooltip: 'グループの説明を入力',
      },
    },
    menuBlock: {
      title: 'メニュー',
      subtitle: 'アイテムと価格付きのメニューを作成',
      add: '新しいアイテムを追加',
      edit: 'アイテムを編集',
      name: '名前',
      nameCaption: 'アイテム名を入力',
      description: '説明',
      descriptionCaption: '短い説明を入力',
      ingredients: '材料',
      ingredientsCaption: '材料や成分を記載',
      price: '価格',
      priceCaption: '価格を入力',
      weight: '重量（g）',
      weightCaption: 'グラム単位で重量を入力',
      calories: 'カロリー（kcal）',
      caloriesCaption: 'kcal単位でカロリーを入力',
      label: 'ラベル',
      labelCaption: 'ラベルのテキストを入力',
      labelColor: 'ラベルの色',
      labelColorCaption: 'ラベルの背景色を選択',
      image: '画像',
      imageCaption: 'アイテムの画像をアップロード',
      available: '注文可能',
      visible: 'ページに表示',
    },
    nft: {
      blockTitle: 'NFT',
      blockText: 'OpenSeaプラットフォームまたは個人のウォレットからNFTを表示',
      blockShortText: 'NFTを表示',
    },
    wallet: {
      wallet: 'ウォレット',
      blockTitle: '銀行/暗号ウォレット',
      blockText: 'クレジットカードやBitcoinウォレットを表示して、ユーザーが送金のためにコピーしやすくします',
      blockShortText: 'ウォレットを表示',
      title: 'タイトル',
      titleTooltip: 'ウォレットのタイトル',
      walletNumber: 'ウォレット番号',
      walletNumberTooltip: 'ウォレット番号を貼り付け',
      icon: 'アイコン',
      iconTooltip: 'ウォレットのアイコンを設定',
      card: 'カード',
      bank: '銀行',
      crypto: '暗号資産',
      transfer: '送金',
      paymentLink: '支払いリンク',
      cardNumber: 'カード番号',
      cardNumberTooltip: 'カード番号を貼り付け',
      cardHolder: 'カード名義人',
      cardHolderTooltip: 'カード名義人を入力',
      bankAccountDetails: '銀行口座情報',
      bankAccountDetailsTooltip: '銀行口座情報を入力',
      walletAddress: 'ウォレットアドレス',
      walletAddressTooltip: 'ウォレットアドレスを入力',
      network: 'ネットワーク',
      networkTooltip: 'ネットワークを入力',
      publicKey: '公開鍵',
      publicKeyTooltip: '公開鍵を入力',
      providerName: 'プロバイダー名',
      providerNameTooltip: 'プロバイダー名を入力',
      link: 'リンク',
      linkTooltip: 'リンクを入力',
      serviceName: 'サービス名',
      serviceNameTooltip: 'サービス名を入力',
      email: 'メール',
      emailTooltip: 'メールを入力',
      phone: '電話番号',
      phoneTooltip: '電話番号を入力',
      username: 'ユーザー名',
      usernameTooltip: 'ユーザー名を入力',
      fullName: '氏名',
      fullNameTooltip: '氏名を入力',
      referenceNumber: '参照番号',
      referenceNumberTooltip: '参照番号を入力',
      country: '国',
      countryTooltip: '国を入力',
      transferProvider: '送金プロバイダー',
      transferProviderTooltip: '送金プロバイダーを入力',
      cryptoCurrency: '暗号通貨',
      cryptoCurrencyTooltip: '暗号通貨を入力',
    },
    instagram: {
      blockTitle: 'Instagram',
      blockText: 'お気に入りのInstagramメディアや動画を紹介したり、ショッパブルなInstagramフィードで商品を販売',
      blockShortText: 'お気に入りのInstagramメディア',
      blockConnectTitle: 'Instagramが接続されていません',
      blockConnectText: 'Instagram商品がまだインポートされていないようです。今すぐアカウントを接続してください',
      blockConnectButton: 'Instagramを追加',
      emptyList: 'Instagramメディアはまだありません。',
      addInstagramUsername: 'Instagramのユーザー名を追加',
      username: 'ユーザー名',
      downloadTakes: 'ダウンロードには最大2分かかります',
      displayPost: '投稿をウェブサイトに表示',
      view: '表示',
      redirect: 'URLリダイレクト',
      text: 'テキストとボタン',
      actionType: 'アクションタイプ',
      url: 'URL',
      openInNewTab: '新しいタブで開く',
      delete: '削除',
      cancel: 'キャンセル',
      save: '保存',
      editMedia: 'メディアを編集',
      title: 'タイトル',
      automation: '自動化',
      automationText: 'オートパイロット機能でアカウントを自動化',
      autopilot: 'オートパイロット',
      autopilotTooltip: 'サンプルキャプション付きで投稿をアップロードすると、商品タグ/リンクが自動的に生成されます',
      switchTitle: 'タイトル、価格、リンクを自動検出',
      sampleCaption: 'サンプルキャプション：#49.99 #NiceDress https://google.com',
      integrations: '連携',
      integrationsText: 'Instagramをウェブサイトに追加',
      connectInstagram: 'Instagramを接続',
      connectInstagramText: 'Instagramアカウントを接続して、選んだ投稿やReelを表示しましょう。',
      selectAccount: 'アカウントを選択',
      connectNewInstagram: '新しいInstagramアカウントを接続',
      continue: '続ける',
      disconnectInstagram: 'Instagramを接続解除',
      addTag: 'タグを追加',
      tagClickHint: '画像をクリックしてタグを配置',
      tagPositionSet: '位置を設定しました。下に詳細を入力してください。',
      tagTypeLink: 'リンク',
      tagTypeProduct: '商品',
      tagLabel: 'ラベル',
      tagSelectProduct: '商品を選択',
    },
    tiktok: {
      blockTitle: 'TikTok',
      blockText: 'お気に入りのTikTok動画を紹介したり、ショッパブルなTikTokフィードで商品を販売',
      blockShortText: 'お気に入りのTikTok動画',
      addTikTok: 'TikTokアカウントを追加',
      individualVideo: '個別の動画',
      videoCollection: '動画コレクション',
      add: '追加',
      blockConnectTitle: 'TikTokが接続されていません',
      blockConnectText: 'TikTok商品がまだインポートされていないようです。今すぐアカウントを接続してください',
      blockConnectButton: 'TikTokを接続',
      enterUsername: 'ユーザー名を入力',
      enterVideo: 'TikTok動画のURLを入力',
      emptyList: 'TikTokメディアはまだありません。',
      editMedia: 'メディアを編集',
      addTikTokVideo: 'TikTok動画を追加',
      displayPost: '投稿をウェブサイトに表示',
      delete: '削除',
      cancel: 'キャンセル',
      save: '保存',
      integrations: '連携',
      integrationsText: 'TikTokをウェブサイトに追加',
      connectTikTok: 'TikTokを接続',
      disconnectTikTok: 'TikTokを接続解除',
      individualText: 'このタイプのブロック（「個別」）にはTikTokアカウントを接続できません。',
      individualText2: '代わりに単一のTikTok動画を追加してください。',
    },
    youtube: {
      blockTitle: 'YouTube',
      blockText: 'ページにYouTube動画や配信を紹介。YouTube動画に商品をタグ付け',
      blockShortText: 'YouTube動画を紹介',
      enterYouTubeLink: 'YouTube URLを入力',
      enterYouTubeLinkTooltip: 'YouTube URLを貼り付け',
    },
    overview: {
      blockTitle: '概要',
      blockText: 'ページに動画や配信を紹介。動画に商品をタグ付け',
      blockShortText: '動画に商品をタグ付け',
    },
    video: {
      blockTitle: '動画',
      blockText: 'ページに動画や配信を紹介',
      blockShortText: '動画を紹介',
    },
    short: {
      blockTitle: 'ショート / リール',
      blockText: '縦型のショート動画を追加 — Shorts、Reels、TikTok',
      blockShortText: '縦型動画',
    },
    twitter: {
      blockTitle: 'X (Twitter)',
      blockText: 'ツイートをUniLinkページに表示して、エンゲージメントを高めます',
      blockShortText: 'ツイートを表示',
      twitterURL: 'Twitter URL',
      twitterURLTooltip: 'Twitterから埋め込みコードを生成するためのURLを追加',
      enterTwitterURL: 'Twitter URLを入力',
    },
    music: {
      templates: {
        nowPlaying: 'プレーヤー',
        nowPlayingCaption: 'ジャケット、プログレスバー、操作ボタンを備えたダークなカード。ブロックのトラックを送れます',
        compact: 'コンパクトプレーヤー',
        compactCaption: '高さ三分の一の同じプレーヤー。主役ではない曲のために',
        tracklist: 'トラックリスト',
        tracklistCaption: '長さと再生ボタンを備えた番号付きの行。レコードの裏面のように',
        queue: '再生キュー',
        queueCaption: '再生中の曲と次の曲を、キュー付きの小さなアルバムプレーヤーで',
        featured: '注目のトラック',
        featuredCaption: 'ジャケットを大きく、その上にタイトル、再生ボタンひとつ',
        waveform: '波形',
        waveformCaption: '再生とともに満ちていく波形として一つの録音を。デモやラフミックスに',
        mix: 'DJミックス',
        mixCaption: '全面写真、セットの長さ、ボタンの奥にトラックリスト',
        release: 'リリースとリンク',
        releaseCaption: 'ジャケット、タイトル、配信サービスごとに一行 — スマートリンクのカード',
        streaming: '配信リンク',
        streamingCaption: 'ジャケットなしでサービスだけ。訪問者を使い慣れたプラットフォームへ',
        presave: '事前保存',
        presaveCaption: 'まだ出ていない作品と、リリース日にライブラリへ入れるボタン',
        shelf: 'アルバム棚',
        shelfCaption: '各リリースをジャケットで横スクロール。タップでそのリンクが開きます',
        playlistCard: 'プレイリストカード',
        playlistCardCaption: 'プレイリストの中身のモザイク、長さ、そして聴くためのボタンひとつ',
        record: 'レコードを買う',
        recordCaption: 'スリーブ、価格、そして二つのボタン — 買うか、まず聴くか',
        classic: 'タブ',
        classicCaption: '元のブロック：トラック・プレイリスト・リリースをタブで、いつものカードとともに',
        showcase: 'ショーケース',
        showcaseCaption: '編集的なビュー — 大きなリリースカードと、その下に残りを並べたレール',
      },
      blockTitle: '音楽',
      blockText: 'Spotify、SoundCloudの曲やプレイリストを埋め込むか、自分の音声ファイルをアップロード',
      blockShortText: '音楽を追加',
      brand: 'ブランド',
      brandTooltip: '音楽を追加するタイプを選択',
      url: 'URL',
      embed: '埋め込みコード',
      custom: 'カスタム',
      musicUrl: '音楽のURL',
      musicUrlTooltip: '音楽のURLを入力',
      embedCodeTitle: '埋め込みコード',
      embedCodeTooltip: '選択した音楽プラットフォームから曲の埋め込みコードを貼り付け',
      audioFile: '音声ファイル',
      uploadAudios: 'ここには音声のみアップロードできます',
      title: 'タイトル',
      titleTooltip: '音楽のタイトルを入力',
      artist: 'アーティスト',
      artistTooltip: '音楽のアーティストを入力',
      audioFileTitle: '音声ファイル',
      audioFileTooltip: '音声ファイルの名前',
      coverImage: 'カバー画像',
      coverImageTooltip: '音楽の画像をアップロード',
    },
    twitch: {
      blockTitle: 'Twitch',
      blockText: 'ページにTwitch動画や配信を埋め込み',
      blockShortText: 'Twitch動画を埋め込み',
      twitchURL: 'Twitch URL',
      twitchURLTooltip: 'チャンネルのURLまたはチャンネル名を貼り付け',
      twitchTV: 'twitch.tv/...',
      displayTwitch: 'Twitchチャンネルを表示',
      displayChat: 'Twitchチャンネルとチャットの両方を表示',
    },
    splash: {
      blockTitle: 'ポップアップ',
      blockText: 'テキストとボタン付きの全画面バナーがサイト読み込み前に表示され、商品やイベントを宣伝できます',
      blockShortText: '全画面バナー',
    },
    pageList: {
      templates: {
        classic: 'シンプルなリスト',
        classicCaption: '元のブロック。1行に1ページと矢印。5ページまでに向きます',
        described: '説明付きリスト',
        describedCaption: '番号付きの行。各ページに行き先を説明する一文が付きます',
        icons: 'アイコングリッド',
        iconsCaption: '名前の上にアイコンを置いた2列。6ページ以上に向きます',
        covers: 'カバー付きカード',
        coversCaption: '各ページの横に画像。名前だけでなく見せたい区画に',
        groups: 'グループ分け',
        groupsCaption: 'サイトマップ。設定したグループ名の下にページを並べます',
        headline: '大きな行',
        headlineCaption: '塗りのパネルに大きな行。主要な4〜5件の行き先に',
        tiles: '写真タイル',
        tilesCaption: '1行2枚の写真タイル。最後の1枚は全幅になります',
        tags: 'タグ',
        tagsCaption: '各ページをピル表示。10ページ以上のときのコンパクトな選択',
        prevNext: '前と次',
        prevNextCaption: 'このページの前後2ページ。長いページの末尾に',
      },
    },
    promo: {
      blockTitle: 'プロモバー',
      blockText: 'プロモーションを表示できるハイライト',
      blockShortText: 'プロモーションを強調',
    },
    welcome: {
      blockTitle: 'ウェルカムメッセージ',
      blockText: '訪問者にチャットを始めてもらうウェルカムメッセージを書きましょう。ページ下部にポップアップして訪問者を歓迎し、サポートを提供します',
      blockShortText: 'ウェルカムメッセージを書く',
    },
    review: {
      blockTitle: 'レビュー',
      blockText: 'レビューは、顧客が商品についてより詳しく知り、自分に合った商品かどうかを判断するのに役立ちます',
      blockShortText: 'レビューは顧客に役立つ',
      name: '名前',
      nameTooltip: 'レビュアーの名前を入力',
      comment: 'コメント',
      commentTooltip: 'レビュアーのコメントを入力',
      date: '日付',
      dateTooltip: 'レビュアーの日付を入力',
      rate: '評価',
      rateTooltip: 'レビューの評価を設定',
      image: '画像',
      imageTooltip: 'レビュアーの画像をアップロード',
    },
    coupon: {
      blockTitle: 'クーポン',
      blockText: 'オンラインクーポンとは、ウェブサイトで利用できる割引コードまたは番号を指します',
      blockShortText: 'オンラインクーポン',
    },
    timer: {
      blockTitle: 'Countdown',
      blockText: 'カウントダウンタイマーは、ページ上の仮想時計で、特定の数値や日付からカウントダウンし、イベントやオファーの開始または終了を示します',
      blockShortText: 'カウントダウンタイマー',
    },
    outfit: {
      blockTitle: 'コーディネート',
      blockText: '独自の商品リストを作成',
      blockShortText: '商品リストを作成',
    },
    spacer: {
      blockTitle: 'スペーサー',
      blockText: 'ページに縦方向の空白スペースを追加',
      blockShortText: '空白を追加',
    },
    html: {
      blockTitle: 'Embed',
      blockText: '独自のHTMLコードをUniLinkページに貼り付けられます。HTMLはウェブページ作成の標準マークアップ言語です。iframe、セクション、段落、リンクに対応しています。',
      blockShortText: '独自のHTMLを貼り付け',
      markupCode: 'マークアップコード',
      markupCodeTooltip: 'HTMLのマークアップコードを貼り付け',
      strippedWarning: '表示時にセキュリティのため削除されました：',
    },
    unlock: {
      blockTitle: 'ロック解除',
      blockText: 'ロック解除コンテンツをUniLinkページに追加できます。',
      blockShortText: 'ロック解除ファイルを貼り付け',
    },
    file: {
      blockTitle: 'ファイル',
      blockText: 'このブロックでは、ドキュメント、画像、音声などのファイルをアップロードして共有できます。訪問者はページから直接簡単に表示またはダウンロードできます。',
      blockShortText: 'ファイルをアップロードして共有。',
      addNewItem: '新しいファイルを追加',
      editFile: 'ファイルを編集',
      fileName: 'ファイル名を入力',
      fileDescription: 'ファイルの説明（任意）',
      coverImage: 'カバー画像（任意）',
      templates: {
        classic: 'クラシック一覧',
        classicCaption: '元のブロック — ファイルごとにアイコン・サイズ・公開バッジを並べた行',
        list: 'ファイル一覧',
        listCaption: '形式をプレートで示し、右側にダウンロードボタンを置いた行',
        single: '単一ダウンロード',
        singleCaption: 'カード1枚と大きなボタン1つ。ファイルが1つだけのブロック向け',
        cover: '表紙プレビュー',
        coverCaption: '最初のページを画像として見せ、その下に説明とボタン',
        folders: 'フォルダ',
        foldersCaption: '種類ごとにまとめたファイル。各フォルダに件数と容量を表示',
        formats: 'フォーマット',
        formatsCaption: '同じ素材のすべての形式を、タップできるチップで並べる',
        versions: 'バージョン',
        versionsCaption: '最新版を上部に枠付きで、旧版は下からも取得可能',
        gate: 'メールと引き換え',
        gateCaption: '訪問者がメールアドレスを入力するとダウンロードが開きます',
        transfer: '大容量の受け渡し',
        transferCaption: '重いファイル向けのダークカード。容量の注意書き付き',
      },
    },
    stat: {
      templates: {
        grid: '4つの数字',
        gridCaption: '1行に2つ、それぞれ何を数えたかの説明つき',
        hero: '大きな数字ひとつ',
        heroCaption: 'ブロック全体を占める1つの数字。ページの文字色で表示',
        row: '横並び3つ',
        rowCaption: '短い数字を3つ1行に、細い区切り線で分割',
        change: '変化つき',
        changeCaption: '数字とその変化。各統計の追加フィールドから',
        bars: '棒グラフ',
        barsCaption: '統計ごとに1本の柱。最も高い柱はアクセントカラー',
        progress: '進捗バー',
        progressCaption: '内訳を塗りバーで表示：名前、数字、バー',
        photo: '写真つき',
        photoCaption: 'ブロック見出しの画像の下に数字を並べて表示',
        live: 'ライブカウンター',
        liveCaption: '数字ひとつと、その横で点滅するドット',
        source: '出典つき',
        sourceCaption: '2つの数字と、その出どころを示す一文',
        trend: 'トレンド',
        trendCaption: '統計を時系列の折れ線に。最新の数字を上に表示',
        share: '構成比',
        shareCaption: '全体の内訳をリングと凡例で表示',
        ranked: 'ランキング',
        rankedCaption: '番号つきのトップ5、各行の下にバー',
        feed: 'フィード',
        feedCaption: '元のブロック——折り返して並ぶ統計タイル',
        slider: 'スライダー',
        sliderCaption: '同じタイルを、訪問者がスワイプできるレールに配置',
      },
      blockTitle: '統計',
      blockText:
        'このブロックでは、表示回数、訪問者数、エンゲージメントなど、ページに関する主要なインサイトを表示できます。オーディエンスを把握し、ページのパフォーマンスを理解するのに役立ちます。',
      blockShortText: 'ページに統計を追加。',
      addNewItem: '新しい統計を追加',
      editItem: '統計を編集',
      statName: '統計の名前を入力',
      statValue: '統計の値を入力',
      statDescription: '統計の説明を入力',
      statProgress: '進捗バー（％、任意）',
      statLabel: '変化または出典',
      statLabelTooltip: '「変化つき」「トレンド」で数字の横に出るラベル（「+18%」「−1.1」）、または「出典つき」で数字の下に出る一文',
      matchScreenshot: 'スクリーンショットに合わせる',
      matchScreenshotRunning: 'デザインを読み取り中…',
      matchScreenshotSkipped: 'タイルの色とフォントはそのままです',
      compose: 'デザインする',
      composePlaceholder: '見た目を説明 —「明るくモダン」「もっと大胆に」',
      composeHint: '色はパレットから。文字のコントラストは自動で確保されます',
      composeDone: 'デザインを更新しました',
      review: '確認',
      reviewClean: '確認しました — 修正は不要です',
      reviewFixed: '確認して修正しました',
      statItemFields: '表示するフィールドを選択。',
      columns: '列数',
      subtitleColumns: '1行に表示する統計の数',
      feed: 'フィード',
      slider: 'スライダー',
      titleSize: 'タイトルサイズ',
      subtitleTitleSize: 'タイトルサイズを変更できます',
    },
    listing: {
      blockTitle: 'リスティング',
      blockText: '物件やアイテムのリスティングを画像、詳細、価格付きで表示。',
      blockShortText: 'ページにリスティングを追加。',
    },
    rental: {
      blockTitle: 'レンタル',
      blockText: 'レンタル物件やアイテムを、空き状況と期間ごとの価格付きで掲載。',
      blockShortText: 'ページにレンタルを追加。',
    },
    'single-product': {
      blockTitle: '単一商品',
      blockText: '画像、説明、購入ボタン付きで単一商品を紹介。',
      blockShortText: '商品を紹介。',
    },
    team: {
      blockTitle: 'チーム',
      blockText: 'チームメンバーを写真、名前、役割、SNSリンク付きで紹介。',
      blockShortText: 'チームを紹介。',
    },
    timetable: {
      blockTitle: 'タイムテーブル',
      blockText: 'クラス、イベント、セッションの週間スケジュールを表示。',
      blockShortText: '週間スケジュールを追加。',
    },
  },
  themeTokens: {
    title: 'テーマスタイル',
    subtitle: 'タイポグラフィ、角、間隔',
    typography: 'タイポグラフィ',
    corners: '角',
    density: '密度',
  },
  headingDesign: {
    title: '見出し',
    subtitle: 'ブロックの文字色を継承します',
    hint: '色を変更しなければブロックの文字色に従います。設定するとその部分だけに適用されます。',
    titleColor: 'タイトル',
    descriptionColor: '説明',
    inherited: '継承',
    reset: 'リセット',
    custom: '個別設定',
  },
  advancedDesign: {
    inherited: '継承',
    reset: 'リセット',
    title: '詳細',
    subtitle: '各部分を微調整',
    slot_title: 'タイトル',
    slot_description: '説明',
    slot_label: 'アイブロウラベル',
    fontSize: 'フォントサイズ',
    fontWeight: '太さ',
    textTransform: '大文字小文字',
    textAlign: '配置',
    color: '色',
  },
  layoutPicker: {
    title: 'レイアウト',
    tooltip: 'アイテムの配置方法を選択',
    layout_list: 'リスト',
    layout_grid: 'グリッド',
    layout_cards: 'カード',
  },
  importDesign: {
    title: 'デザインをインポート',
    subtitle: 'スクリーンショットからデザインを再現',
    upload: 'スクリーンショットをアップロード',
    extracting: '分析中…',
    apply: 'ページに適用',
    applying: '適用中…',
    blocksCount: '+{n}個のブロック',
    applied: 'デザインを適用しました — {n}個のブロックを追加',
  },
  storyEditor: {
    back: '戻る',
    general: '一般',
    text: 'テキスト',
    cta: 'CTA',
    media: 'メディア',
    items: '商品',
    addOns: 'アドオン',
    stickers: 'ステッカー',
    layers: 'レイヤー',
    save: '保存',
    delete: '削除',
    addText: 'テキストを追加',
    addCta: 'タップしてね',
    unsavedChanges: '未保存の変更',
    leaveConfirm: '保存せずに終了しますか？変更は失われます。',
    title: 'タイトル',
    enterTitle: 'タイトルを入力',
    duration: '表示時間',
    durationHint: 'ストーリーを表示する長さ',
    kenBurns: 'Ken Burns（ゆっくりズーム）',
    content: '内容',
    enterContent: '内容を入力',
    url: 'URL',
    enterUrl: 'URLを入力',
    fontSize: '文字サイズ',
    chooseFontSize: '文字サイズを選択',
    stylePreset: 'スタイル',
    stylePresetHint: 'プリセットを適用',
    animation: 'アニメーション',
    animationHint: '登場アニメーション',
    color: '色',
    chooseColors: '色を選択',
    filter: 'フィルター',
    cropImage: '画像を切り抜く',
    nothingToAdd: '追加できるものがありません',
    noLayers: 'レイヤーがありません',
    bringForward: '前面へ',
    sendBackward: '背面へ',
    responses: '回答',
    noResponses: 'まだ回答がありません',
  },
  storyGroups: {
    stories: 'ストーリー',
    addStoryGroup: '+ グループを追加',
    newStory: '+ 新しいストーリー',
    previewGroup: 'グループをプレビュー',
    noStoriesYet: 'ストーリーがありません',
    editGroup: 'グループを編集',
    duplicate: '複製',
    delete: '削除',
    preview: 'プレビュー',
    name: '名前',
    content: '内容',
    views: '閲覧数',
    behavior: '表示方法',
    live: '公開',
    cover: 'カバー',
    groupName: '名前',
    enterGroupName: 'グループ名を入力',
    save: '保存',
    behaviour: '表示方法',
    behaviourPermanent: '常時',
    behaviourPermanentHint: 'ウィジェットに常に表示',
    behaviourDaily: '毎日',
    behaviourDailyHint: '1日1回既読になります',
    behaviourOnce: '1回のみ',
    behaviourOnceHint: '視聴後は非表示',
    widgets: 'ウィジェット',
    widgetsHint: 'このグループを表示するウィジェット',
    noWidgets: 'ウィジェットがありません',
  },
};
